import { ColorInput } from "@mantine/core";

export function Icontemp(props: { col?: string }) {
  const { col = "black" } = props || {};
  return <></>;
}
export function IconPeople(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.09688 7.99922C8.13122 7.99922 9.1232 7.58833 9.85459 6.85694C10.586 6.12554 10.9969 5.13356 10.9969 4.09922C10.9969 3.06487 10.586 2.07289 9.85459 1.3415C9.1232 0.61011 8.13122 0.199219 7.09688 0.199219C6.06253 0.199219 5.07055 0.61011 4.33916 1.3415C3.60777 2.07289 3.19688 3.06487 3.19688 4.09922C3.19688 5.13356 3.60777 6.12554 4.33916 6.85694C5.07055 7.58833 6.06253 7.99922 7.09688 7.99922ZM13.9213 14.1732C14.5573 14.4336 15.3661 14.5992 16.3957 14.5992C21.1957 14.5992 21.1957 10.9992 21.1957 10.9992C21.1957 10.522 21.0062 10.0644 20.6689 9.72685C20.3316 9.38932 19.8741 9.19954 19.3969 9.19922H13.8433C14.3149 9.77042 14.5981 10.5012 14.5981 11.2992V11.7264C14.5955 11.8275 14.5887 11.9284 14.5777 12.0288C14.496 12.7784 14.2725 13.5059 13.9213 14.1732ZM19.3969 4.99922C19.3969 5.79487 19.0808 6.55793 18.5182 7.12054C17.9556 7.68315 17.1925 7.99922 16.3969 7.99922C15.6012 7.99922 14.8382 7.68315 14.2756 7.12054C13.7129 6.55793 13.3969 5.79487 13.3969 4.99922C13.3969 4.20357 13.7129 3.44051 14.2756 2.8779C14.8382 2.31529 15.6012 1.99922 16.3969 1.99922C17.1925 1.99922 17.9556 2.31529 18.5182 2.8779C19.0808 3.44051 19.3969 4.20357 19.3969 4.99922ZM0.796875 11.5992C0.796875 10.9627 1.04973 10.3523 1.49982 9.90216C1.94991 9.45208 2.56036 9.19922 3.19688 9.19922H10.9969C11.6334 9.19922 12.2438 9.45208 12.6939 9.90216C13.144 10.3523 13.3969 10.9627 13.3969 11.5992C13.3969 11.5992 13.3969 16.3992 7.09688 16.3992C0.796875 16.3992 0.796875 11.5992 0.796875 11.5992Z"
        fill="#666666"
      />
    </svg>
  );
}
export function IconVideoSchedule(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V5.2L21.213 1.55C21.288 1.49746 21.3759 1.4665 21.4672 1.4605C21.5586 1.4545 21.6498 1.4737 21.731 1.51599C21.8122 1.55829 21.8802 1.62206 21.9276 1.70035C21.9751 1.77865 22.0001 1.86846 22 1.96V14.04C22.0001 14.1315 21.9751 14.2214 21.9276 14.2996C21.8802 14.3779 21.8122 14.4417 21.731 14.484C21.6498 14.5263 21.5586 14.5455 21.4672 14.5395C21.3759 14.5335 21.288 14.5025 21.213 14.45L16 10.8V15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16H1C0.734784 16 0.48043 15.8946 0.292893 15.7071C0.105357 15.5196 0 15.2652 0 15V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H15ZM14 2H2V14H14V2ZM6.4 4.829C6.47611 4.82879 6.55069 4.8503 6.615 4.891L10.97 7.662C11.0268 7.69812 11.0735 7.74799 11.1059 7.80699C11.1383 7.86598 11.1553 7.9322 11.1553 7.9995C11.1553 8.0668 11.1383 8.13302 11.1059 8.19201C11.0735 8.25101 11.0268 8.30088 10.97 8.337L6.615 11.11C6.55434 11.1487 6.48438 11.1703 6.41248 11.1725C6.34059 11.1748 6.26941 11.1576 6.20646 11.1228C6.14351 11.088 6.0911 11.0368 6.05477 10.9747C6.01844 10.9127 5.99951 10.8419 6 10.77V5.23C6 5.12391 6.04214 5.02217 6.11716 4.94716C6.19217 4.87214 6.29391 4.829 6.4 4.829ZM20 4.84L16 7.64V8.358L20 11.158V4.84Z"
        fill="#666666"
      />
    </svg>
  );
}
export function IconScheduleMeet(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14C12.1978 14 12.3911 13.9414 12.5556 13.8315C12.72 13.7216 12.8482 13.5654 12.9239 13.3827C12.9996 13.2 13.0194 12.9989 12.9808 12.8049C12.9422 12.6109 12.847 12.4327 12.7071 12.2929C12.5673 12.153 12.3891 12.0578 12.1951 12.0192C12.0011 11.9806 11.8 12.0004 11.6173 12.0761C11.4346 12.1518 11.2784 12.28 11.1685 12.4444C11.0586 12.6089 11 12.8022 11 13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14ZM17 14C17.1978 14 17.3911 13.9414 17.5556 13.8315C17.72 13.7216 17.8482 13.5654 17.9239 13.3827C17.9996 13.2 18.0194 12.9989 17.9808 12.8049C17.9422 12.6109 17.847 12.4327 17.7071 12.2929C17.5673 12.153 17.3891 12.0578 17.1951 12.0192C17.0011 11.9806 16.8 12.0004 16.6173 12.0761C16.4346 12.1518 16.2784 12.28 16.1685 12.4444C16.0586 12.6089 16 12.8022 16 13C16 13.2652 16.1054 13.5196 16.2929 13.7071C16.4804 13.8946 16.7348 14 17 14ZM12 18C12.1978 18 12.3911 17.9414 12.5556 17.8315C12.72 17.7216 12.8482 17.5654 12.9239 17.3827C12.9996 17.2 13.0194 16.9989 12.9808 16.8049C12.9422 16.6109 12.847 16.4327 12.7071 16.2929C12.5673 16.153 12.3891 16.0578 12.1951 16.0192C12.0011 15.9806 11.8 16.0004 11.6173 16.0761C11.4346 16.1518 11.2784 16.28 11.1685 16.4444C11.0586 16.6089 11 16.8022 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18ZM17 18C17.1978 18 17.3911 17.9414 17.5556 17.8315C17.72 17.7216 17.8482 17.5654 17.9239 17.3827C17.9996 17.2 18.0194 16.9989 17.9808 16.8049C17.9422 16.6109 17.847 16.4327 17.7071 16.2929C17.5673 16.153 17.3891 16.0578 17.1951 16.0192C17.0011 15.9806 16.8 16.0004 16.6173 16.0761C16.4346 16.1518 16.2784 16.28 16.1685 16.4444C16.0586 16.6089 16 16.8022 16 17C16 17.2652 16.1054 17.5196 16.2929 17.7071C16.4804 17.8946 16.7348 18 17 18ZM7 14C7.19778 14 7.39112 13.9414 7.55557 13.8315C7.72002 13.7216 7.84819 13.5654 7.92388 13.3827C7.99957 13.2 8.01937 12.9989 7.98079 12.8049C7.9422 12.6109 7.84696 12.4327 7.70711 12.2929C7.56725 12.153 7.38907 12.0578 7.19509 12.0192C7.00111 11.9806 6.80004 12.0004 6.61732 12.0761C6.43459 12.1518 6.27841 12.28 6.16853 12.4444C6.05865 12.6089 6 12.8022 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14ZM19 4H18V3C18 2.73478 17.8946 2.48043 17.7071 2.29289C17.5196 2.10536 17.2652 2 17 2C16.7348 2 16.4804 2.10536 16.2929 2.29289C16.1054 2.48043 16 2.73478 16 3V4H8V3C8 2.73478 7.89464 2.48043 7.70711 2.29289C7.51957 2.10536 7.26522 2 7 2C6.73478 2 6.48043 2.10536 6.29289 2.29289C6.10536 2.48043 6 2.73478 6 3V4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V10H20V19ZM20 8H4V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V8ZM7 18C7.19778 18 7.39112 17.9414 7.55557 17.8315C7.72002 17.7216 7.84819 17.5654 7.92388 17.3827C7.99957 17.2 8.01937 16.9989 7.98079 16.8049C7.9422 16.6109 7.84696 16.4327 7.70711 16.2929C7.56725 16.153 7.38907 16.0578 7.19509 16.0192C7.00111 15.9806 6.80004 16.0004 6.61732 16.0761C6.43459 16.1518 6.27841 16.28 6.16853 16.4444C6.05865 16.6089 6 16.8022 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18Z"
        fill="#666666"
      />
    </svg>
  );
}
export function IconRecordStop(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66667 4H17.3333C18.8 4 20 5.2 20 6.66667V17.3333C20 18.8 18.8 20 17.3333 20H6.66667C5.2 20 4 18.8 4 17.3333V6.66667C4 5.2 5.2 4 6.66667 4Z"
        fill="#FF3636"
      />
    </svg>
  );
}
export function IconRecord(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15C8.61667 15 7.43733 14.5123 6.462 13.537C5.48667 12.5617 4.99933 11.3827 5 10C5 8.61667 5.48767 7.43733 6.463 6.462C7.43833 5.48667 8.61733 4.99933 10 5C11.3833 5 12.5627 5.48767 13.538 6.463C14.5133 7.43833 15.0007 8.61733 15 10C15 11.3833 14.5123 12.5627 13.537 13.538C12.5617 14.5133 11.3827 15.0007 10 15ZM18 10C18 9.3 17.9167 8.625 17.75 7.975C17.5833 7.325 17.3417 6.70833 17.025 6.125C16.8917 5.875 16.8373 5.60833 16.862 5.325C16.8867 5.04167 17.016 4.81667 17.25 4.65C17.4833 4.48333 17.7417 4.43333 18.025 4.5C18.3083 4.56667 18.5167 4.71667 18.65 4.95C19.0833 5.7 19.4167 6.496 19.65 7.338C19.8833 8.18 20 9.06733 20 10C20 10.9333 19.879 11.825 19.637 12.675C19.395 13.525 19.0577 14.325 18.625 15.075C18.4917 15.3083 18.2873 15.4543 18.012 15.513C17.7367 15.5717 17.4827 15.5173 17.25 15.35C17.0167 15.1833 16.8833 14.9583 16.85 14.675C16.8167 14.3917 16.8667 14.125 17 13.875C17.3167 13.2917 17.5627 12.679 17.738 12.037C17.9133 11.395 18.0007 10.716 18 10ZM10 2C9.28333 2 8.604 2.08767 7.962 2.263C7.32 2.43833 6.708 2.684 6.126 3C5.876 3.13333 5.60933 3.18333 5.326 3.15C5.04267 3.11667 4.81767 2.98333 4.651 2.75C4.48433 2.51667 4.43 2.26233 4.488 1.987C4.546 1.71167 4.692 1.50767 4.926 1.375C5.676 0.941667 6.476 0.604333 7.326 0.363C8.176 0.121667 9.06733 0.000666667 10 0C10.9333 0 11.825 0.121 12.675 0.363C13.525 0.605 14.325 0.942333 15.075 1.375C15.325 1.50833 15.4793 1.71267 15.538 1.988C15.5967 2.26333 15.5423 2.51733 15.375 2.75C15.2083 2.98333 14.9833 3.11667 14.7 3.15C14.4167 3.18333 14.15 3.13333 13.9 3C13.3167 2.68333 12.7 2.43733 12.05 2.262C11.4 2.08667 10.7167 1.99933 10 2ZM2 10C2 10.7167 2.08767 11.396 2.263 12.038C2.43833 12.68 2.684 13.292 3 13.874C3.13333 14.124 3.18333 14.3907 3.15 14.674C3.11667 14.9573 2.98333 15.1823 2.75 15.349C2.51667 15.5157 2.26233 15.57 1.987 15.512C1.71167 15.454 1.50767 15.308 1.375 15.074C0.941667 14.324 0.604333 13.524 0.363 12.674C0.121667 11.824 0.000666667 10.9327 0 10C0 9.06667 0.116667 8.179 0.35 7.337C0.583333 6.495 0.916666 5.69933 1.35 4.95C1.48333 4.71667 1.69167 4.56667 1.975 4.5C2.25833 4.43333 2.51667 4.48333 2.75 4.65C2.98333 4.81667 3.11267 5.04167 3.138 5.325C3.16333 5.60833 3.109 5.875 2.975 6.125C2.65833 6.70833 2.41667 7.325 2.25 7.975C2.08333 8.625 2 9.3 2 10ZM10 18C10.7 18 11.375 17.9167 12.025 17.75C12.675 17.5833 13.2917 17.3417 13.875 17.025C14.125 16.8917 14.3877 16.8417 14.663 16.875C14.9383 16.9083 15.159 17.0417 15.325 17.275C15.4917 17.5083 15.546 17.7627 15.488 18.038C15.43 18.3133 15.284 18.5173 15.05 18.65C14.3 19.0833 13.504 19.4167 12.662 19.65C11.82 19.8833 10.9327 20 10 20C9.06667 20 8.179 19.8833 7.337 19.65C6.495 19.4167 5.69933 19.0833 4.95 18.65C4.71667 18.5167 4.56667 18.3083 4.5 18.025C4.43333 17.7417 4.48333 17.4833 4.65 17.25C4.81667 17.0167 5.04167 16.8877 5.325 16.863C5.60833 16.8383 5.875 16.8923 6.125 17.025C6.70833 17.3417 7.325 17.5833 7.975 17.75C8.625 17.9167 9.3 18 10 18Z"
        fill="black"
      />
    </svg>
  );
}
export function IconAddVideoCall(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.77344 17.4531H6.16797V14.7344C6.16797 14.6312 6.08711 14.5469 5.98828 14.5469H4.91016C4.81133 14.5469 4.73047 14.6312 4.73047 14.7344V17.4531H2.125C2.02617 17.4531 1.94531 17.5375 1.94531 17.6406V18.7656C1.94531 18.8688 2.02617 18.9531 2.125 18.9531H4.73047V21.6719C4.73047 21.775 4.81133 21.8594 4.91016 21.8594H5.98828C6.08711 21.8594 6.16797 21.775 6.16797 21.6719V18.9531H8.77344C8.87227 18.9531 8.95312 18.8688 8.95312 18.7656V17.6406C8.95312 17.5375 8.87227 17.4531 8.77344 17.4531Z"
        fill="white"
      />
      <path
        d="M20.9922 7.56953L18.1172 9.29688V5.73438C18.1172 4.90703 17.4726 4.23438 16.6797 4.23438H3.38281C2.58994 4.23438 1.94531 4.90703 1.94531 5.73438V13.9844H3.5625V5.92188H16.5V19.0469H10.5703V20.7344H16.6797C17.4726 20.7344 18.1172 20.0617 18.1172 19.2344V15.6719L20.9922 17.3992C21.4706 17.6875 22.0703 17.3266 22.0703 16.7523V8.21875C22.0703 7.64219 21.4706 7.28125 20.9922 7.56953ZM20.4531 15.1328L18.1172 13.7313V11.2398L20.4531 9.83594V15.1328Z"
        fill="white"
      />
      <path
        d="M7.69531 8.92188C7.79414 8.92188 7.875 8.8375 7.875 8.73438V7.60938C7.875 7.50625 7.79414 7.42188 7.69531 7.42188H5.17969C5.08086 7.42188 5 7.50625 5 7.60938V8.73438C5 8.8375 5.08086 8.92188 5.17969 8.92188H7.69531Z"
        fill="white"
      />
    </svg>
  );
}
export function IconUploadResources(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.175 18H13C12.7167 18 12.4793 17.904 12.288 17.712C12.0967 17.52 12.0007 17.2827 12 17C12 16.7167 12.096 16.4793 12.288 16.288C12.48 16.0967 12.7173 16.0007 13 16H18.175L17.275 15.1C17.0917 14.9167 17 14.6877 17 14.413C17 14.1383 17.1 13.9007 17.3 13.7C17.4833 13.5167 17.7167 13.425 18 13.425C18.2833 13.425 18.5167 13.5167 18.7 13.7L21.3 16.3C21.5 16.5 21.6 16.7333 21.6 17C21.6 17.2667 21.5 17.5 21.3 17.7L18.7 20.3C18.5 20.5 18.2667 20.596 18 20.588C17.7333 20.58 17.5 20.4757 17.3 20.275C17.1167 20.075 17.0207 19.8417 17.012 19.575C17.0033 19.3083 17.0993 19.075 17.3 18.875L18.175 18ZM6 21C5.45 21 4.97933 20.8043 4.588 20.413C4.19667 20.0217 4.00067 19.5507 4 19V5C4 4.45 4.196 3.97933 4.588 3.588C4.98 3.19667 5.45067 3.00067 6 3H9.175C9.35833 2.41667 9.71667 1.93767 10.25 1.563C10.7833 1.18833 11.3667 1.00067 12 1C12.6667 1 13.2627 1.18767 13.788 1.563C14.3133 1.93833 14.6673 2.41733 14.85 3H18C18.55 3 19.021 3.196 19.413 3.588C19.805 3.98 20.0007 4.45067 20 5V10C20 10.2833 19.904 10.521 19.712 10.713C19.52 10.905 19.2827 11.0007 19 11C18.7167 11 18.4793 10.904 18.288 10.712C18.0967 10.52 18.0007 10.2827 18 10V5H17V7C17 7.28333 16.904 7.521 16.712 7.713C16.52 7.905 16.2827 8.00067 16 8H8C7.71667 8 7.47933 7.904 7.288 7.712C7.09667 7.52 7.00067 7.28267 7 7V5H6V19H9C9.28333 19 9.521 19.096 9.713 19.288C9.905 19.48 10.0007 19.7173 10 20C10 20.2833 9.904 20.521 9.712 20.713C9.52 20.905 9.28267 21.0007 9 21H6ZM12 5C12.2833 5 12.521 4.904 12.713 4.712C12.905 4.52 13.0007 4.28267 13 4C13 3.71667 12.904 3.47933 12.712 3.288C12.52 3.09667 12.2827 3.00067 12 3C11.7167 3 11.4793 3.096 11.288 3.288C11.0967 3.48 11.0007 3.71733 11 4C11 4.28333 11.096 4.521 11.288 4.713C11.48 4.905 11.7173 5.00067 12 5Z"
        fill="black"
      />
    </svg>
  );
}

export function IconTestResources(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 20.75V19.5H15V20.75H12.5ZM5 22V17H20V22H18.75V18.25H11.25V22H10V18.25H6.25V22H5ZM12.5 13.25V12H17.5V13.25H12.5ZM17.5 4.5V5.75H12.5V4.5H17.5ZM5 15.75V9.5H20V15.75H5ZM11.25 10.75V14.5H18.75V10.75H11.25ZM6.25 10.75V14.5H10V10.75H6.25ZM5 2H20V8.25H5V2ZM10 7V3.25H6.25V7H10ZM18.75 7V3.25H11.25V7H18.75Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function IconRank(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 2.034C10.942 2.135 10.877 2.251 10.801 2.388L10.703 2.564L10.68 2.604C10.602 2.748 10.472 2.986 10.255 3.151C10.034 3.319 9.767 3.377 9.612 3.411L9.568 3.42L9.378 3.463C9.202 3.503 9.059 3.535 8.938 3.566C9.017 3.663 9.12 3.785 9.254 3.942L9.384 4.094L9.414 4.128C9.522 4.253 9.696 4.453 9.777 4.713C9.857 4.969 9.829 5.233 9.812 5.399C9.81024 5.41466 9.80857 5.43032 9.807 5.446L9.787 5.649C9.77201 5.80224 9.75801 5.95558 9.745 6.109C9.85 6.063 9.968 6.009 10.109 5.944L10.288 5.862L10.328 5.842C10.472 5.775 10.721 5.657 11 5.657C11.279 5.657 11.528 5.775 11.672 5.843L11.712 5.862L11.891 5.944C12.031 6.009 12.151 6.064 12.255 6.109C12.242 5.95558 12.228 5.80224 12.213 5.649L12.193 5.446C12.1914 5.43032 12.1898 5.41466 12.188 5.399C12.171 5.232 12.143 4.969 12.223 4.713C12.303 4.453 12.478 4.253 12.586 4.128L12.616 4.094L12.746 3.942C12.88 3.785 12.983 3.663 13.062 3.566C12.941 3.536 12.798 3.503 12.622 3.463L12.432 3.42L12.388 3.41C12.233 3.377 11.966 3.319 11.745 3.15C11.528 2.986 11.398 2.748 11.32 2.605L11.297 2.564L11.199 2.388C11.123 2.251 11.059 2.135 11 2.034ZM10.014 0.8C10.186 0.575 10.498 0.25 11 0.25C11.502 0.25 11.814 0.575 11.986 0.8C12.151 1.014 12.316 1.311 12.486 1.616L12.509 1.657L12.607 1.834L12.664 1.934L12.763 1.957L12.953 2L13.001 2.01C13.328 2.085 13.654 2.158 13.904 2.257C14.18 2.366 14.554 2.577 14.699 3.042C14.841 3.497 14.662 3.883 14.506 4.132C14.361 4.362 14.141 4.618 13.916 4.881L13.886 4.916L13.756 5.069L13.674 5.166C13.676 5.202 13.681 5.244 13.686 5.301L13.706 5.504L13.71 5.55C13.744 5.902 13.777 6.242 13.765 6.514C13.753 6.8 13.685 7.232 13.297 7.525C12.897 7.829 12.457 7.763 12.177 7.682C11.919 7.609 11.614 7.468 11.307 7.327L11.264 7.307L11.084 7.224L11 7.185L10.915 7.225L10.736 7.307L10.692 7.327C10.386 7.468 10.082 7.609 9.823 7.682C9.543 7.762 9.103 7.829 8.703 7.525C8.316 7.232 8.247 6.8 8.235 6.515C8.223 6.242 8.255 5.902 8.29 5.55L8.294 5.504L8.314 5.301L8.327 5.166C8.29954 5.13349 8.27188 5.10115 8.244 5.069L8.114 4.916L8.084 4.881C7.859 4.618 7.639 4.361 7.494 4.131C7.338 3.883 7.159 3.497 7.301 3.041C7.445 2.578 7.82 2.366 8.096 2.257C8.346 2.158 8.672 2.085 8.999 2.011L9.046 2.001L9.237 1.957L9.337 1.934L9.393 1.834L9.491 1.657L9.514 1.616C9.684 1.311 9.849 1.014 10.014 0.8ZM9.951 8.25H12.049C12.714 8.25 13.287 8.25 13.746 8.312C14.238 8.378 14.709 8.527 15.091 8.909C15.473 9.291 15.622 9.762 15.688 10.254C15.75 10.713 15.75 11.286 15.75 11.951V14.417C15.914 14.367 16.083 14.335 16.254 14.312C16.713 14.25 17.286 14.25 17.951 14.25H18.049C18.714 14.25 19.287 14.25 19.746 14.312C20.238 14.378 20.709 14.527 21.091 14.909C21.473 15.291 21.622 15.762 21.688 16.254C21.75 16.713 21.75 17.286 21.75 17.951V21C21.75 21.1989 21.671 21.3897 21.5303 21.5303C21.3897 21.671 21.1989 21.75 21 21.75C20.8011 21.75 20.6103 21.671 20.4697 21.5303C20.329 21.3897 20.25 21.1989 20.25 21V18C20.25 17.272 20.248 16.8 20.202 16.454C20.158 16.129 20.087 16.027 20.03 15.97C19.973 15.913 19.871 15.842 19.546 15.798C19.199 15.752 18.728 15.75 18 15.75C17.272 15.75 16.8 15.752 16.454 15.798C16.129 15.842 16.027 15.913 15.97 15.97C15.913 16.027 15.842 16.129 15.798 16.454C15.752 16.801 15.75 17.272 15.75 18V21C15.75 21.1989 15.671 21.3897 15.5303 21.5303C15.3897 21.671 15.1989 21.75 15 21.75C14.8011 21.75 14.6103 21.671 14.4697 21.5303C14.329 21.3897 14.25 21.1989 14.25 21V12C14.25 11.272 14.248 10.8 14.202 10.454C14.158 10.129 14.087 10.027 14.03 9.97C13.973 9.913 13.871 9.842 13.546 9.798C13.199 9.752 12.728 9.75 12 9.75H10C9.272 9.75 8.8 9.752 8.454 9.798C8.129 9.842 8.027 9.913 7.97 9.97C7.913 10.027 7.842 10.129 7.798 10.454C7.752 10.801 7.75 11.272 7.75 12V21C7.75 21.1989 7.67098 21.3897 7.53033 21.5303C7.38968 21.671 7.19891 21.75 7 21.75C6.80109 21.75 6.61032 21.671 6.46967 21.5303C6.32902 21.3897 6.25 21.1989 6.25 21C6.25 20.272 6.248 19.8 6.202 19.454C6.158 19.129 6.087 19.027 6.03 18.97C5.973 18.913 5.871 18.842 5.546 18.798C5.199 18.752 4.728 18.75 4 18.75C3.272 18.75 2.8 18.752 2.454 18.798C2.129 18.842 2.027 18.913 1.97 18.97C1.913 19.027 1.842 19.129 1.798 19.454C1.752 19.801 1.75 20.272 1.75 21C1.75 21.1989 1.67098 21.3897 1.53033 21.5303C1.38968 21.671 1.19891 21.75 1 21.75C0.801088 21.75 0.610322 21.671 0.46967 21.5303C0.329018 21.3897 0.25 21.1989 0.25 21V20.95C0.25 20.286 0.25 19.713 0.312 19.254C0.378 18.762 0.527 18.291 0.909 17.909C1.291 17.527 1.763 17.378 2.254 17.312C2.713 17.25 3.286 17.25 3.951 17.25H4.049C4.714 17.25 5.287 17.25 5.746 17.312C5.917 17.335 6.086 17.368 6.25 17.417V11.951C6.25 11.286 6.25 10.713 6.312 10.254C6.378 9.762 6.527 9.291 6.909 8.909C7.291 8.527 7.763 8.378 8.254 8.312C8.713 8.25 9.286 8.25 9.951 8.25Z"
          fill="black"
        />
      </svg>
    </>
  );
}
export function IconWord(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="61"
          height="61"
          rx="1.5"
          stroke="#4B65F6"
        />
        <path
          d="M40.4359 50.3333H20.5641C18.0434 50.3333 16 48.2899 16 45.7692V15.5641C16 13.0434 18.0434 11 20.5641 11H34.0405L45 22.7153V45.7692C45 48.2899 42.9566 50.3333 40.4359 50.3333Z"
          stroke="#4B65F6"
          stroke-width="2"
        />
        <path
          d="M20.9552 44.0514H18.0862V35.9582H20.9789C21.793 35.9582 22.4938 36.1202 23.0813 36.4442C23.6688 36.7656 24.1206 37.228 24.4367 37.8313C24.7555 38.4346 24.9149 39.1565 24.9149 39.9969C24.9149 40.8399 24.7555 41.5644 24.4367 42.1703C24.1206 42.7763 23.6661 43.2413 23.0734 43.5653C22.4832 43.8894 21.7772 44.0514 20.9552 44.0514ZM19.7973 42.5853H20.8841C21.3899 42.5853 21.8154 42.4957 22.1605 42.3166C22.5083 42.1348 22.7691 41.8542 22.943 41.4748C23.1195 41.0928 23.2077 40.6002 23.2077 39.9969C23.2077 39.3988 23.1195 38.9101 22.943 38.5308C22.7691 38.1514 22.5096 37.8721 22.1645 37.693C21.8193 37.5138 21.3939 37.4243 20.888 37.4243H19.7973V42.5853ZM33.1745 40.0048C33.1745 40.8873 33.0073 41.6382 32.6727 42.2573C32.3407 42.8764 31.8876 43.3493 31.3133 43.676C30.7416 44 30.0987 44.162 29.3848 44.162C28.6656 44.162 28.0201 43.9987 27.4484 43.672C26.8767 43.3453 26.4249 42.8724 26.093 42.2533C25.761 41.6342 25.595 40.8847 25.595 40.0048C25.595 39.1222 25.761 38.3714 26.093 37.7523C26.4249 37.1331 26.8767 36.6616 27.4484 36.3375C28.0201 36.0108 28.6656 35.8475 29.3848 35.8475C30.0987 35.8475 30.7416 36.0108 31.3133 36.3375C31.8876 36.6616 32.3407 37.1331 32.6727 37.7523C33.0073 38.3714 33.1745 39.1222 33.1745 40.0048ZM31.4397 40.0048C31.4397 39.4331 31.3541 38.951 31.1829 38.5584C31.0142 38.1659 30.7758 37.8682 30.4676 37.6653C30.1593 37.4625 29.7984 37.361 29.3848 37.361C28.9712 37.361 28.6102 37.4625 28.302 37.6653C27.9938 37.8682 27.754 38.1659 27.5828 38.5584C27.4142 38.951 27.3299 39.4331 27.3299 40.0048C27.3299 40.5765 27.4142 41.0586 27.5828 41.4511C27.754 41.8437 27.9938 42.1414 28.302 42.3442C28.6102 42.5471 28.9712 42.6485 29.3848 42.6485C29.7984 42.6485 30.1593 42.5471 30.4676 42.3442C30.7758 42.1414 31.0142 41.8437 31.1829 41.4511C31.3541 41.0586 31.4397 40.5765 31.4397 40.0048ZM41.1378 38.7916H39.4069C39.3753 38.5676 39.3108 38.3687 39.2133 38.1949C39.1158 38.0183 38.9907 37.8682 38.8379 37.7444C38.6851 37.6205 38.5086 37.5257 38.3083 37.4598C38.1108 37.394 37.896 37.361 37.6642 37.361C37.2453 37.361 36.8804 37.4651 36.5696 37.6732C36.2587 37.8787 36.0176 38.1791 35.8464 38.5742C35.6751 38.9668 35.5895 39.4436 35.5895 40.0048C35.5895 40.5817 35.6751 41.0665 35.8464 41.459C36.0203 41.8516 36.2626 42.148 36.5735 42.3482C36.8844 42.5484 37.244 42.6485 37.6523 42.6485C37.8816 42.6485 38.0936 42.6182 38.2886 42.5576C38.4862 42.497 38.6614 42.4088 38.8142 42.2929C38.967 42.1743 39.0934 42.0307 39.1935 41.8621C39.2963 41.6935 39.3674 41.5012 39.4069 41.2851L41.1378 41.2931C41.093 41.6645 40.9811 42.0228 40.8019 42.3679C40.6254 42.7104 40.387 43.0173 40.0866 43.2887C39.7889 43.5574 39.4333 43.7708 39.0197 43.9289C38.6087 44.0843 38.1437 44.162 37.6247 44.162C36.9028 44.162 36.2574 43.9987 35.6883 43.672C35.1219 43.3453 34.674 42.8724 34.3447 42.2533C34.018 41.6342 33.8547 40.8847 33.8547 40.0048C33.8547 39.1222 34.0207 38.3714 34.3526 37.7523C34.6846 37.1331 35.1351 36.6616 35.7041 36.3375C36.2732 36.0108 36.9134 35.8475 37.6247 35.8475C38.0936 35.8475 38.5283 35.9134 38.9288 36.0451C39.3319 36.1768 39.6888 36.3691 39.9997 36.622C40.3106 36.8723 40.5635 37.1793 40.7584 37.5428C40.956 37.9064 41.0825 38.3226 41.1378 38.7916ZM42.8721 44.1541C42.6113 44.1541 42.3873 44.0619 42.2003 43.8775C42.0159 43.6905 41.9237 43.4665 41.9237 43.2057C41.9237 42.9475 42.0159 42.7262 42.2003 42.5418C42.3873 42.3574 42.6113 42.2652 42.8721 42.2652C43.125 42.2652 43.3463 42.3574 43.536 42.5418C43.7257 42.7262 43.8205 42.9475 43.8205 43.2057C43.8205 43.3796 43.7757 43.539 43.6862 43.6839C43.5992 43.8261 43.4846 43.9407 43.3424 44.0277C43.2001 44.112 43.0433 44.1541 42.8721 44.1541Z"
          fill="#4B65F6"
        />
        <path
          d="M29.3086 18.7437L24.7194 26.6924H33.8978L29.3086 18.7437ZM30.1035 33.0513V25.8975H28.5137V33.0513H30.1035Z"
          fill="#4B65F6"
        />
      </svg>
    </>
  );
}
export function IconPdf(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="61" height="61" rx="1.5" stroke="#4B65F6" />
      <path
        d="M34.3173 22.2212V23.2212H35.3173H45.75V45.4808C45.75 47.9767 43.7267 50 41.2308 50H21.5192C19.0233 50 17 47.9767 17 45.4808V15.5192C17 13.0233 19.0233 11 21.5192 11H34.3173V22.2212ZM36.3173 12.5328L44.4452 21.2212H36.3173V12.5328Z"
        stroke="#4B65F6"
        stroke-width="2"
      />
      <path
        d="M21.4282 43.8654V35.8374H24.5955C25.2044 35.8374 25.7231 35.9537 26.1517 36.1863C26.5803 36.4162 26.9069 36.7363 27.1317 37.1466C27.359 37.5543 27.4727 38.0247 27.4727 38.5578C27.4727 39.0909 27.3577 39.5613 27.1278 39.969C26.8978 40.3766 26.5646 40.6942 26.1282 40.9215C25.6944 41.1489 25.1691 41.2625 24.5524 41.2625H22.5336V39.9023H24.278C24.6046 39.9023 24.8738 39.8461 25.0855 39.7338C25.2998 39.6188 25.4592 39.4607 25.5637 39.2595C25.6709 39.0556 25.7244 38.8217 25.7244 38.5578C25.7244 38.2912 25.6709 38.0587 25.5637 37.8601C25.4592 37.6588 25.2998 37.5033 25.0855 37.3936C24.8712 37.2812 24.5994 37.225 24.2701 37.225H23.1255V43.8654H21.4282ZM30.9795 43.8654H28.1336V35.8374H31.003C31.8105 35.8374 32.5057 35.9981 33.0884 36.3195C33.6712 36.6384 34.1193 37.097 34.4329 37.6954C34.7491 38.2939 34.9072 39.0099 34.9072 39.8435C34.9072 40.6798 34.7491 41.3984 34.4329 41.9995C34.1193 42.6005 33.6686 43.0618 33.0806 43.3832C32.4952 43.7046 31.7948 43.8654 30.9795 43.8654ZM29.831 42.4111H30.9089C31.4107 42.4111 31.8327 42.3222 32.1751 42.1445C32.52 41.9642 32.7787 41.6859 32.9512 41.3096C33.1263 40.9307 33.2138 40.442 33.2138 39.8435C33.2138 39.2503 33.1263 38.7656 32.9512 38.3892C32.7787 38.0129 32.5213 37.7359 32.179 37.5582C31.8367 37.3805 31.4146 37.2917 30.9129 37.2917H29.831V42.4111ZM35.723 43.8654V35.8374H41.0384V37.2368H37.4203V39.1497H40.6856V40.5491H37.4203V43.8654H35.723Z"
        fill="#4B65F6"
      />
      <path
        d="M30.1914 18.6731L25.6392 26.5577H34.7436L30.1914 18.6731ZM30.9799 32.8654V25.7692H29.4029V32.8654H30.9799Z"
        fill="#4B65F6"
      />
    </svg>
  );
}
export function IconViewFile(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 47 59"
        fill="none"
      >
        <path
          d="M15.034 15.2493H32.3906M15.034 26.8204H32.3906M26.605 38.3914H32.3906M3.46289 55.748V9.46376C3.46289 7.92934 4.07244 6.45776 5.15743 5.37277C6.24243 4.28777 7.71401 3.67822 9.24842 3.67822H38.1761C39.7105 3.67822 41.1821 4.28777 42.2671 5.37277C43.3521 6.45776 43.9616 7.92934 43.9616 9.46376V55.748L35.2833 49.9625L29.4978 55.748L23.7123 49.9625L17.9267 55.748L12.1412 49.9625L3.46289 55.748Z"
          stroke="black"
          stroke-width="5.78553"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
export function IconCoursesUnselect(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 32"
        fill="none"
      >
        <path
          d="M23.5 3.2V16.9348L19.0452 13.6764L18.75 13.4605L18.4548 13.6764L14 16.9348V0.5H15H18H20.6667C22.2509 0.5 23.5 1.72787 23.5 3.2ZM12 0.5H13V17.92V18.9052L13.7952 18.3236L18.75 14.6995L23.5 18.1738V28.8C23.5 30.2721 22.2509 31.5 20.6667 31.5H3.33333C1.74909 31.5 0.5 30.2721 0.5 28.8V3.2C0.5 1.72787 1.74909 0.5 3.33333 0.5H12Z"
          stroke="#909395"
        />
      </svg>
    </>
  );
}
export function IconCourses(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
      >
        <path
          d="M27.5 3.2V16.9348L23.0452 13.6764L22.75 13.4605L22.4548 13.6764L18 16.9348V0.5H19H22H24.6667C26.2509 0.5 27.5 1.72787 27.5 3.2ZM16 0.5H17V17.92V18.9052L17.7952 18.3236L22.75 14.6995L27.5 18.1738V28.8C27.5 30.2721 26.2509 31.5 24.6667 31.5H7.33333C5.74909 31.5 4.5 30.2721 4.5 28.8V3.2C4.5 1.72787 5.74909 0.5 7.33333 0.5H16Z"
          stroke={col}
        />
      </svg>
    </>
  );
}
export function IconDownload(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <g opacity="0.6">
          <path
            d="M10 22H22V20.6667H10V22ZM16 17.744L20.4107 13.3333L19.4667 12.3893L16.6667 15.1747V8.66667H15.3333V15.1733L12.5333 12.3907L11.5893 13.3333L16 17.744ZM16.004 28C14.3453 28 12.7853 27.6853 11.324 27.056C9.86356 26.4258 8.59289 25.5707 7.512 24.4907C6.43111 23.4116 5.57556 22.1422 4.94533 20.6827C4.31511 19.2231 4 17.6636 4 16.004C4 14.3453 4.31467 12.7853 4.944 11.324C5.57422 9.86356 6.42933 8.59289 7.50933 7.512C8.58844 6.43111 9.85778 5.57556 11.3173 4.94533C12.7769 4.31511 14.3364 4 15.996 4C17.6547 4 19.2147 4.31467 20.676 4.944C22.1364 5.57422 23.4071 6.42933 24.488 7.50933C25.5689 8.58844 26.4244 9.85778 27.0547 11.3173C27.6849 12.7769 28 14.3364 28 15.996C28 17.6547 27.6853 19.2147 27.056 20.676C26.4258 22.1364 25.5707 23.4071 24.4907 24.488C23.4116 25.5689 22.1422 26.4244 20.6827 27.0547C19.2231 27.6849 17.6636 28 16.004 28ZM16 26.6667C18.9778 26.6667 21.5 25.6333 23.5667 23.5667C25.6333 21.5 26.6667 18.9778 26.6667 16C26.6667 13.0222 25.6333 10.5 23.5667 8.43333C21.5 6.36667 18.9778 5.33333 16 5.33333C13.0222 5.33333 10.5 6.36667 8.43333 8.43333C6.36667 10.5 5.33333 13.0222 5.33333 16C5.33333 18.9778 6.36667 21.5 8.43333 23.5667C10.5 25.6333 13.0222 26.6667 16 26.6667Z"
            fill="black"
          />
        </g>
      </svg>
    </>
  );
}
export function IconCallEnd(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M4.51077 15.48L6.51077 13.89C6.99077 13.51 7.27077 12.93 7.27077 12.32V9.71999C10.2908 8.73999 13.5608 8.72999 16.5908 9.71999V12.33C16.5908 12.94 16.8708 13.52 17.3508 13.9L19.3408 15.48C20.1408 16.11 21.2808 16.05 22.0008 15.33L23.2208 14.11C24.0208 13.31 24.0208 11.98 23.1708 11.23C16.7608 5.56999 7.10077 5.56999 0.690767 11.23C-0.159233 11.98 -0.159233 13.31 0.640767 14.11L1.86077 15.33C2.57077 16.05 3.71077 16.11 4.51077 15.48Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function IconDown2(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M9.00063 12.6C8.47563 12.6 7.95062 12.3975 7.55312 12L2.66313 7.10998C2.44563 6.89248 2.44563 6.53248 2.66313 6.31498C2.88063 6.09748 3.24063 6.09748 3.45813 6.31498L8.34812 11.205C8.70813 11.565 9.29313 11.565 9.65313 11.205L14.5431 6.31498C14.7606 6.09748 15.1206 6.09748 15.3381 6.31498C15.5556 6.53248 15.5556 6.89248 15.3381 7.10998L10.4481 12C10.0506 12.3975 9.52563 12.6 9.00063 12.6Z"
          fill="black"
        />
      </svg>
    </>
  );
}
export function IconTest3(props: { col?: string; size?: string }) {
  const { col = "#909395" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clipPath="url(#clip0_6367_122050)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.3924 2.50489H22.2725V2.47358C22.2725 1.93835 21.8284 1.50294 21.2825 1.50294H18.6956H17.7375H14.6076H13.6495H11.0626C10.5167 1.50294 10.0726 1.93835 10.0726 2.47358V2.50489H5.95271C4.56153 2.50489 3.42969 3.61456 3.42969 4.97847V29.5264C3.42969 30.8903 4.56153 32 5.95271 32H26.3924C27.7836 32 28.9154 30.8903 28.9154 29.5264V4.97847C28.9154 3.61456 27.7836 2.50489 26.3924 2.50489ZM25.8814 5.44814H21.7933C21.7877 5.44814 21.7822 5.44751 21.7766 5.44733C21.3165 6.05526 20.5792 6.4501 19.7495 6.4501H12.5956C11.7659 6.4501 11.0286 6.05526 10.5685 5.44733C10.5629 5.44751 10.5574 5.44814 10.5517 5.44814H6.4637C6.44607 5.44814 6.43176 5.46217 6.43176 5.47945V29.0254C6.43176 29.0427 6.44607 29.0568 6.4637 29.0568H25.8814C25.899 29.0568 25.9133 29.0427 25.9133 29.0254V5.47945C25.9133 5.46217 25.899 5.44814 25.8814 5.44814ZM11.0626 2.44227C11.045 2.44227 11.0307 2.4563 11.0307 2.47358V3.97652C11.0307 4.82248 11.7327 5.51076 12.5956 5.51076H19.7495C20.6124 5.51076 21.3144 4.82248 21.3144 3.97652V2.97819L21.3142 2.97456L21.3144 2.97093V2.47358C21.3144 2.4563 21.3001 2.44227 21.2825 2.44227H11.0626ZM26.3924 31.0607C27.2553 31.0607 27.9573 30.3724 27.9573 29.5264V4.97847C27.9573 4.13251 27.2553 3.44423 26.3924 3.44423H22.2725V3.97652C22.2725 4.15925 22.2516 4.33722 22.213 4.50881H25.8814C26.4273 4.50881 26.8714 4.94422 26.8714 5.47945V29.0254C26.8714 29.5607 26.4273 29.9961 25.8814 29.9961H6.4637C5.91777 29.9961 5.47365 29.5607 5.47365 29.0254V5.47945C5.47365 4.94422 5.91777 4.50881 6.4637 4.50881H10.132C10.0935 4.33722 10.0726 4.15925 10.0726 3.97652V3.44423H5.95271C5.08984 3.44423 4.3878 4.13251 4.3878 4.97847V29.5264C4.3878 30.3724 5.08984 31.0607 5.95271 31.0607H26.3924Z"
            fill={col}
          />
          <path
            d="M18.6956 1.50294V1.47162C18.6956 0.660164 18.0222 0 17.1945 0H15.1506C14.3229 0 13.6495 0.660164 13.6495 1.47162V1.50294H14.6076V1.47162C14.6076 1.17811 14.8512 0.939335 15.1506 0.939335H17.1945C17.4939 0.939335 17.7375 1.17811 17.7375 1.47162V1.50294H18.6956Z"
            fill={col}
          />
          <path
            d="M9.08199 13.4638H13.0422C13.3416 13.4638 13.5851 13.225 13.5851 12.9315V9.04889C13.5851 8.75538 13.3416 8.5166 13.0422 8.5166H9.08199C8.78261 8.5166 8.53906 8.75538 8.53906 9.04889V12.9315C8.53906 13.225 8.78261 13.4638 9.08199 13.4638ZM9.49717 9.45594H12.627V12.5244H9.49717V9.45594Z"
            fill={col}
          />
          <path
            d="M13.0422 21.542H9.08199C8.78261 21.542 8.53906 21.7808 8.53906 22.0743V25.9569C8.53906 26.2504 8.78261 26.4892 9.08199 26.4892H13.0422C13.3416 26.4892 13.5851 26.2504 13.5851 25.9569V22.0743C13.5851 21.7808 13.3416 21.542 13.0422 21.542ZM12.627 25.5498H9.49717V22.4813H12.627V25.5498Z"
            fill={col}
          />
          <path
            d="M13.7893 15.1671L13.4449 15.5048C13.272 15.2208 12.9563 15.0295 12.5951 15.0295H9.52911C8.98318 15.0295 8.53906 15.465 8.53906 16.0002V19.0061C8.53906 19.5413 8.98318 19.9767 9.52911 19.9767H12.5951C13.141 19.9767 13.5851 19.5413 13.5851 19.0061V18.5051C13.5851 18.2457 13.3706 18.0354 13.1061 18.0354C12.8415 18.0354 12.627 18.2457 12.627 18.5051V19.0061C12.627 19.0233 12.6127 19.0374 12.5951 19.0374H9.52911C9.51148 19.0374 9.49717 19.0233 9.49717 19.0061V16.0002C9.49717 15.9829 9.51148 15.9689 9.52911 15.9689H12.5951C12.6127 15.9689 12.627 15.9829 12.627 16.0002V16.3067L11.5731 17.3399L10.8898 16.6701C10.7027 16.4866 10.3994 16.4866 10.2124 16.6701C10.0253 16.8535 10.0253 17.1508 10.2124 17.3342L11.2344 18.3362C11.3279 18.4279 11.4505 18.4738 11.5731 18.4738C11.6956 18.4738 11.8183 18.4279 11.9118 18.3362L13.4447 16.8333L13.4448 16.8332L14.4668 15.8313C14.6538 15.6479 14.6538 15.3505 14.4668 15.1671C14.2797 14.9837 13.9763 14.9837 13.7893 15.1671Z"
            fill={col}
          />
          <path
            d="M15.147 9.95691H16.68C16.9446 9.95691 17.1591 9.74663 17.1591 9.48725C17.1591 9.22786 16.9446 9.01758 16.68 9.01758H15.147C14.8825 9.01758 14.668 9.22786 14.668 9.48725C14.668 9.74663 14.8825 9.95691 15.147 9.95691Z"
            fill={col}
          />
          <path
            d="M14.668 11.4914C14.668 11.7508 14.8825 11.9611 15.147 11.9611H22.8119C23.0765 11.9611 23.291 11.7508 23.291 11.4914C23.291 11.232 23.0765 11.0217 22.8119 11.0217H15.147C14.8825 11.0217 14.668 11.232 14.668 11.4914Z"
            fill={col}
          />
          <path
            d="M15.147 16.9706H20.2569C20.5215 16.9706 20.736 16.7603 20.736 16.5009C20.736 16.2415 20.5215 16.0312 20.2569 16.0312H15.147C14.8825 16.0312 14.668 16.2415 14.668 16.5009C14.668 16.7603 14.8825 16.9706 15.147 16.9706Z"
            fill={col}
          />
          <path
            d="M22.8119 18.0354H15.147C14.8825 18.0354 14.668 18.2457 14.668 18.5051C14.668 18.7644 14.8825 18.9747 15.147 18.9747H22.8119C23.0765 18.9747 23.291 18.7644 23.291 18.5051C23.291 18.2457 23.0765 18.0354 22.8119 18.0354Z"
            fill={col}
          />
          <path
            d="M15.147 23.4835H17.191C17.4556 23.4835 17.67 23.2732 17.67 23.0139C17.67 22.7545 17.4556 22.5442 17.191 22.5442H15.147C14.8825 22.5442 14.668 22.7545 14.668 23.0139C14.668 23.2732 14.8825 23.4835 15.147 23.4835Z"
            fill={col}
          />
          <path
            d="M22.8119 24.5479H15.147C14.8825 24.5479 14.668 24.7581 14.668 25.0175C14.668 25.2769 14.8825 25.4872 15.147 25.4872H22.8119C23.0765 25.4872 23.291 25.2769 23.291 25.0175C23.291 24.7581 23.0765 24.5479 22.8119 24.5479Z"
            fill={col}
          />
        </g>
        <defs>
          <clipPath id="clip0_6367_122050">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export function IconLibrary(props: { col?: string; size?: string }) {
  const { col = "#909395" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M3.67126 18.5563L3.67121 18.556C3.37081 16.5069 3.15552 15.0278 3.16432 13.8947C3.17296 12.7816 3.3987 12.0915 3.90777 11.5615C4.4248 11.0232 5.16935 10.718 6.40442 10.5596C7.64815 10.4001 9.2974 10.3992 11.5605 10.3992H20.4352C22.6983 10.3992 24.3475 10.4001 25.5912 10.5596C26.8263 10.718 27.5709 11.0232 28.0879 11.5615C28.597 12.0915 28.8227 12.7816 28.8313 13.8947C28.8401 15.0278 28.6249 16.5069 28.3245 18.556L28.3244 18.5563L27.7618 22.4121C27.5264 24.0201 27.3562 25.1755 27.1018 26.0512C26.8527 26.9092 26.5382 27.4403 26.0486 27.8311C25.5537 28.2261 24.9189 28.4464 23.9329 28.5605C22.9365 28.6757 21.6471 28.6765 19.8712 28.6765H12.1245C10.3479 28.6765 9.05889 28.6757 8.0628 28.5605C7.07727 28.4465 6.44255 28.2261 5.94688 27.8309C5.45741 27.4401 5.14297 26.9091 4.89383 26.0512C4.63952 25.1756 4.4693 24.0202 4.23393 22.4123C4.23393 22.4123 4.23392 22.4123 4.23392 22.4123C4.23391 22.4122 4.2339 22.4121 4.2339 22.4121L3.67126 18.5563ZM15.2076 24.1137L15.208 24.1135L19.7023 21.327C20.2471 20.9898 20.4982 20.3989 20.4982 19.8432C20.4982 19.2874 20.2471 18.6966 19.7023 18.3594L15.2082 15.573C14.6678 15.2376 14.0543 15.2907 13.592 15.5942C13.135 15.8941 12.8312 16.4301 12.8312 17.0565V22.6298C12.8312 23.2563 13.1351 23.792 13.5921 24.0918C14.0543 24.3949 14.6674 24.448 15.2076 24.1137Z"
          stroke={col}
        />
        <path
          opacity="0.4"
          d="M11.3427 2.66675H20.6494C20.9587 2.66675 21.1961 2.66675 21.4041 2.68675C22.8814 2.83208 24.0907 3.72008 24.6041 4.91608H7.38672C7.89872 3.72008 9.10805 2.83208 10.5854 2.68675C10.7947 2.66675 11.0321 2.66675 11.3427 2.66675Z"
          fill={col}
        />
        <path
          opacity="0.7"
          d="M8.412 6.05908C6.55867 6.05908 5.03867 7.17908 4.53067 8.66308C4.52 8.69405 4.50978 8.72516 4.5 8.75641C5.03067 8.59641 5.58267 8.49108 6.14267 8.41908C7.58267 8.23508 9.404 8.23508 11.5187 8.23508H20.708C22.8227 8.23508 24.6427 8.23508 26.084 8.41908C26.6398 8.48649 27.1892 8.59931 27.7267 8.75641C27.7169 8.72515 27.7067 8.69404 27.696 8.66308C27.1893 7.17775 25.668 6.05908 23.8133 6.05908H8.412Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconDoubts1(props: { col?: string }) {
  const { col = "#909395" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="23"
        viewBox="0 0 21 23"
        fill="none"
      >
        <path
          d="M14.1747 19.5781L14.3435 20.0488L14.1747 19.5781C13.1686 19.939 12.0837 20.1358 10.9517 20.1358C5.6799 20.1358 1.40625 15.8622 1.40625 10.5904C1.40625 5.31857 5.6799 1.04492 10.9517 1.04492C16.2235 1.04492 20.4972 5.31857 20.4972 10.5904C20.4972 13.4788 19.2149 16.0672 17.1868 17.8183C17.0234 17.9594 16.9251 18.1663 16.9251 18.3884V21.7692L14.9696 19.7608C14.7604 19.5459 14.4483 19.48 14.1747 19.5781Z"
          stroke={col}
        />
        <path
          d="M11.0566 14.0784C11.0566 14.364 10.8251 14.5955 10.5395 14.5955C10.254 14.5955 10.0225 14.364 10.0225 14.0784C10.0225 13.7929 10.254 13.5614 10.5395 13.5614C10.8251 13.5614 11.0566 13.7929 11.0566 14.0784Z"
          fill={col}
        />
        <path
          d="M11.2104 6.32275C12.1542 6.32275 12.9084 6.56676 13.4729 7.05475C14.0466 7.54274 14.3335 8.20938 14.3335 9.05467C14.3335 9.93481 14.0373 10.5971 13.4451 11.0415C12.8529 11.4859 12.0663 11.7082 11.0854 11.7082L11.082 12.2146C11.0801 12.5058 10.8435 12.7408 10.5523 12.7408C10.2597 12.7408 10.0225 12.5036 10.0225 12.211V10.6886H11.0785C11.0785 10.6886 12.05 10.4637 12.3902 10.1446C12.7303 9.82559 12.8205 9.05467 12.8205 9.05467C12.8205 8.59282 12.6771 8.23117 12.3902 7.96975C12.1126 7.70832 11.7239 7.57761 11.2242 7.57761C10.7245 7.57761 10.3313 7.70397 10.0444 7.95668C9.93258 8.05518 9.84256 8.16891 9.77433 8.29787C9.58252 8.66039 9.28164 9.01546 8.87151 9.01546C8.46138 9.01546 8.1157 8.67708 8.22074 8.28064C8.28319 8.04492 8.37751 7.82365 8.50368 7.61682C8.75352 7.20725 9.10979 6.88918 9.57247 6.66261C10.0444 6.43604 10.5904 6.32275 11.2104 6.32275Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconMyCourses(props: { col?: string; size?: string }) {
  const { col = "#4B65F6" } = props || {};
  const { size = "32" } = props || {};

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 28 28"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 23.5C5 24.8807 6.11929 26 7.5 26H20.5C21.8807 26 23 24.8807 23 23.5V15L19.0625 12L15.125 15V1H14H7.5C6.11929 1 5 2.11929 5 3.5V23.5Z"
          fill={col}
        />
        <path
          d="M18.5 1H16.25H15.125V15L19.0625 12L23 15V3.5C23 2.11929 21.8807 1 20.5 1H18.5Z"
          fill="white"
        />
        <path
          d="M22.5 3.5V13.9905L19.3655 11.6023L19.0625 11.3714L18.7595 11.6023L15.625 13.9905V1.5H16.25H18.5H20.5C21.6046 1.5 22.5 2.39543 22.5 3.5ZM14 1.5H14.625V15V16.0095L15.428 15.3977L19.0625 12.6286L22.5 15.2476V23.5C22.5 24.6046 21.6046 25.5 20.5 25.5H7.5C6.39543 25.5 5.5 24.6046 5.5 23.5V3.5C5.5 2.39543 6.39543 1.5 7.5 1.5H14Z"
          stroke={col}
        />
      </svg>
    </>
  );
}

export function IconWebsiteBuilder(props: { col?: string; size?: string }) {
  const { col = "#4B65F6" } = props || {};
  const { size = "32" } = props || {};

  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.6225 5.97656C19.1795 5.97656 18.8203 6.33572 18.8203 6.77877V21.2186C18.8203 21.6616 19.1795 22.0208 19.6225 22.0208C20.0656 22.0208 20.4247 21.6616 20.4247 21.2186V6.77877C20.4247 6.33572 20.0656 5.97656 19.6225 5.97656Z"
          fill="#909395"
        />
        <path
          d="M5.98438 9.18607C5.98438 9.62912 6.34354 9.98828 6.78658 9.98828L13.2043 9.98828C13.6473 9.98828 14.0065 9.62912 14.0065 9.18607C14.0065 8.74302 13.6473 8.38386 13.2043 8.38386L6.78659 8.38386C6.34354 8.38386 5.98438 8.74302 5.98438 9.18607Z"
          fill="#909395"
        />
        <path
          d="M5.98438 13.9986C5.98437 14.4416 6.34354 14.8008 6.78658 14.8008L13.2043 14.8008C13.6473 14.8008 14.0065 14.4416 14.0065 13.9986C14.0065 13.5555 13.6473 13.1964 13.2043 13.1964L6.78659 13.1964C6.34354 13.1964 5.98438 13.5555 5.98438 13.9986Z"
          fill="#909395"
        />
        <path
          d="M5.98438 18.8111C5.98437 19.2541 6.34354 19.6133 6.78658 19.6133L13.2043 19.6133C13.6473 19.6133 14.0065 19.2541 14.0065 18.8111C14.0065 18.368 13.6473 18.0089 13.2043 18.0089L6.78659 18.0089C6.34354 18.0089 5.98438 18.368 5.98438 18.8111Z"
          fill="#909395"
        />
        <path
          d="M3.50021 3.26758H24.5035C24.683 3.26758 24.881 3.35398 25.0448 3.55412C25.2108 3.75705 25.3162 4.05024 25.3162 4.372V23.625C25.3162 23.9468 25.2108 24.24 25.0448 24.4429C24.881 24.6431 24.683 24.7295 24.5035 24.7295H3.50021C3.32075 24.7295 3.12271 24.6431 2.95896 24.4429C2.79293 24.24 2.6875 23.9468 2.6875 23.625V4.372C2.6875 4.05024 2.79293 3.75705 2.95896 3.55412C3.12271 3.35398 3.32075 3.26758 3.50021 3.26758Z"
          stroke="#909395"
        />
      </svg>
    </>
  );
}

export function IconWebsiteBuilderSelected(props: {
  col?: string;
  size?: string;
}) {
  const { col = "#4B65F6" } = props || {};
  const { size = "32" } = props || {};

  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.5035 2.76758H3.50021C3.15206 2.76758 2.81816 2.93662 2.57198 3.2375C2.3258 3.53839 2.1875 3.94648 2.1875 4.372V23.625C2.1875 24.0506 2.3258 24.4586 2.57198 24.7595C2.81816 25.0604 3.15206 25.2295 3.50021 25.2295H24.5035C24.8517 25.2295 25.1856 25.0604 25.4317 24.7595C25.6779 24.4586 25.8162 24.0506 25.8162 23.625V4.372C25.8162 3.94648 25.6779 3.53839 25.4317 3.2375C25.1856 2.93662 24.8517 2.76758 24.5035 2.76758Z"
          fill="#4B65F6"
        />
        <path
          d="M19.6225 5.97656C19.1795 5.97656 18.8203 6.33572 18.8203 6.77877V21.2186C18.8203 21.6616 19.1795 22.0208 19.6225 22.0208C20.0656 22.0208 20.4247 21.6616 20.4247 21.2186V6.77877C20.4247 6.33572 20.0656 5.97656 19.6225 5.97656Z"
          fill="white"
        />
        <path
          d="M5.98438 9.18607C5.98438 9.62912 6.34354 9.98828 6.78658 9.98828L13.2043 9.98828C13.6473 9.98828 14.0065 9.62912 14.0065 9.18607C14.0065 8.74302 13.6473 8.38386 13.2043 8.38386L6.78659 8.38386C6.34354 8.38386 5.98438 8.74302 5.98438 9.18607Z"
          fill="white"
        />
        <path
          d="M5.98438 13.9986C5.98438 14.4416 6.34354 14.8008 6.78658 14.8008L13.2043 14.8008C13.6473 14.8008 14.0065 14.4416 14.0065 13.9986C14.0065 13.5555 13.6473 13.1964 13.2043 13.1964L6.78658 13.1964C6.34354 13.1964 5.98438 13.5555 5.98438 13.9986Z"
          fill="white"
        />
        <path
          d="M5.98438 18.8111C5.98437 19.2541 6.34354 19.6133 6.78658 19.6133L13.2043 19.6133C13.6473 19.6133 14.0065 19.2541 14.0065 18.8111C14.0065 18.368 13.6473 18.0089 13.2043 18.0089L6.78659 18.0089C6.34354 18.0089 5.98438 18.368 5.98438 18.8111Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function IconVideo(props: {
  col?: string;
  size?: string;
  filled?: boolean;
}) {
  const { col = "#666666" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 28 28"
        fill={props.filled ? col : "none"}
      >
        <path
          d="M25.64 7.5L20 10V7C20 6.46957 19.7893 5.96086 19.4142 5.58579C19.0391 5.21071 18.5304 5 18 5H3C2.46957 5 1.96086 5.21071 1.58579 5.58579C1.21071 5.96086 1 6.46957 1 7V21C1 21.5304 1.21071 22.0391 1.58579 22.4142C1.96086 22.7893 2.46957 23 3 23H18C18.5304 23 19.0391 22.7893 19.4142 22.4142C19.7893 22.0391 20 21.5304 20 21V18L25.64 20.5C25.7921 20.5587 25.9561 20.5793 26.118 20.5601C26.2798 20.5408 26.4345 20.4824 26.5686 20.3897C26.7027 20.297 26.8121 20.173 26.8873 20.0284C26.9624 19.8838 27.0012 19.723 27 19.56V8.44C27.0012 8.27702 26.9624 8.11623 26.8873 7.97162C26.8121 7.82702 26.7027 7.70298 26.5686 7.61032C26.4345 7.51765 26.2798 7.45915 26.118 7.43993C25.9561 7.4207 25.7921 7.44132 25.64 7.5Z"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconPlusQuestions(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M37.9118 8.66963L37.9118 8.66998C38.7595 15.903 38.7595 23.2094 37.9118 30.4424L37.9118 30.4425C37.4441 34.4386 34.2331 37.5727 30.254 38.0195C23.1219 38.8101 15.9243 38.8101 8.79222 38.0195C4.81072 37.5727 1.59996 34.4385 1.13448 30.4428L1.13445 30.4426C0.288515 23.2096 0.288515 15.9028 1.13445 8.66986L1.13448 8.66963C1.59997 4.67385 4.81293 1.53765 8.79169 1.09301C15.9241 0.302331 23.1221 0.30233 30.2545 1.09301C34.2355 1.53762 37.4463 4.67374 37.9118 8.66963Z"
          stroke="#808080"
        />
        <path
          d="M8.02734 19.5552C8.02734 19.097 8.20935 18.6576 8.53332 18.3336C8.8573 18.0096 9.2967 17.8276 9.75487 17.8276H17.8005H21.2556H29.3012C29.7594 17.8276 30.1988 18.0096 30.5228 18.3336C30.8467 18.6576 31.0287 19.097 31.0287 19.5552C31.0287 20.0133 30.8467 20.4527 30.5228 20.7767C30.1988 21.1007 29.7594 21.2827 29.3012 21.2827H21.2556H17.8005H9.75487C9.2967 21.2827 8.8573 21.1007 8.53332 20.7767C8.20935 20.4527 8.02734 20.0133 8.02734 19.5552Z"
          fill="black"
        />
        <path
          d="M19.5264 8.05493C19.9845 8.05493 20.424 8.23694 20.7479 8.56091C21.0719 8.88488 21.2539 9.32429 21.2539 9.78245L21.2539 17.8281L21.2539 21.2832L21.2539 29.3288C21.2539 29.787 21.0719 30.2264 20.7479 30.5503C20.424 30.8743 19.9845 31.0563 19.5264 31.0563C19.0682 31.0563 18.6288 30.8743 18.3048 30.5503C17.9809 30.2264 17.7989 29.787 17.7989 29.3288L17.7989 21.2832L17.7989 17.8281L17.7989 9.78245C17.7989 9.32429 17.9809 8.88488 18.3048 8.56091C18.6288 8.23694 19.0682 8.05493 19.5264 8.05493Z"
          fill="black"
        />
      </svg>
    </>
  );
}
export function IconDeleteQuestion(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "40" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M37.9118 8.66963L37.9118 8.66998C38.7595 15.903 38.7595 23.2094 37.9118 30.4424L37.9118 30.4425C37.4441 34.4386 34.2331 37.5727 30.254 38.0195C23.1219 38.8101 15.9243 38.8101 8.79222 38.0195C4.81072 37.5727 1.59996 34.4385 1.13448 30.4428L1.13445 30.4426C0.288515 23.2096 0.288515 15.9028 1.13445 8.66986L1.13448 8.66963C1.59997 4.67385 4.81293 1.53765 8.79169 1.09301C15.9241 0.302331 23.1221 0.30233 30.2545 1.09301C34.2355 1.53762 37.4463 4.67374 37.9118 8.66963Z"
          stroke="#808080"
        />
        <path
          d="M8.02734 19.5552C8.02734 19.097 8.20935 18.6576 8.53332 18.3336C8.8573 18.0096 9.2967 17.8276 9.75487 17.8276H17.8005H21.2556H29.3012C29.7594 17.8276 30.1988 18.0096 30.5228 18.3336C30.8467 18.6576 31.0287 19.097 31.0287 19.5552C31.0287 20.0133 30.8467 20.4527 30.5228 20.7767C30.1988 21.1007 29.7594 21.2827 29.3012 21.2827H21.2556H17.8005H9.75487C9.2967 21.2827 8.8573 21.1007 8.53332 20.7767C8.20935 20.4527 8.02734 20.0133 8.02734 19.5552Z"
          fill="black"
        />
      </svg>
    </>
  );
}
export function IconEditQuestion(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M37.9118 8.66963L37.9118 8.66998C38.7595 15.903 38.7595 23.2094 37.9118 30.4424L37.9118 30.4425C37.4441 34.4386 34.2331 37.5727 30.254 38.0195C23.1219 38.8101 15.9243 38.8101 8.79222 38.0195C4.81072 37.5727 1.59996 34.4385 1.13448 30.4428L1.13445 30.4426C0.288515 23.2096 0.288515 15.9028 1.13445 8.66986L1.13448 8.66963C1.59997 4.67385 4.81293 1.53765 8.79169 1.09301C15.9241 0.302331 23.1221 0.30233 30.2545 1.09301C34.2355 1.53762 37.4463 4.67374 37.9118 8.66963Z"
          stroke="#808080"
        />
        <path
          d="M24.8442 12.8585L27.1387 15.1519M26.3197 10.8381L20.1155 17.0423C19.7949 17.3624 19.5763 17.7703 19.4871 18.2145L18.9141 21.0831L21.7827 20.509C22.2269 20.4201 22.6342 20.2024 22.9549 19.8817L29.1591 13.6775C29.3456 13.491 29.4935 13.2697 29.5944 13.0261C29.6953 12.7825 29.7472 12.5214 29.7472 12.2578C29.7472 11.9941 29.6953 11.733 29.5944 11.4894C29.4935 11.2458 29.3456 11.0245 29.1591 10.8381C28.9727 10.6516 28.7514 10.5037 28.5078 10.4028C28.2642 10.3019 28.0031 10.25 27.7394 10.25C27.4758 10.25 27.2147 10.3019 26.9711 10.4028C26.7275 10.5037 26.5062 10.6516 26.3197 10.8381Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.582 23.2498V26.4998C27.582 27.0745 27.3538 27.6256 26.9474 28.0319C26.5411 28.4382 25.99 28.6665 25.4154 28.6665H13.4987C12.9241 28.6665 12.373 28.4382 11.9666 28.0319C11.5603 27.6256 11.332 27.0745 11.332 26.4998V14.5832C11.332 14.0085 11.5603 13.4574 11.9666 13.0511C12.373 12.6448 12.9241 12.4165 13.4987 12.4165H16.7487"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function IconGenerateAI(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
      >
        <path
          d="M19.2868 27.495V32.209L16.6298 33.7459V29.5219C16.6298 28.7229 16.1998 27.9939 15.5118 27.5949L11.9768 25.548L9.29984 24L7.60184 23.021C6.82378 22.573 6.14166 21.976 5.59452 21.2642C5.04738 20.5524 4.64595 19.7396 4.4132 18.8725C4.18044 18.0054 4.12093 17.1009 4.23807 16.2108C4.3552 15.3206 4.64669 14.4623 5.09584 13.685L5.36584 13.225L5.63484 12.755C6.54275 11.1866 8.0361 10.0428 9.78682 9.57476C11.5375 9.10675 13.4024 9.35283 14.9718 10.259L16.6288 11.218V14.254L13.7928 12.616C13.2946 12.3286 12.7446 12.1423 12.1743 12.0676C11.604 11.9929 11.0246 12.0314 10.4692 12.1807C9.91373 12.33 9.39316 12.5873 8.93721 12.9379C8.48125 13.2885 8.09885 13.7255 7.81184 14.224L7.47184 14.813C7.18489 15.3105 6.99886 15.8597 6.92438 16.4292C6.8499 16.9987 6.88843 17.5773 7.03778 18.1319C7.18714 18.6864 7.44437 19.2061 7.79477 19.6612C8.14516 20.1163 8.58185 20.4978 9.07984 20.784L11.9758 22.452L14.6528 24L18.5678 26.257C19.0178 26.517 19.2868 26.986 19.2868 27.495Z"
          fill="#4B65F6"
        />
        <path
          d="M31.37 9.33V11.218L28.713 12.746V9.55C28.7141 8.39135 28.255 7.27971 27.4366 6.45948C27.411 6.43385 27.3852 6.40857 27.359 6.38364C26.5488 5.61085 25.4715 5.17754 24.349 5.176H23.66C23.0857 5.176 22.5169 5.28915 21.9863 5.50897C21.4557 5.7288 20.9736 6.051 20.5675 6.45718C20.1614 6.86335 19.8393 7.34555 19.6196 7.87622C19.3999 8.40689 19.2869 8.97565 19.287 9.55V20.505C19.287 21.015 19.017 21.484 18.567 21.743L14.654 24L11.978 22.452L15.513 20.415C15.8525 20.2181 16.1344 19.9356 16.3305 19.5957C16.5267 19.2558 16.6303 18.8704 16.631 18.478V9.34C16.6321 7.52625 17.3531 5.78708 18.6356 4.50456C19.9181 3.22204 21.6573 2.50106 23.471 2.5H24.541C25.4381 2.49961 26.3264 2.676 27.1552 3.0191C27.9841 3.3622 28.7371 3.86528 29.3714 4.49958C30.0057 5.13389 30.5088 5.88697 30.8519 6.71581C31.195 7.54464 31.3704 8.43296 31.37 9.33ZM28.713 32.218V35.254L25.118 33.177C24.8231 33.0118 24.4959 32.9144 24.16 32.8908C24.1555 32.8905 24.151 32.8902 24.1466 32.8899C24.0979 32.8868 24.049 32.8853 24 32.8853C23.6085 32.8853 23.2236 32.9857 22.882 33.177L19.287 35.254L16.63 36.782L14.973 37.741C13.4035 38.647 11.5385 38.893 9.78778 38.4248C8.03705 37.9566 6.54377 36.8125 5.63603 35.244L5.36603 34.774L5.09603 34.316C4.64676 33.5385 4.3552 32.6801 4.23806 31.7898C4.12091 30.8995 4.18047 29.9949 4.41333 29.1276C4.64618 28.2604 5.04776 27.4476 5.59509 26.7357C6.14242 26.0238 6.82474 25.4269 7.60303 24.979L9.29984 24L11.9768 25.548L9.08103 27.216C8.58304 27.5021 8.14635 27.8837 7.79595 28.3387C7.44555 28.7938 7.18832 29.3135 7.03897 29.8681C6.88962 30.4227 6.85108 31.0013 6.92556 31.5708C7.00004 32.1403 7.18608 32.6895 7.47303 33.187L7.81303 33.777C8.10011 34.2754 8.48258 34.7123 8.93857 35.0627C9.39457 35.4132 9.91515 35.6705 10.4706 35.8197C11.026 35.9689 11.6054 36.0073 12.1757 35.9325C12.7459 35.8577 13.2958 35.6714 13.794 35.384L16.6298 33.7459L19.2868 32.209L23.281 29.902L23.291 29.912C23.731 29.652 24.27 29.652 24.709 29.912H24.719L28.713 32.219V32.218Z"
          fill="#4B65F6"
        />
        <path
          d="M42.9039 34.3159L42.6339 34.7749L42.3639 35.2449C41.456 36.8133 39.9626 37.9571 38.2119 38.4251C36.4612 38.8931 34.5963 38.647 33.0269 37.7409L31.3699 36.7819L31.37 33.7458L34.206 35.3838C35.2089 35.9626 36.4002 36.1206 37.5192 35.8232C38.6383 35.5258 39.5939 34.7972 40.177 33.7968L40.517 33.1968C40.8052 32.6992 40.9924 32.1497 41.068 31.5798C41.1436 31.0098 41.1062 30.4305 40.9578 29.8751C40.8093 29.3196 40.5529 28.7988 40.2031 28.3425C39.8533 27.8862 39.4169 27.5033 38.919 27.2158L36.023 25.5478L33.347 23.9998L29.432 21.743C29.2137 21.6184 29.032 21.4381 28.9058 21.2207C28.7795 21.0033 28.713 20.7563 28.7129 20.5049L28.714 15.7912V15.7898L31.3699 14.2529V18.4769C31.3699 19.2759 31.7999 20.0139 32.4879 20.4139L36.0229 22.4509L38.6999 23.9999L40.3979 24.9789C41.176 25.4269 41.8581 26.0239 42.4052 26.7357C42.9524 27.4475 43.3538 28.2602 43.5865 29.1274C43.8193 29.9945 43.8788 30.899 43.7617 31.7891C43.6445 32.6792 43.3531 33.5375 42.9039 34.3149V34.3159Z"
          fill="#4B65F6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M28.713 35.254L25.119 33.177C24.824 33.0117 24.4962 32.9143 24.16 32.8908C24.4959 32.9144 24.8231 33.0118 25.118 33.177L28.713 35.254ZM38.6999 23.9999L40.3971 23.0207C41.1754 22.5728 41.8577 21.9769 42.405 21.265C42.9524 20.5531 43.354 19.7403 43.5868 18.8731C43.8197 18.0058 43.8792 17.1012 43.7621 16.2109C43.6449 15.3206 43.3534 14.4622 42.9041 13.6847L42.6351 13.2257L42.3651 12.7557C41.4574 11.1872 39.9641 10.0431 38.2134 9.57493C36.4626 9.10673 34.5976 9.35267 33.0281 10.2587L31.37 11.218L28.7141 12.7457L25.1191 14.8227C24.8539 14.9766 24.5636 15.0714 24.2674 15.1068C24.0631 15.1313 23.856 15.1276 23.6526 15.0956C23.3849 15.0536 23.1232 14.9626 22.882 14.8228L19.287 12.7458L19.2871 15.7917L19.288 15.7922L23.282 18.0968L23.292 18.0868C23.732 18.3468 24.271 18.3468 24.71 18.0868L24.72 18.0968L28.7131 15.7917L28.714 15.7912L31.3699 14.2529L34.206 12.616C35.2098 12.0365 36.4027 11.8793 37.5224 12.1789C38.642 12.4784 39.5968 13.2094 40.1771 14.2127L40.517 14.803C40.8053 15.3006 40.9927 15.8502 41.0684 16.4203C41.1441 16.9903 41.1067 17.5697 40.9582 18.1253C40.8098 18.6808 40.553 19.2007 40.2032 19.657C39.8533 20.1133 39.417 20.4962 38.9191 20.7837L36.0229 22.4509L38.6999 23.9999Z"
          fill="#4B65F6"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.287 35.254L16.63 36.782L16.63 38.6599C16.6311 40.4737 17.3521 42.2128 18.6346 43.4954C19.9171 44.7779 21.6563 45.4989 23.47 45.4999H24.54C25.4372 45.5003 26.3256 45.3239 27.1545 44.9807C27.9834 44.6376 28.7365 44.1344 29.3708 43.5C30.0051 42.8656 30.5082 42.1124 30.8512 41.2834C31.1943 40.4545 31.3706 39.566 31.37 38.6689L31.3699 36.7819L31.37 33.7458V29.5218C31.37 29.1416 31.4674 28.7772 31.6436 28.4567C31.6525 28.4405 31.6615 28.4245 31.6707 28.4086C31.867 28.0703 32.1489 27.7895 32.488 27.5948L36.023 25.5478L33.347 23.9998L29.433 26.2569C29.2267 26.3761 29.0582 26.5391 28.9362 26.7298C28.8172 26.9161 28.7424 27.1289 28.7201 27.3528C28.719 27.3632 28.7181 27.3737 28.7173 27.3841C28.7145 27.4208 28.713 27.4577 28.713 27.4948L28.713 35.254L28.713 38.45C28.7141 39.6087 28.255 40.7203 27.4366 41.5406C26.6183 42.3608 25.5077 42.8224 24.349 42.824H23.66C23.0857 42.824 22.5169 42.7109 21.9863 42.4911C21.4557 42.2712 20.9736 41.949 20.5675 41.5429C20.1614 41.1367 19.8393 40.6545 19.6196 40.1238C19.3999 39.5932 19.2869 39.0244 19.287 38.45L19.287 35.254ZM24.349 42.824C25.5077 42.8224 26.6183 42.3608 27.4366 41.5406C26.6185 42.3608 25.5085 42.8221 24.35 42.8239H23.661C23.0866 42.824 22.5171 42.7108 21.9863 42.4911C22.5169 42.7109 23.0857 42.824 23.66 42.824H24.349Z"
          fill="#4B65F6"
        />
        <path
          d="M24.75 24C24.75 24.4142 24.4142 24.75 24 24.75C23.5858 24.75 23.25 24.4142 23.25 24C23.25 23.5858 23.5858 23.25 24 23.25C24.4142 23.25 24.75 23.5858 24.75 24Z"
          fill="#4B65F6"
        />
      </svg>
    </>
  );
}
export function IconRadiusLeft(props: { col?: string }) {
  const { col = "#ABABAB" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="18"
        viewBox="0 0 9 18"
        fill="none"
      >
        <path
          d="M0.000156977 8.6675C0.000157008 7.9675 0.270156 7.2675 0.800156 6.7375L7.32016 0.2175C7.61016 -0.0725 8.09016 -0.0725 8.38016 0.2175C8.67016 0.5075 8.67016 0.9875 8.38016 1.2775L1.86016 7.7975C1.38016 8.2775 1.38016 9.0575 1.86016 9.5375L8.38016 16.0575C8.67016 16.3475 8.67016 16.8275 8.38016 17.1175C8.09016 17.4075 7.61016 17.4075 7.32016 17.1175L0.800156 10.5975C0.270155 10.0675 0.000156947 9.3675 0.000156977 8.6675Z"
          fill="#ABABAB"
        />
      </svg>
    </>
  );
}
export function IconCross2(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "24" } = props || {};

  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.3125 1.68652L12.9988 13.0002L1.68508 24.3139"
          stroke={col}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M1.68359 1.68652L12.9973 13.0002L24.311 24.3139"
          stroke={col}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
}
export function IconTest2(props: {
  col?: string;
  size?: string;
  filled?: boolean;
}) {
  const { col = "#666666" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 29 28"
        fill="none"
      >
        <g clipPath="url(#clip0_5960_2364)">
          <path
            d="M23.5943 2.19178H19.9894V2.16438C19.9894 1.69605 19.6008 1.31507 19.1231 1.31507H16.8596V1.28767C16.8596 0.577644 16.2704 0 15.5462 0H13.7577C13.0335 0 12.4443 0.577644 12.4443 1.28767V1.31507H10.1808C9.70309 1.31507 9.31448 1.69605 9.31448 2.16438V2.19178H5.7096C4.49232 2.19178 3.50195 3.16274 3.50195 4.35616V25.8356C3.50195 27.029 4.49232 28 5.7096 28H23.5943C24.8116 28 25.802 27.029 25.802 25.8356V4.35616C25.802 3.16274 24.8116 2.19178 23.5943 2.19178ZM19.5701 4.76712H23.1472C23.1626 4.76712 23.1751 4.7794 23.1751 4.79452V25.3973C23.1751 25.4124 23.1626 25.4247 23.1472 25.4247H6.15672C6.14129 25.4247 6.12877 25.4124 6.12877 25.3973V4.79452C6.12877 4.7794 6.14129 4.76712 6.15672 4.76712H9.73371C9.73869 4.76712 9.74349 4.76658 9.74841 4.76641C10.151 5.29836 10.7961 5.64384 11.5221 5.64384H17.7818C18.5078 5.64384 19.1529 5.29836 19.5555 4.76641C19.5604 4.76658 19.5652 4.76712 19.5701 4.76712ZM13.2827 1.28767C13.2827 1.03085 13.4958 0.821918 13.7577 0.821918H15.5462C15.8081 0.821918 16.0213 1.03085 16.0213 1.28767V1.31507H13.2827V1.28767ZM10.1528 2.16438C10.1528 2.14926 10.1653 2.13699 10.1808 2.13699H19.1231C19.1386 2.13699 19.1511 2.14926 19.1511 2.16438V2.59956L19.1509 2.60274L19.1511 2.60592V3.47945C19.1511 4.21967 18.5368 4.82192 17.7818 4.82192H11.5221C10.7671 4.82192 10.1528 4.21967 10.1528 3.47945V2.16438ZM24.9636 25.8356C24.9636 26.5758 24.3493 27.1781 23.5943 27.1781H5.7096C4.95458 27.1781 4.3403 26.5758 4.3403 25.8356V4.35616C4.3403 3.61595 4.95458 3.0137 5.7096 3.0137H9.31448V3.47945C9.31448 3.63934 9.33282 3.79507 9.36652 3.94521H6.15672C5.67903 3.94521 5.29042 4.32619 5.29042 4.79452V25.3973C5.29042 25.8656 5.67903 26.2466 6.15672 26.2466H23.1472C23.6249 26.2466 24.0135 25.8656 24.0135 25.3973V4.79452C24.0135 4.32619 23.6249 3.94521 23.1472 3.94521H19.9374C19.9711 3.79507 19.9894 3.63934 19.9894 3.47945V3.0137H23.5943C24.3493 3.0137 24.9636 3.61595 24.9636 4.35616V25.8356Z"
            fill={col}
          />
          <path
            d="M19.5701 4.76712H23.1472C23.1626 4.76712 23.1751 4.7794 23.1751 4.79452V25.3973C23.1751 25.4124 23.1626 25.4247 23.1472 25.4247H6.15672C6.14129 25.4247 6.12877 25.4124 6.12877 25.3973V4.79452C6.12877 4.7794 6.14129 4.76712 6.15672 4.76712H9.73371C9.73869 4.76712 9.74349 4.76658 9.74841 4.76641C10.151 5.29836 10.7961 5.64384 11.5221 5.64384H17.7818C18.5078 5.64384 19.1529 5.29836 19.5555 4.76641C19.5604 4.76658 19.5652 4.76712 19.5701 4.76712Z"
            fill={props.filled ? col : "none"}
          />
          <path
            d="M8.44772 11.7809H11.9129C12.1748 11.7809 12.3879 11.572 12.3879 11.3152V7.9179C12.3879 7.66108 12.1748 7.45215 11.9129 7.45215H8.44772C8.18576 7.45215 7.97266 7.66108 7.97266 7.9179V11.3152C7.97266 11.572 8.18576 11.7809 8.44772 11.7809ZM8.811 8.27407H11.5496V10.959H8.811V8.27407Z"
            fill={!props.filled ? col : "white"}
          />
          <path
            d="M11.9129 18.8486H8.44772C8.18576 18.8486 7.97266 19.0576 7.97266 19.3144V22.7116C7.97266 22.9685 8.18576 23.1774 8.44772 23.1774H11.9129C12.1748 23.1774 12.3879 22.9685 12.3879 22.7116V19.3144C12.3879 19.0576 12.1748 18.8486 11.9129 18.8486ZM11.5496 22.3555H8.811V19.6706H11.5496V22.3555Z"
            fill={!props.filled ? col : "white"}
          />
          <path
            d="M12.5666 13.2708L12.2653 13.5662C12.114 13.3177 11.8377 13.1504 11.5217 13.1504H8.83895C8.36126 13.1504 7.97266 13.5314 7.97266 13.9997V16.6298C7.97266 17.0982 8.36126 17.4792 8.83895 17.4792H11.5217C11.9993 17.4792 12.3879 17.0982 12.3879 16.6298V16.1915C12.3879 15.9645 12.2003 15.7805 11.9688 15.7805C11.7373 15.7805 11.5496 15.9645 11.5496 16.1915V16.6298C11.5496 16.645 11.5371 16.6572 11.5217 16.6572H8.83895C8.82352 16.6572 8.811 16.645 8.811 16.6298V13.9997C8.811 13.9846 8.82352 13.9723 8.83895 13.9723H11.5217C11.5371 13.9723 11.5496 13.9846 11.5496 13.9997V14.2679L10.6274 15.172L10.0296 14.5858C9.86586 14.4253 9.60044 14.4253 9.4368 14.5858C9.2731 14.7463 9.2731 15.0065 9.4368 15.167L10.331 16.0437C10.4129 16.124 10.5202 16.1641 10.6274 16.1641C10.7347 16.1641 10.842 16.124 10.9238 16.0437L12.2651 14.7287L12.2652 14.7286L13.1594 13.8519C13.3231 13.6914 13.3231 13.4313 13.1594 13.2708C12.9957 13.1103 12.7303 13.1103 12.5666 13.2708Z"
            fill={!props.filled ? col : "white"}
          />
          <path
            d="M13.7551 8.71254H15.0965C15.328 8.71254 15.5156 8.52854 15.5156 8.30158C15.5156 8.07462 15.328 7.89062 15.0965 7.89062H13.7551C13.5236 7.89062 13.3359 8.07462 13.3359 8.30158C13.3359 8.52854 13.5236 8.71254 13.7551 8.71254Z"
            fill={!props.filled ? col : "white"}
          />
          <path
            d="M13.3359 10.0545C13.3359 10.2815 13.5236 10.4655 13.7551 10.4655H20.4619C20.6934 10.4655 20.8811 10.2815 20.8811 10.0545C20.8811 9.82755 20.6934 9.64355 20.4619 9.64355H13.7551C13.5236 9.64355 13.3359 9.82755 13.3359 10.0545Z"
            fill={!props.filled ? col : "white"}
          />
          <path
            d="M13.7551 14.8493H18.2263C18.4578 14.8493 18.6455 14.6653 18.6455 14.4383C18.6455 14.2113 18.4578 14.0273 18.2263 14.0273H13.7551C13.5236 14.0273 13.3359 14.2113 13.3359 14.4383C13.3359 14.6653 13.5236 14.8493 13.7551 14.8493Z"
            fill={!props.filled ? col : "white"}
          />
          <path
            d="M20.4619 15.7812H13.7551C13.5236 15.7812 13.3359 15.9652 13.3359 16.1922C13.3359 16.4192 13.5236 16.6032 13.7551 16.6032H20.4619C20.6934 16.6032 20.8811 16.4192 20.8811 16.1922C20.8811 15.9652 20.6934 15.7812 20.4619 15.7812Z"
            fill={!props.filled ? col : "white"}
          />
          <path
            d="M13.7551 20.5485H15.5436C15.7751 20.5485 15.9628 20.3645 15.9628 20.1375C15.9628 19.9106 15.7751 19.7266 15.5436 19.7266H13.7551C13.5236 19.7266 13.3359 19.9106 13.3359 20.1375C13.3359 20.3645 13.5236 20.5485 13.7551 20.5485Z"
            fill={!props.filled ? col : "white"}
          />
          <path
            d="M20.4619 21.4795H13.7551C13.5236 21.4795 13.3359 21.6635 13.3359 21.8905C13.3359 22.1174 13.5236 22.3014 13.7551 22.3014H20.4619C20.6934 22.3014 20.8811 22.1174 20.8811 21.8905C20.8811 21.6635 20.6934 21.4795 20.4619 21.4795Z"
            fill={!props.filled ? col : "white"}
          />
        </g>
        <defs>
          <clipPath id="clip0_5960_2364">
            <rect
              width="28"
              height="28"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
export function IconTeach2(props: {
  col?: string;
  size?: string;
  filled?: boolean;
}) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 29 28"
        fill={props.filled ? col : "none"}
      >
        <path
          d="M13.5 9.67187C14.0625 10.0514 14.4712 10.4609 14.6917 10.75H18.3083C18.8836 10.75 19.35 11.2164 19.35 11.7916C19.35 12.3669 18.8836 12.8333 18.3083 12.8333H13.5V17H25.5C26.0523 17 26.5 16.5523 26.5 16V3C26.5 2.44772 26.0523 2 25.5 2H13.5V9.67187Z"
          stroke={col}
          //fill={col}
        />
        <path
          d="M11.3605 26.9992V13.1192C11.3605 12.3131 12.2653 11.8382 12.9286 12.2963L13.0241 12.3622C13.6923 12.8235 14.485 13.0706 15.2969 13.0706H18.2687C18.9097 13.0706 19.4294 12.5509 19.4294 11.9099C19.4294 11.2688 18.9097 10.7492 18.2687 10.7492H17.3596C16.1205 10.7492 14.967 10.1282 13.9211 9.46391C13.2921 9.06445 12.5068 8.70573 11.599 8.53426C10.8658 8.39575 10.128 8.63645 9.49425 9.0303L8.75034 9.49259C8.42712 9.69345 8.01792 9.69345 7.69471 9.49259L6.58018 8.8C6.18864 8.55668 5.73684 8.42773 5.27586 8.42773C3.91107 8.42773 2.80469 9.53412 2.80469 10.8989V13.9992V18.4307C2.80469 19.0602 3.31506 19.5706 3.94464 19.5706C4.57422 19.5706 5.08459 20.081 5.08459 20.7106V26.9992H8.22252H11.3605Z"
          //fill={col}
          stroke={col}
        />
        <path
          d="M10.5 5.5C10.5 6.88071 9.38071 8 8 8C6.61929 8 5.5 6.88071 5.5 5.5C5.5 4.11929 6.61929 3 8 3C9.38071 3 10.5 4.11929 10.5 5.5Z"
          //fill={col}
          stroke={col}
        />
        <path
          d="M5.08654 27V19.5714M5.08654 12.1428V18.1786V19.5714M11.3624 27V13.12C11.3624 12.3139 12.2673 11.8391 12.9306 12.2971L13.0261 12.363C13.6942 12.8243 14.4869 13.0714 15.2988 13.0714H18.2707C18.9117 13.0714 19.4314 12.5517 19.4314 11.9107V11.9107C19.4314 11.2697 18.9117 10.75 18.2707 10.75H17.2073C16.0655 10.75 15.0023 10.1817 14.0521 9.54866V9.54866C13.4028 9.11611 12.5719 8.71849 11.601 8.53508C10.8678 8.39658 10.13 8.63728 9.49621 9.03113L8.75229 9.49342C8.42908 9.69427 8.01987 9.69427 7.69666 9.49342L6.58214 8.80082C6.19059 8.5575 5.7388 8.42856 5.27781 8.42856V8.42856C3.91302 8.42856 2.80664 9.53494 2.80664 10.8997V14V17.2915C2.80664 18.5507 3.82739 19.5714 5.08654 19.5714V19.5714M8.22447 27V17.7143M15.3969 7.03572H19.4314M15.3969 3.78572H23.0176M14.0521 18H26.5003C27.0526 18 27.5003 17.5523 27.5003 17V2C27.5003 1.44772 27.0526 1 26.5003 1H14.0521H13.1555"
          stroke={!props.filled ? col : "white"}
          strokeLinecap="round"
        />
        <path
          d="M24.4655 27H12.3621H9.22414H6.08621H2.5"
          stroke={!props.filled ? col : "white"}
          strokeLinecap="round"
        />
        <path
          d="M20.418 10.8571L24.3904 6.22852"
          stroke={!props.filled ? col : "white"}
          strokeLinecap="round"
        />
      </svg>
    </>
  );
}
export function IconDown(props: {
  col?: string;
  width?: string;
  height?: string;
}) {
  const { col = "black" } = props || {};
  const { height = "7" } = props || {};
  const { width = "13" } = props || {};
  // const { size = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13 7"
        fill="none"
      >
        <path d="M6.5 6.5L4.29138e-07 0.5L13 0.499999L6.5 6.5Z" fill="black" />
      </svg>
    </>
  );
}
// export function IconTeach(props: { col?: string }) {
//   const { col = "black" } = props || {};
//   return (
//     <>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         width="29"
//         height="28"
//         viewBox="0 0 29 28"
//         fill="none"
//       >
//         <path
//           d="M10.4899 3.65749C10.4899 5.10223 9.36345 6.24321 8.01056 6.24321C6.65767 6.24321 5.53125 5.10223 5.53125 3.65749C5.53125 2.21276 6.65767 1.07178 8.01056 1.07178C9.36345 1.07178 10.4899 2.21276 10.4899 3.65749Z"
//           fill="white"
//           stroke="#4B65F6"
//         />
//         <path
//           d="M23.4655 27H11.3621M1.5 27H5.08621M5.08621 27H8.22414M5.08621 27V19.5714M5.08621 12.1428V18.1786V19.5714M11.3621 27V13.12C11.3621 12.3139 12.2669 11.8391 12.9303 12.2971L13.0258 12.363C13.6939 12.8243 14.4866 13.0714 15.2985 13.0714H18.2703C18.9114 13.0714 19.431 12.5517 19.431 11.9107V11.9107C19.431 11.2697 18.9114 10.75 18.2703 10.75H17.3612C16.1221 10.75 14.9687 10.129 13.9227 9.46473C13.2937 9.06528 12.5084 8.70656 11.6006 8.53508C10.8674 8.39658 10.1296 8.63728 9.49587 9.03112L8.75195 9.49342C8.42874 9.69427 8.01954 9.69427 7.69632 9.49342L6.5818 8.80082C6.19026 8.5575 5.73846 8.42856 5.27747 8.42856V8.42856C3.91269 8.42856 2.8063 9.53494 2.8063 10.8997V14V17.2915C2.8063 18.5507 3.82705 19.5714 5.08621 19.5714V19.5714M11.3621 27H8.22414M8.22414 27V17.7143M15.3966 7.03572H19.431M15.3966 3.78572H23.0172M14.0517 17.7143H26.5C27.0523 17.7143 27.5 17.2666 27.5 16.7143V2C27.5 1.44771 27.0523 1 26.5 1H13.1552"
//           stroke="#4B65F6"
//           strokeLinecap="round"
//         />
//         <path
//           d="M20.418 10.8576L24.3904 6.229"
//           stroke="#4B65F6"
//           strokeLinecap="round"
//         />
//       </svg>
//     </>
//   );
// }
export function IconViewResponse(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.5 15H11V20.5L5.5 15ZM10 22H18C19.0815 22 19.9542 21.155 19.9983 20.0849L19.6286 19.7163C18.9115 20.2131 18.1122 20.4615 17.2308 20.4615C16.6579 20.4615 16.11 20.3504 15.5871 20.128C15.0643 19.9056 14.6136 19.6052 14.235 19.2266C13.8564 18.848 13.5559 18.3972 13.3335 17.8744C13.1112 17.3516 13 16.8037 13 16.2308C13 15.6579 13.1112 15.11 13.3335 14.5871C13.3831 14.4706 13.4365 14.3576 13.4939 14.2483C13.2055 14.2158 12.9216 14.1331 12.6554 14L12.4443 13.8944C12.022 13.6833 11.5249 13.6833 11.1026 13.8944L10.8915 14C10.1877 14.3519 9.35922 14.3519 8.6554 14L7.54983 13.4472C7.30284 13.3237 7.20273 13.0234 7.32622 12.7764C7.44972 12.5294 7.75006 12.4293 7.99704 12.5528L9.10262 13.1056C9.52491 13.3167 10.022 13.3167 10.4443 13.1056L10.6554 13C11.3592 12.6481 12.1877 12.6481 12.8915 13L13.1026 13.1056C13.4793 13.2939 13.9155 13.3143 14.3051 13.1666C14.6688 12.82 15.0962 12.5423 15.5871 12.3335C16.11 12.1112 16.6579 12 17.2308 12C17.8037 12 18.3516 12.1112 18.8744 12.3335C19.2966 12.5131 19.6718 12.7436 20 13.0251V4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21071 18.5304 2 18 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V16L10 22ZM6.47326 11.2117C6.33969 11.2117 6.23117 11.1801 6.14769 11.1169C6.06978 11.0538 6.02248 10.9705 6.00578 10.8671C5.98908 10.7579 6.00856 10.6373 6.06421 10.5052L8.26804 5.46523C8.34039 5.29867 8.42665 5.18092 8.52682 5.112C8.63256 5.03733 8.75221 5 8.88578 5C9.01378 5 9.12787 5.03733 9.22804 5.112C9.33378 5.18092 9.42282 5.29867 9.49517 5.46523L11.7073 10.5052C11.7685 10.6373 11.7908 10.7579 11.7741 10.8671C11.7574 10.9762 11.7101 11.0624 11.6322 11.1255C11.5543 11.183 11.4513 11.2117 11.3233 11.2117C11.1675 11.2117 11.0451 11.1744 10.956 11.0997C10.8726 11.0193 10.7974 10.8987 10.7306 10.7378L10.3138 9.73846H7.44299L7.03256 10.7378C6.96021 10.9044 6.88508 11.025 6.80717 11.0997C6.72926 11.1744 6.61795 11.2117 6.47326 11.2117ZM8.86908 6.26646L7.8127 8.85969H9.94971L8.88578 6.26646H8.86908ZM13.1945 11.1428C13.0108 11.1428 12.8689 11.0939 12.7687 10.9963C12.6741 10.8929 12.6268 10.7465 12.6268 10.5569V5.65477C12.6268 5.46523 12.6741 5.32164 12.7687 5.224C12.8689 5.12062 13.0108 5.06892 13.1945 5.06892H15.1979C15.6097 5.06892 15.9604 5.1321 16.2498 5.25846C16.5391 5.38482 16.759 5.56575 16.9092 5.80123C17.065 6.03672 17.143 6.31815 17.143 6.64554C17.143 7.01313 17.04 7.32328 16.8341 7.576C16.678 7.76761 16.4786 7.91135 16.2361 8.00721C16.532 8.08942 16.7703 8.23286 16.951 8.43754C17.1791 8.696 17.2932 9.032 17.2932 9.44554C17.2932 9.98544 17.1151 10.4047 16.759 10.7034C16.4084 10.9963 15.9186 11.1428 15.2898 11.1428H13.1945ZM13.6536 10.3071H15.1562C15.5346 10.3071 15.8129 10.2324 15.991 10.0831C16.169 9.928 16.2581 9.69826 16.2581 9.39385C16.2581 9.08369 16.169 8.85395 15.991 8.70462C15.8129 8.55528 15.5346 8.48062 15.1562 8.48062H13.6536V10.3071ZM13.6536 7.64492H15.0143C15.3816 7.64492 15.6542 7.57313 15.8324 7.42954C16.016 7.28021 16.1078 7.06195 16.1078 6.77477C16.1078 6.48759 16.016 6.27221 15.8324 6.12862C15.6542 5.97928 15.3816 5.90462 15.0143 5.90462H13.6536V7.64492Z"
          fill="black"
        />
        <path
          d="M19.66 15.7622C19.5378 15.0929 19.1954 14.5638 18.6328 14.1749C18.0702 13.786 17.4543 13.6527 16.785 13.7748C16.1157 13.897 15.5866 14.2394 15.1977 14.802C14.8088 15.3646 14.6754 15.9805 14.7976 16.6498C14.9198 17.3191 15.2622 17.8482 15.8248 18.2371C16.3873 18.626 17.0033 18.7594 17.6726 18.6372C18.3419 18.515 18.871 18.1726 19.2599 17.61C19.6488 17.0475 19.7821 16.4315 19.66 15.7622ZM23.2627 19.7701C23.297 19.9582 23.258 20.1335 23.1456 20.2961C23.0332 20.4587 22.883 20.5571 22.6948 20.5915C22.4995 20.6271 22.3241 20.5881 22.1688 20.4744L19.9686 18.9583C19.4029 19.5251 18.7221 19.8812 17.9262 20.0265C17.4088 20.1209 16.8958 20.1108 16.387 19.9962C15.8782 19.8816 15.4217 19.6846 15.0174 19.4051C14.6131 19.1256 14.2675 18.7681 13.9805 18.3327C13.6935 17.8972 13.5028 17.4208 13.4084 16.9034C13.3139 16.3861 13.324 15.873 13.4386 15.3642C13.5532 14.8555 13.7502 14.3989 14.0297 13.9946C14.3092 13.5903 14.6667 13.2447 15.1021 12.9577C15.5376 12.6707 16.014 12.48 16.5314 12.3856C17.0487 12.2912 17.5618 12.3012 18.0706 12.4158C18.5793 12.5304 19.0359 12.7275 19.4402 13.007C19.8445 13.2864 20.1901 13.6439 20.4771 14.0794C20.7641 14.5148 20.9548 14.9913 21.0492 15.5086C21.1945 16.3045 21.102 17.0672 20.7716 17.7967L22.9727 19.3183C23.131 19.4277 23.2277 19.5783 23.2627 19.7701Z"
          fill="black"
        />
        <path
          d="M19.66 15.7622C19.5378 15.0929 19.1954 14.5638 18.6328 14.1749C18.0702 13.786 17.4543 13.6527 16.785 13.7748C16.1157 13.897 15.5866 14.2394 15.1977 14.802C14.8088 15.3646 14.6754 15.9805 14.7976 16.6498C14.9198 17.3191 15.2622 17.8482 15.8248 18.2371C16.3873 18.626 17.0033 18.7594 17.6726 18.6372C18.3419 18.515 18.871 18.1726 19.2599 17.61C19.6488 17.0475 19.7821 16.4315 19.66 15.7622Z"
          fill="#F5F5F5"
        />
      </svg>
    </>
  );
}
export function BackButtonWithCircle(props: { col?: string }) {
  const { col = "#595959" } = props || {};
  return (
    <>
      <svg viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.4">
          <circle
            cx="21"
            cy="21"
            r="20"
            // fill="#F8F8F8"
            stroke={col}
            strokeWidth="2"
          />
          <path
            d="M9.29289 20.2929C8.90237 20.6834 8.90237 21.3166 9.29289 21.7071L15.6569 28.0711C16.0474 28.4616 16.6805 28.4616 17.0711 28.0711C17.4616 27.6805 17.4616 27.0474 17.0711 26.6569L11.4142 21L17.0711 15.3431C17.4616 14.9526 17.4616 14.3195 17.0711 13.9289C16.6805 13.5384 16.0474 13.5384 15.6569 13.9289L9.29289 20.2929ZM32 20H10V22H32V20Z"
            fill={col}
          />
        </g>
      </svg>
    </>
  );
}
export function IconT(props: { col?: string }) {
  const { col = "white" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
      >
        <path
          d="M17.6621 14.32H44.7941V22.633H43.4681L41.9891 17.278C41.8871 16.87 41.7681 16.581 41.6321 16.411C41.5301 16.207 41.3091 16.088 40.9691 16.054C40.6291 15.986 40.0511 15.952 39.2351 15.952H33.4721V44.869C33.4721 46.059 33.5231 46.756 33.6251 46.96C33.7271 47.164 34.0501 47.3 34.5941 47.368L37.3991 47.674V49H25.1081V47.674L27.9131 47.368C28.4571 47.3 28.7801 47.164 28.8821 46.96C28.9841 46.756 29.0351 46.059 29.0351 44.869V15.952H23.2211C22.4391 15.952 21.8611 15.986 21.4871 16.054C21.1471 16.088 20.9091 16.207 20.7731 16.411C20.6711 16.581 20.5691 16.87 20.4671 17.278L18.9881 22.633H17.6621V14.32Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconUpload2(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 35 35"
        fill="none"
      >
        <path
          d="M4.375 35C3.17188 35 2.14157 34.5712 1.28407 33.7137C0.426566 32.8563 -0.00145462 31.8267 3.71392e-06 30.625V24.0625H4.375V30.625H30.625V24.0625H35V30.625C35 31.8281 34.5713 32.8584 33.7138 33.7159C32.8563 34.5734 31.8267 35.0015 30.625 35H4.375ZM15.3125 26.25V8.42187L9.625 14.1094L6.5625 10.9375L17.5 0L28.4375 10.9375L25.375 14.1094L19.6875 8.42187V26.25H15.3125Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function IconRight(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
      >
        <path
          d="M47.354 14.6879C48.2627 15.5967 48.2627 17.07 47.354 17.9787L23.8278 41.5049C22.2657 43.067 19.733 43.067 18.1709 41.5049L9.81202 33.146C8.90296 32.2369 8.90296 30.7631 9.81202 29.854C10.7203 28.9457 12.1926 28.9448 13.102 29.852L20.2926 37.025C20.6831 37.4145 21.3154 37.4143 21.7056 37.0244L44.064 14.6872C44.9728 13.7792 46.4455 13.7795 47.354 14.6879Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function IconSubjectName(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M10.375 4.125H10.75C10.8881 4.125 11 4.23693 11 4.375V10.75C11 10.8881 10.8881 11 10.75 11H6.72855C6.66225 11 6.59866 10.9737 6.55178 10.9268L6 10.375M10.375 4.125V9.75M10.375 4.125V3.75C10.375 3.61193 10.2631 3.5 10.125 3.5H9.75M6 10.375L5.44822 10.9268C5.40134 10.9737 5.33775 11 5.27145 11H1.25C1.11193 11 1 10.8881 1 10.75V9.75M6 10.375C5.16667 9.95833 4.75 9.125 1.625 9.75M6 10.375C6.83333 9.95833 7.25 9.125 10.375 9.75M6 10.375H1.875C1.73693 10.375 1.625 10.2631 1.625 10.125V9.75M6 10.375H10.125C10.2631 10.375 10.375 10.2631 10.375 10.125V9.75M6 10.375C6 8.9694 8.19525 8.55165 9.50009 8.50464C9.63807 8.49967 9.75 8.38807 9.75 8.25V5.375M6 10.375C6 8.94639 4.11024 7.78234 3.03046 7.31481C2.93665 7.2742 2.875 7.18297 2.875 7.08074V3.5M6 10.375C5.79561 9.14866 5.99226 7.92233 3.63909 6.69599C3.55512 6.65223 3.5 6.56518 3.5 6.47049V2.25M6 10.375V4.125M1 9.125V4.375C1 4.23693 1.11193 4.125 1.25 4.125H1.625M1.625 4.125V9.75M1.625 4.125V4.00769C1.625 3.89298 1.70307 3.79298 1.81437 3.76516L2.875 3.5M3.5 2.25L3.30178 2.05178C3.14429 1.89429 2.875 2.00583 2.875 2.22855V3.5M3.5 2.25V1.34686C3.5 1.17622 3.6675 1.05585 3.82497 1.12158C5.44794 1.79896 6 3.146 6 4.125M9.75 4.75V3.5M6 4.125C6.60182 3.52318 8.36263 2.34187 9.60843 2.81307C9.697 2.84657 9.75 2.93482 9.75 3.02951V3.5"
          stroke="#3174F3"
          strokeWidth="0.25"
        />
      </svg>
    </>
  );
}
export function IconTestParent(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M23.7962 5.87867H20.7063V5.85519C20.7063 5.45376 20.3732 5.1272 19.9638 5.1272H18.0236V5.10372C18.0236 4.49512 17.5186 4 16.8978 4H15.3649C14.7441 4 14.2391 4.49512 14.2391 5.10372V5.1272H12.2989C11.8895 5.1272 11.5564 5.45376 11.5564 5.85519V5.87867H8.46649C7.4231 5.87867 6.57422 6.71092 6.57422 7.73386V26.1448C6.57422 27.1677 7.4231 28 8.46649 28H23.7962C24.8396 28 25.6885 27.1677 25.6885 26.1448V7.73386C25.6885 6.71092 24.8396 5.87867 23.7962 5.87867ZM20.3469 8.08611H23.413C23.4262 8.08611 23.4369 8.09663 23.4369 8.10959V25.7691C23.4369 25.782 23.4262 25.7926 23.413 25.7926H8.84973C8.83651 25.7926 8.82578 25.782 8.82578 25.7691V8.10959C8.82578 8.09663 8.83651 8.08611 8.84973 8.08611H11.9157C11.92 8.08611 11.9241 8.08564 11.9283 8.08549C12.2734 8.54145 12.8264 8.83757 13.4487 8.83757H18.8141C19.4364 8.83757 19.9893 8.54145 20.3344 8.08549C20.3386 8.08564 20.3427 8.08611 20.3469 8.08611ZM14.9577 5.10372C14.9577 4.88359 15.1403 4.7045 15.3649 4.7045H16.8978C17.1224 4.7045 17.305 4.88359 17.305 5.10372V5.1272H14.9577V5.10372ZM12.275 5.85519C12.275 5.84222 12.2857 5.8317 12.2989 5.8317H19.9638C19.977 5.8317 19.9878 5.84222 19.9878 5.85519V6.2282C19.9878 6.22914 19.9876 6.23003 19.9876 6.23092C19.9876 6.23181 19.9878 6.23275 19.9878 6.23364V6.98239C19.9878 7.61686 19.4612 8.13307 18.8141 8.13307H13.4487C12.8015 8.13307 12.275 7.61686 12.275 6.98239V5.85519ZM24.9699 26.1448C24.9699 26.7793 24.4434 27.2955 23.7962 27.2955H8.46649C7.81933 27.2955 7.2928 26.7793 7.2928 26.1448V7.73386C7.2928 7.09938 7.81933 6.58317 8.46649 6.58317H11.5564V6.98239C11.5564 7.11944 11.5721 7.25292 11.601 7.3816H8.84973C8.44028 7.3816 8.10719 7.70816 8.10719 8.10959V25.7691C8.10719 26.1705 8.44028 26.4971 8.84973 26.4971H23.413C23.8224 26.4971 24.1555 26.1705 24.1555 25.7691V8.10959C24.1555 7.70816 23.8224 7.3816 23.413 7.3816H20.6617C20.6907 7.25292 20.7063 7.11944 20.7063 6.98239V6.58317H23.7962C24.4434 6.58317 24.9699 7.09938 24.9699 7.73386V26.1448Z"
          fill={col}
        />
        <path
          d="M10.8134 14.0978H13.7836C14.0081 14.0978 14.1908 13.9187 14.1908 13.6986V10.7867C14.1908 10.5665 14.0081 10.3875 13.7836 10.3875H10.8134C10.5889 10.3875 10.4062 10.5665 10.4062 10.7867V13.6986C10.4062 13.9187 10.5889 14.0978 10.8134 14.0978ZM11.1248 11.092H13.4722V13.3933H11.1248V11.092Z"
          fill={col}
        />
        <path
          d="M13.7836 20.1565H10.8134C10.5889 20.1565 10.4062 20.3356 10.4062 20.5557V23.4676C10.4062 23.6878 10.5889 23.8669 10.8134 23.8669H13.7836C14.0081 23.8669 14.1908 23.6878 14.1908 23.4676V20.5557C14.1908 20.3356 14.0081 20.1565 13.7836 20.1565ZM13.4722 23.1624H11.1248V20.861H13.4722V23.1624Z"
          fill={col}
        />
        <path
          d="M14.3439 15.3754L14.0856 15.6286C13.9559 15.4157 13.7192 15.2722 13.4482 15.2722H11.1488C10.7393 15.2722 10.4062 15.5988 10.4062 16.0002V18.2546C10.4062 18.656 10.7393 18.9826 11.1488 18.9826H13.4482C13.8577 18.9826 14.1908 18.656 14.1908 18.2546V17.8789C14.1908 17.6843 14.0299 17.5266 13.8315 17.5266C13.6331 17.5266 13.4722 17.6843 13.4722 17.8789V18.2546C13.4722 18.2676 13.4615 18.2781 13.4482 18.2781H11.1488C11.1356 18.2781 11.1248 18.2676 11.1248 18.2546V16.0002C11.1248 15.9872 11.1356 15.9767 11.1488 15.9767H13.4482C13.4615 15.9767 13.4722 15.9872 13.4722 16.0002V16.2301L12.6818 17.005L12.1693 16.5026C12.029 16.365 11.8015 16.365 11.6612 16.5026C11.5209 16.6402 11.5209 16.8632 11.6612 17.0007L12.4277 17.7522C12.4979 17.821 12.5898 17.8554 12.6818 17.8554C12.7737 17.8554 12.8657 17.821 12.9358 17.7522L14.0855 16.625L14.0856 16.625L14.852 15.8735C14.9923 15.736 14.9923 15.513 14.852 15.3754C14.7118 15.2378 14.4842 15.2378 14.3439 15.3754Z"
          fill={col}
        />
        <path
          d="M15.3632 11.4677H16.5129C16.7114 11.4677 16.8722 11.31 16.8722 11.1154C16.8722 10.9209 16.7114 10.7632 16.5129 10.7632H15.3632C15.1648 10.7632 15.0039 10.9209 15.0039 11.1154C15.0039 11.31 15.1648 11.4677 15.3632 11.4677Z"
          fill={col}
        />
        <path
          d="M15.0039 12.6186C15.0039 12.8131 15.1648 12.9709 15.3632 12.9709H21.1119C21.3103 12.9709 21.4711 12.8131 21.4711 12.6186C21.4711 12.4241 21.3103 12.2664 21.1119 12.2664H15.3632C15.1648 12.2664 15.0039 12.4241 15.0039 12.6186Z"
          fill={col}
        />
        <path
          d="M15.3632 16.7279H19.1956C19.3941 16.7279 19.5549 16.5702 19.5549 16.3757C19.5549 16.1812 19.3941 16.0234 19.1956 16.0234H15.3632C15.1648 16.0234 15.0039 16.1812 15.0039 16.3757C15.0039 16.5702 15.1648 16.7279 15.3632 16.7279Z"
          fill={col}
        />
        <path
          d="M21.1119 17.5266H15.3632C15.1648 17.5266 15.0039 17.6843 15.0039 17.8789C15.0039 18.0734 15.1648 18.2311 15.3632 18.2311H21.1119C21.3103 18.2311 21.4711 18.0734 21.4711 17.8789C21.4711 17.6843 21.3103 17.5266 21.1119 17.5266Z"
          fill={col}
        />
        <path
          d="M15.3632 21.6127H16.8962C17.0946 21.6127 17.2555 21.455 17.2555 21.2605C17.2555 21.0659 17.0946 20.9082 16.8962 20.9082H15.3632C15.1648 20.9082 15.0039 21.0659 15.0039 21.2605C15.0039 21.455 15.1648 21.6127 15.3632 21.6127Z"
          fill={col}
        />
        <path
          d="M21.1119 22.4109H15.3632C15.1648 22.4109 15.0039 22.5686 15.0039 22.7631C15.0039 22.9577 15.1648 23.1154 15.3632 23.1154H21.1119C21.3103 23.1154 21.4711 22.9577 21.4711 22.7631C21.4711 22.5686 21.3103 22.4109 21.1119 22.4109Z"
          fill={col}
        />
      </svg>
    </>
  );
}

export function IconClock() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0006 22.1666C17.0633 22.1666 21.1673 18.0626 21.1673 13C21.1673 7.93735 17.0633 3.83328 12.0006 3.83328C6.93803 3.83328 2.83398 7.93735 2.83398 13C2.83398 18.0626 6.93803 22.1666 12.0006 22.1666Z"
        fill="#2F88FF"
        stroke="#C1D5FB"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M11.8795 7.67679L11.8789 13.1812L15.7651 17.0673"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 4.5L5.5 2"
        stroke="#C1D5FB"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 4.5L18.5 2"
        stroke="#C1D5FB"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconClipBoard(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <g clipPath="url(#clip0_4756_24394)">
          <path
            d="M17.8462 4.909H15.5288V4.89139C15.5288 4.59032 15.279 4.3454 14.9719 4.3454H13.5167V4.32779C13.5167 3.87134 13.138 3.5 12.6724 3.5H11.5227C11.0571 3.5 10.6783 3.87134 10.6783 4.32779V4.3454H9.22322C8.91613 4.3454 8.66631 4.59032 8.66631 4.89139V4.909H6.34889C5.56635 4.909 4.92969 5.53319 4.92969 6.30039V20.1086C4.92969 20.8758 5.56635 21.5 6.34889 21.5H17.8462C18.6287 21.5 19.2654 20.8758 19.2654 20.1086V6.30039C19.2654 5.53319 18.6287 4.909 17.8462 4.909ZM15.2592 6.56458H17.5588C17.5687 6.56458 17.5767 6.57247 17.5767 6.58219V19.8268C17.5767 19.8365 17.5687 19.8444 17.5588 19.8444H6.63632C6.6264 19.8444 6.61836 19.8365 6.61836 19.8268V6.58219C6.61836 6.57247 6.6264 6.56458 6.63632 6.56458H8.93582C8.93902 6.56458 8.94211 6.56423 8.94527 6.56412C9.20407 6.90609 9.6188 7.12818 10.0855 7.12818H14.1096C14.5763 7.12818 14.991 6.90609 15.2498 6.56412C15.253 6.56423 15.2561 6.56458 15.2592 6.56458ZM11.2173 4.32779C11.2173 4.16269 11.3543 4.02838 11.5227 4.02838H12.6724C12.8408 4.02838 12.9778 4.16269 12.9778 4.32779V4.3454H11.2173V4.32779ZM9.20525 4.89139C9.20525 4.88167 9.2133 4.87378 9.22322 4.87378H14.9719C14.9818 4.87378 14.9898 4.88167 14.9898 4.89139V5.17115C14.9898 5.17185 14.9897 5.17252 14.9897 5.17319C14.9897 5.17386 14.9898 5.17456 14.9898 5.17523V5.73679C14.9898 6.21265 14.5949 6.5998 14.1096 6.5998H10.0855C9.60015 6.5998 9.20525 6.21265 9.20525 5.73679V4.89139ZM18.7265 20.1086C18.7265 20.5845 18.3316 20.9716 17.8462 20.9716H6.34889C5.86352 20.9716 5.46862 20.5845 5.46862 20.1086V6.30039C5.46862 5.82454 5.86352 5.43738 6.34889 5.43738H8.66631V5.73679C8.66631 5.83958 8.6781 5.93969 8.69976 6.0362H6.63632C6.32923 6.0362 6.07942 6.28112 6.07942 6.58219V19.8268C6.07942 20.1279 6.32923 20.3728 6.63632 20.3728H17.5588C17.8659 20.3728 18.1157 20.1279 18.1157 19.8268V6.58219C18.1157 6.28112 17.8659 6.0362 17.5588 6.0362H15.4953C15.517 5.93969 15.5288 5.83958 15.5288 5.73679V5.43738H17.8462C18.3316 5.43738 18.7265 5.82454 18.7265 6.30039V20.1086Z"
            fill={col}
          />
          <path
            d="M8.11008 11.0733H10.3377C10.5061 11.0733 10.6431 10.939 10.6431 10.7739V8.58994C10.6431 8.42484 10.5061 8.29053 10.3377 8.29053H8.11008C7.94169 8.29053 7.80469 8.42484 7.80469 8.58994V10.7739C7.80469 10.939 7.94169 11.0733 8.11008 11.0733ZM8.34362 8.8189H10.1042V10.5449H8.34362V8.8189Z"
            fill={col}
          />
          <path
            d="M10.3377 15.6172H8.11008C7.94169 15.6172 7.80469 15.7515 7.80469 15.9166V18.1006C7.80469 18.2657 7.94169 18.4 8.11008 18.4H10.3377C10.5061 18.4 10.6431 18.2657 10.6431 18.1006V15.9166C10.6431 15.7515 10.5061 15.6172 10.3377 15.6172ZM10.1042 17.8716H8.34362V16.1456H10.1042V17.8716Z"
            fill={col}
          />
          <path
            d="M10.758 12.0315L10.5642 12.2214C10.467 12.0617 10.2894 11.9541 10.0862 11.9541H8.36159C8.0545 11.9541 7.80469 12.199 7.80469 12.5001V14.1909C7.80469 14.492 8.0545 14.7369 8.36159 14.7369H10.0862C10.3933 14.7369 10.6431 14.492 10.6431 14.1909V13.9091C10.6431 13.7632 10.5224 13.6449 10.3736 13.6449C10.2248 13.6449 10.1042 13.7632 10.1042 13.9091V14.1909C10.1042 14.2006 10.0961 14.2085 10.0862 14.2085H8.36159C8.35167 14.2085 8.34362 14.2006 8.34362 14.1909V12.5001C8.34362 12.4904 8.35167 12.4825 8.36159 12.4825H10.0862C10.0961 12.4825 10.1042 12.4904 10.1042 12.5001V12.6725L9.51132 13.2537L9.12699 12.8769C9.02175 12.7737 8.85112 12.7737 8.74592 12.8769C8.64069 12.9801 8.64069 13.1473 8.74592 13.2505L9.32079 13.8141C9.37339 13.8657 9.44237 13.8915 9.51132 13.8915C9.58027 13.8915 9.64925 13.8657 9.70185 13.8141L10.5641 12.9687L10.5642 12.9687L11.139 12.4051C11.2443 12.3019 11.2443 12.1347 11.139 12.0315C11.0338 11.9283 10.8632 11.9283 10.758 12.0315Z"
            fill={col}
          />
          <path
            d="M11.5195 9.10064H12.3818C12.5306 9.10064 12.6512 8.98236 12.6512 8.83645C12.6512 8.69055 12.5306 8.57227 12.3818 8.57227H11.5195C11.3706 8.57227 11.25 8.69055 11.25 8.83645C11.25 8.98236 11.3706 9.10064 11.5195 9.10064Z"
            fill={col}
          />
          <path
            d="M11.25 9.96389C11.25 10.1098 11.3706 10.2281 11.5195 10.2281H15.831C15.9798 10.2281 16.1004 10.1098 16.1004 9.96389C16.1004 9.81799 15.9798 9.69971 15.831 9.69971H11.5195C11.3706 9.69971 11.25 9.81799 11.25 9.96389Z"
            fill={col}
          />
          <path
            d="M11.5195 13.046H14.3938C14.5426 13.046 14.6633 12.9277 14.6633 12.7818C14.6633 12.6359 14.5426 12.5176 14.3938 12.5176H11.5195C11.3706 12.5176 11.25 12.6359 11.25 12.7818C11.25 12.9277 11.3706 13.046 11.5195 13.046Z"
            fill={col}
          />
          <path
            d="M15.831 13.645H11.5195C11.3706 13.645 11.25 13.7633 11.25 13.9092C11.25 14.0551 11.3706 14.1734 11.5195 14.1734H15.831C15.9798 14.1734 16.1004 14.0551 16.1004 13.9092C16.1004 13.7633 15.9798 13.645 15.831 13.645Z"
            fill={col}
          />
          <path
            d="M11.5195 16.7095H12.6692C12.818 16.7095 12.9387 16.5912 12.9387 16.4453C12.9387 16.2994 12.818 16.1812 12.6692 16.1812H11.5195C11.3706 16.1812 11.25 16.2994 11.25 16.4453C11.25 16.5912 11.3706 16.7095 11.5195 16.7095Z"
            fill={col}
          />
          <path
            d="M15.831 17.3081H11.5195C11.3706 17.3081 11.25 17.4264 11.25 17.5723C11.25 17.7182 11.3706 17.8365 11.5195 17.8365H15.831C15.9798 17.8365 16.1004 17.7182 16.1004 17.5723C16.1004 17.4264 15.9798 17.3081 15.831 17.3081Z"
            fill={col}
          />
        </g>
        <defs>
          <clipPath id="clip0_4756_24394">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
export function IconViewTest(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
      >
        <path d="M-3 -1H21V23H-3V-1Z" fill="black" />
      </svg>
    </>
  );
}
export function IconBook(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M10.375 4.125H10.75C10.8881 4.125 11 4.23693 11 4.375V10.75C11 10.8881 10.8881 11 10.75 11H6.72855C6.66225 11 6.59866 10.9737 6.55178 10.9268L6 10.375M10.375 4.125V9.75M10.375 4.125V3.75C10.375 3.61193 10.2631 3.5 10.125 3.5H9.75M6 10.375L5.44822 10.9268C5.40134 10.9737 5.33775 11 5.27145 11H1.25C1.11193 11 1 10.8881 1 10.75V9.75M6 10.375C5.16667 9.95833 4.75 9.125 1.625 9.75M6 10.375C6.83333 9.95833 7.25 9.125 10.375 9.75M6 10.375H1.875C1.73693 10.375 1.625 10.2631 1.625 10.125V9.75M6 10.375H10.125C10.2631 10.375 10.375 10.2631 10.375 10.125V9.75M6 10.375C6 8.9694 8.19525 8.55165 9.50009 8.50464C9.63807 8.49967 9.75 8.38807 9.75 8.25V5.375M6 10.375C6 8.94639 4.11024 7.78234 3.03046 7.31481C2.93665 7.2742 2.875 7.18297 2.875 7.08074V3.5M6 10.375C5.79561 9.14866 5.99226 7.92233 3.63909 6.69599C3.55512 6.65223 3.5 6.56518 3.5 6.47049V2.25M6 10.375V4.125M1 9.125V4.375C1 4.23693 1.11193 4.125 1.25 4.125H1.625M1.625 4.125V9.75M1.625 4.125V4.00769C1.625 3.89298 1.70307 3.79298 1.81437 3.76516L2.875 3.5M3.5 2.25L3.30178 2.05178C3.14429 1.89429 2.875 2.00583 2.875 2.22855V3.5M3.5 2.25V1.34686C3.5 1.17622 3.6675 1.05585 3.82497 1.12158C5.44794 1.79896 6 3.146 6 4.125M9.75 4.75V3.5M6 4.125C6.60182 3.52318 8.36263 2.34187 9.60843 2.81307C9.697 2.84657 9.75 2.93482 9.75 3.02951V3.5"
          stroke={col}
          strokeWidth="0.25"
        />
      </svg>
    </>
  );
}
export function IconDownlaod(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M16.59 9H15V4C15 3.45 14.55 3 14 3H10C9.45 3 9 3.45 9 4V9H7.41C6.52 9 6.07 10.08 6.7 10.71L11.29 15.3C11.68 15.69 12.31 15.69 12.7 15.3L17.29 10.71C17.92 10.08 17.48 9 16.59 9ZM5 19C5 19.55 5.45 20 6 20H18C18.55 20 19 19.55 19 19C19 18.45 18.55 18 18 18H6C5.45 18 5 18.45 5 19Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function IconStudy(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M14 13.5V15.5M14 13.5H15.5M14 13.5L5 9M14 29.5L4.1382 24.5691C4.0535 24.5268 4 24.4402 4 24.3455V8.90451C4 8.71866 4.19558 8.59779 4.3618 8.6809L5 9M14 29.5H17M14 29.5V28M17 13.5V15.5M17 13.5H15.5M17 13.5L26 9M17 29.5L26.8618 24.5691C26.9465 24.5268 27 24.4402 27 24.3455V22M17 29.5V28M14 15.5H17M14 15.5V17M17 15.5V17M14 17H17M14 17V26.5M17 17V26.5M14 28H17M14 28V26.5M17 28V26.5M14 26.5H17M15.5 13.5C15.5 10.6032 19.8511 6.3078 22.2512 6.01573C22.3883 5.99905 22.5 6.11193 22.5 6.25V7.96399M15.5 13.5C15.5 11.5941 20.9489 8.02318 24.0577 7.54727C24.339 7.50422 24.615 7.61498 24.8162 7.81615L26 9M15.5 13.5C15.5 11.1778 11.287 6.32784 8.74923 6.01581C8.61219 5.99897 8.5 6.11193 8.5 6.25V7V8.43898M15.5 13.5C15.5 12.7235 14.0869 11.6016 12.2893 10.5M26 9L26.6382 8.6809C26.8044 8.59779 27 8.71866 27 8.90451V19M5 9L6.01436 7.98564C6.30694 7.69306 6.74981 7.61015 7.12556 7.7834C7.55105 7.97959 8.01532 8.20029 8.5 8.43898M8.5 8.43898C9.02391 8.69698 9.57167 8.976 10.1201 9.26778M15.5 19V24M25.5 14.8549V12.4308C25.5 12.2388 25.2926 12.1185 25.126 12.2137L18.626 15.928C18.5481 15.9725 18.5 16.0554 18.5 16.1451V18.5692C18.5 18.7612 18.7074 18.8815 18.874 18.7863L25.374 15.072C25.4519 15.0275 25.5 14.9446 25.5 14.8549Z"
          stroke={col}
          strokeWidth="0.75"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
}
export function IconDiary(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M16 10L14 8H5C4.72386 8 4.5 8.22386 4.5 8.5V25.5M16 10V27.5M16 10L18 8H27C27.2761 8 27.5 8.22386 27.5 8.5V25.5M16 27.5H5C4.72386 27.5 4.5 27.2761 4.5 27V25.5M16 27.5H27C27.2761 27.5 27.5 27.2761 27.5 27V25.5M16 27.5L14.5 25.5H4.5M16 27.5L17.5 25.5H27.5M18 13.5L19.5 15L20.8701 11.803C20.9489 11.6192 21.1297 11.5 21.3297 11.5H25.5M21 17.5H25.5M18 19.5H25.5M18 21.5H25.5M18 23.5H23.5M9.5 19.5H14M14 21.5H6.5M6.5 23.5H12M10.5 10.5H8.5M29.5 17V24M2.5 24V28.5C2.5 29.0523 2.94772 29.5 3.5 29.5H6.5M15 6L18 3"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M25.9976 15.4999C25.9976 15.776 25.7738 15.9999 25.4976 15.9999C25.2215 15.9999 24.9976 15.776 24.9976 15.4999C24.9976 15.2237 25.2215 14.9999 25.4976 14.9999C25.7738 14.9999 25.9976 15.2237 25.9976 15.4999Z"
          fill={col}
        />
        <path
          d="M24.5 15.4999C24.5 15.776 24.2761 15.9999 24 15.9999C23.7239 15.9999 23.5 15.776 23.5 15.4999C23.5 15.2237 23.7239 14.9999 24 14.9999C24.2761 14.9999 24.5 15.2237 24.5 15.4999Z"
          fill={col}
        />
        <path
          d="M20 17.4999C20 17.776 19.7761 17.9999 19.5 17.9999C19.2239 17.9999 19 17.776 19 17.4999C19 17.2237 19.2239 16.9999 19.5 16.9999C19.7761 16.9999 20 17.2237 20 17.4999Z"
          fill={col}
        />
        <path
          d="M7.5 10.5C7.5 10.7761 7.27614 11 7 11C6.72386 11 6.5 10.7761 6.5 10.5C6.5 10.2239 6.72386 10 7 10C7.27614 10 7.5 10.2239 7.5 10.5Z"
          fill={col}
        />
        <path
          d="M8.5 19.5C8.5 19.7761 8.27614 20 8 20C7.72386 20 7.5 19.7761 7.5 19.5C7.5 19.2239 7.72386 19 8 19C8.27614 19 8.5 19.2239 8.5 19.5Z"
          fill={col}
        />
        <path
          d="M19.5 2C19.5 2.27614 19.2761 2.5 19 2.5C18.7239 2.5 18.5 2.27614 18.5 2C18.5 1.72386 18.7239 1.5 19 1.5C19.2761 1.5 19.5 1.72386 19.5 2Z"
          fill={col}
        />
        <path
          d="M3 22.5C3 22.7761 2.77614 23 2.5 23C2.22386 23 2 22.7761 2 22.5C2 22.2239 2.22386 22 2.5 22C2.77614 22 3 22.2239 3 22.5Z"
          fill={col}
        />
        <path
          d="M25.9976 15.4999C25.9976 15.776 25.7738 15.9999 25.4976 15.9999C25.2215 15.9999 24.9976 15.776 24.9976 15.4999C24.9976 15.2237 25.2215 14.9999 25.4976 14.9999C25.7738 14.9999 25.9976 15.2237 25.9976 15.4999Z"
          stroke="#D9D9D9"
        />
        <path
          d="M24.5 15.4999C24.5 15.776 24.2761 15.9999 24 15.9999C23.7239 15.9999 23.5 15.776 23.5 15.4999C23.5 15.2237 23.7239 14.9999 24 14.9999C24.2761 14.9999 24.5 15.2237 24.5 15.4999Z"
          stroke="#D9D9D9"
        />
        <path
          d="M20 17.4999C20 17.776 19.7761 17.9999 19.5 17.9999C19.2239 17.9999 19 17.776 19 17.4999C19 17.2237 19.2239 16.9999 19.5 16.9999C19.7761 16.9999 20 17.2237 20 17.4999Z"
          stroke="#D9D9D9"
        />
        <path
          d="M7.5 10.5C7.5 10.7761 7.27614 11 7 11C6.72386 11 6.5 10.7761 6.5 10.5C6.5 10.2239 6.72386 10 7 10C7.27614 10 7.5 10.2239 7.5 10.5Z"
          stroke="#D9D9D9"
        />
        <path
          d="M8.5 19.5C8.5 19.7761 8.27614 20 8 20C7.72386 20 7.5 19.7761 7.5 19.5C7.5 19.2239 7.72386 19 8 19C8.27614 19 8.5 19.2239 8.5 19.5Z"
          stroke="#D9D9D9"
        />
        <path
          d="M19.5 2C19.5 2.27614 19.2761 2.5 19 2.5C18.7239 2.5 18.5 2.27614 18.5 2C18.5 1.72386 18.7239 1.5 19 1.5C19.2761 1.5 19.5 1.72386 19.5 2Z"
          stroke="#D9D9D9"
        />
        <path
          d="M3 22.5C3 22.7761 2.77614 23 2.5 23C2.22386 23 2 22.7761 2 22.5C2 22.2239 2.22386 22 2.5 22C2.77614 22 3 22.2239 3 22.5Z"
          stroke="#D9D9D9"
        />
        <path
          d="M10.5 13.5L12.5 15.5L21.7259 6.27407L19.709 4.29097L10.5 13.5Z"
          fill="white"
        />
        <path
          d="M10.5 13.5L12.5 15.5M10.5 13.5L9.65811 16.0257C9.59297 16.2211 9.7789 16.407 9.97434 16.3419L12.5 15.5M10.5 13.5L19.709 4.29097M12.5 15.5L21.7259 6.27407M21.7259 6.27407L19.709 4.29097M21.7259 6.27407L23.1206 4.87937M19.709 4.29097L21.0868 2.91318M23.1206 4.87937L24.6464 3.35355C24.8417 3.15829 24.8417 2.84171 24.6464 2.64645L23.3536 1.35355C23.1583 1.15829 22.8417 1.15829 22.6464 1.35355L21.0868 2.91318M23.1206 4.87937L21.0868 2.91318"
          stroke={col}
          strokeLinecap="round"
        />
      </svg>
    </>
  );
}
export function IconPlus(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 47 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M34.8619 22.1354H11.6206C10.8265 22.1354 10.168 21.5451 10.168 20.8333C10.168 20.1215 10.8265 19.5312 11.6206 19.5312H34.8619C35.656 19.5312 36.3145 20.1215 36.3145 20.8333C36.3145 21.5451 35.656 22.1354 34.8619 22.1354Z"
          fill="#2289E9"
        />
        ;
        <path
          d="M23.2416 32.5522C22.4476 32.5522 21.7891 31.962 21.7891 31.2502V10.4168C21.7891 9.70502 22.4476 9.11475 23.2416 9.11475C24.0357 9.11475 24.6942 9.70502 24.6942 10.4168V31.2502C24.6942 31.962 24.0357 32.5522 23.2416 32.5522Z"
          fill="#2289E9"
        />
        ;
      </svg>
    </>
  );
}
export function IconCross(props: { col?: string }) {
  const { col = "#525252" } = props || {};
  return (
    <svg
      width={"40"}
      height={"40"}
      viewBox="0 0 43 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0771 31.5005L32.0771 10.5005"
        stroke={col}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M32.0762 31.501L11.0762 10.501"
        stroke={col}
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}
export function EditIcon(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      height={20}
      width={20}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H13.75C14.2625 1.5625 14.6875 1.9875 14.6875 2.5C14.6875 3.0125 14.2625 3.4375 13.75 3.4375H11.25C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V16.25C26.5625 15.7375 26.9875 15.3125 27.5 15.3125C28.0125 15.3125 28.4375 15.7375 28.4375 16.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375Z"
        fill={col}
      />
      ;
      <path
        d="M10.625 22.1127C9.86254 22.1127 9.16254 21.8377 8.65004 21.3377C8.03754 20.7252 7.77504 19.8377 7.91254 18.9002L8.45004 15.1377C8.55004 14.4127 9.02504 13.4752 9.53754 12.9627L19.3875 3.1127C21.875 0.625195 24.4 0.625195 26.8875 3.1127C28.25 4.4752 28.8625 5.8627 28.7375 7.2502C28.625 8.3752 28.025 9.47519 26.8875 10.6002L17.0375 20.4502C16.525 20.9627 15.5875 21.4377 14.8625 21.5377L11.1 22.0752C10.9375 22.1127 10.775 22.1127 10.625 22.1127ZM20.7125 4.4377L10.8625 14.2877C10.625 14.5252 10.35 15.0752 10.3 15.4002L9.76254 19.1627C9.71254 19.5252 9.78754 19.8252 9.97504 20.0127C10.1625 20.2002 10.4625 20.2752 10.825 20.2252L14.5875 19.6877C14.9125 19.6377 15.475 19.3627 15.7 19.1252L25.55 9.2752C26.3625 8.4627 26.7875 7.7377 26.85 7.0627C26.925 6.2502 26.5 5.3877 25.55 4.4252C23.55 2.4252 22.175 2.9877 20.7125 4.4377Z"
        fill={col}
      />
      ;
      <path
        d="M24.8124 12.2873C24.7249 12.2873 24.6374 12.2748 24.5624 12.2498C21.2749 11.3248 18.6624 8.71235 17.7374 5.42485C17.5999 4.92485 17.8874 4.41235 18.3874 4.26235C18.8874 4.12485 19.3999 4.41235 19.5374 4.91235C20.2874 7.57485 22.3999 9.68735 25.0624 10.4374C25.5624 10.5749 25.8499 11.0998 25.7124 11.5998C25.5999 12.0248 25.2249 12.2873 24.8124 12.2873Z"
        fill={col}
      />
      ;
    </svg>
  );
}
export function IconManage(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "28" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M10.6693 14.0003L10.4693 13.0003C10.3359 12.9448 10.2108 12.8863 10.0939 12.825C9.97705 12.7637 9.85771 12.6888 9.73594 12.6003L8.76927 12.9003L8.1026 11.767L8.86927 11.1003C8.84705 10.9448 8.83594 10.8003 8.83594 10.667C8.83594 10.5337 8.84705 10.3892 8.86927 10.2337L8.1026 9.56699L8.76927 8.43366L9.73594 8.73366C9.85816 8.64477 9.97771 8.56988 10.0946 8.50899C10.2115 8.4481 10.3364 8.38966 10.4693 8.33366L10.6693 7.33366H12.0026L12.2026 8.33366C12.3359 8.38921 12.461 8.45033 12.5779 8.51699C12.6948 8.58366 12.8142 8.66699 12.9359 8.76699L13.9026 8.43366L14.5693 9.60032L13.8026 10.267C13.8248 10.4003 13.8359 10.5392 13.8359 10.6837C13.8359 10.8281 13.8248 10.967 13.8026 11.1003L14.5693 11.767L13.9026 12.9003L12.9359 12.6003C12.8137 12.6892 12.6944 12.7643 12.5779 12.8257C12.4615 12.887 12.3364 12.9452 12.2026 13.0003L12.0026 14.0003H10.6693ZM1.33594 13.3337V11.467C1.33594 11.1003 1.43038 10.7559 1.61927 10.4337C1.80816 10.1114 2.06927 9.86699 2.4026 9.70033C2.96927 9.41144 3.60816 9.16699 4.31927 8.96699C5.03038 8.76699 5.81371 8.66699 6.66927 8.66699H6.9026C6.96927 8.66699 7.03594 8.6781 7.1026 8.70033C6.78038 9.50033 6.64705 10.2948 6.7026 11.0837C6.75816 11.8725 7.02483 12.6225 7.5026 13.3337H1.33594ZM11.3359 12.0003C11.7026 12.0003 12.0166 11.8697 12.2779 11.6083C12.5393 11.347 12.6697 11.0332 12.6693 10.667C12.6693 10.3003 12.5386 9.98632 12.2773 9.72499C12.0159 9.46366 11.7022 9.33321 11.3359 9.33366C10.9693 9.33366 10.6553 9.46433 10.3939 9.72566C10.1326 9.98699 10.0022 10.3008 10.0026 10.667C10.0026 11.0337 10.1333 11.3477 10.3946 11.609C10.6559 11.8703 10.9697 12.0008 11.3359 12.0003ZM6.66927 8.00033C5.93594 8.00033 5.30816 7.73921 4.78594 7.21699C4.26372 6.69477 4.0026 6.06699 4.0026 5.33366C4.0026 4.60033 4.26372 3.97255 4.78594 3.45033C5.30816 2.9281 5.93594 2.66699 6.66927 2.66699C7.4026 2.66699 8.03038 2.9281 8.5526 3.45033C9.07483 3.97255 9.33594 4.60033 9.33594 5.33366C9.33594 6.06699 9.07483 6.69477 8.5526 7.21699C8.03038 7.73921 7.4026 8.00033 6.66927 8.00033Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconCalender(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M14.625 3H12.375V1.875C12.375 1.77554 12.3355 1.68016 12.2652 1.60984C12.1948 1.53951 12.0995 1.5 12 1.5C11.9005 1.5 11.8052 1.53951 11.7348 1.60984C11.6645 1.68016 11.625 1.77554 11.625 1.875V3H6.375V1.875C6.375 1.77554 6.33549 1.68016 6.26517 1.60984C6.19484 1.53951 6.09946 1.5 6 1.5C5.90054 1.5 5.80516 1.53951 5.73484 1.60984C5.66451 1.68016 5.625 1.77554 5.625 1.875V3H3.375C2.8779 3.0006 2.40133 3.19833 2.04983 3.54983C1.69833 3.90133 1.5006 4.3779 1.5 4.875V14.625C1.5006 15.1221 1.69833 15.5987 2.04983 15.9502C2.40133 16.3017 2.8779 16.4994 3.375 16.5H14.625C15.1222 16.4996 15.5988 16.3019 15.9504 15.9504C16.3019 15.5988 16.4996 15.1222 16.5 14.625V4.875C16.4996 4.37784 16.3019 3.90116 15.9504 3.54961C15.5988 3.19807 15.1222 3.0004 14.625 3ZM15.75 14.625C15.75 14.9234 15.6315 15.2095 15.4205 15.4205C15.2095 15.6315 14.9234 15.75 14.625 15.75H3.375C3.07663 15.75 2.79048 15.6315 2.5795 15.4205C2.36853 15.2095 2.25 14.9234 2.25 14.625V8.25H15.75V14.625ZM15.75 7.5H2.25V4.875C2.25 4.254 2.7525 3.75 3.375 3.75H5.625V4.875C5.625 4.97446 5.66451 5.06984 5.73484 5.14016C5.80516 5.21049 5.90054 5.25 6 5.25C6.09946 5.25 6.19484 5.21049 6.26517 5.14016C6.33549 5.06984 6.375 4.97446 6.375 4.875V3.75H11.625V4.875C11.625 4.97446 11.6645 5.06984 11.7348 5.14016C11.8052 5.21049 11.9005 5.25 12 5.25C12.0995 5.25 12.1948 5.21049 12.2652 5.14016C12.3355 5.06984 12.375 4.97446 12.375 4.875V3.75H14.625C14.9234 3.75 15.2095 3.86853 15.4205 4.0795C15.6315 4.29048 15.75 4.57663 15.75 4.875V7.5Z"
          fill="#3174F3"
        />
      </svg>
    </>
  );
}
export function IconGallery(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M3.75 15.75C3.3375 15.75 2.98425 15.603 2.69025 15.309C2.39625 15.015 2.2495 14.662 2.25 14.25V3.75C2.25 3.3375 2.397 2.98425 2.691 2.69025C2.985 2.39625 3.338 2.2495 3.75 2.25H14.25C14.6625 2.25 15.0158 2.397 15.3098 2.691C15.6038 2.985 15.7505 3.338 15.75 3.75V14.25C15.75 14.6625 15.603 15.0158 15.309 15.3098C15.015 15.6038 14.662 15.7505 14.25 15.75H3.75ZM3.75 14.25H14.25V3.75H3.75V14.25ZM4.5 12.75H13.5L10.6875 9L8.4375 12L6.75 9.75L4.5 12.75Z"
          fill="#3174F3"
        />
      </svg>
    </>
  );
}

export function IconTrash(props: { col?: string; size?: string }) {
  const { col = "#6A6A6A" } = props || {};
  const { size = "28" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M7 21C6.45 21 5.979 20.804 5.587 20.412C5.195 20.02 4.99933 19.5493 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.804 20.021 18.412 20.413C18.02 20.805 17.5493 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
          fill={col}
        />
      </svg>
    </>
  );
}

export function IconTestForFooter(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M23.7962 5.87867H20.7063V5.85519C20.7063 5.45376 20.3732 5.1272 19.9638 5.1272H18.0236V5.10372C18.0236 4.49512 17.5186 4 16.8978 4H15.3649C14.7441 4 14.2391 4.49512 14.2391 5.10372V5.1272H12.2989C11.8895 5.1272 11.5564 5.45376 11.5564 5.85519V5.87867H8.46649C7.4231 5.87867 6.57422 6.71092 6.57422 7.73386V26.1448C6.57422 27.1677 7.4231 28 8.46649 28H23.7962C24.8396 28 25.6885 27.1677 25.6885 26.1448V7.73386C25.6885 6.71092 24.8396 5.87867 23.7962 5.87867ZM20.3469 8.08611H23.413C23.4262 8.08611 23.4369 8.09663 23.4369 8.10959V25.7691C23.4369 25.782 23.4262 25.7926 23.413 25.7926H8.84973C8.83651 25.7926 8.82578 25.782 8.82578 25.7691V8.10959C8.82578 8.09663 8.83651 8.08611 8.84973 8.08611H11.9157C11.92 8.08611 11.9241 8.08564 11.9283 8.08549C12.2734 8.54145 12.8264 8.83757 13.4487 8.83757H18.8141C19.4364 8.83757 19.9893 8.54145 20.3344 8.08549C20.3386 8.08564 20.3427 8.08611 20.3469 8.08611ZM14.9577 5.10372C14.9577 4.88359 15.1403 4.7045 15.3649 4.7045H16.8978C17.1224 4.7045 17.305 4.88359 17.305 5.10372V5.1272H14.9577V5.10372ZM12.275 5.85519C12.275 5.84222 12.2857 5.8317 12.2989 5.8317H19.9638C19.977 5.8317 19.9878 5.84222 19.9878 5.85519V6.2282C19.9878 6.22914 19.9876 6.23003 19.9876 6.23092C19.9876 6.23181 19.9878 6.23275 19.9878 6.23364V6.98239C19.9878 7.61686 19.4612 8.13307 18.8141 8.13307H13.4487C12.8015 8.13307 12.275 7.61686 12.275 6.98239V5.85519ZM24.9699 26.1448C24.9699 26.7793 24.4434 27.2955 23.7962 27.2955H8.46649C7.81933 27.2955 7.2928 26.7793 7.2928 26.1448V7.73386C7.2928 7.09938 7.81933 6.58317 8.46649 6.58317H11.5564V6.98239C11.5564 7.11944 11.5721 7.25292 11.601 7.3816H8.84973C8.44028 7.3816 8.10719 7.70816 8.10719 8.10959V25.7691C8.10719 26.1705 8.44028 26.4971 8.84973 26.4971H23.413C23.8224 26.4971 24.1555 26.1705 24.1555 25.7691V8.10959C24.1555 7.70816 23.8224 7.3816 23.413 7.3816H20.6617C20.6907 7.25292 20.7063 7.11944 20.7063 6.98239V6.58317H23.7962C24.4434 6.58317 24.9699 7.09938 24.9699 7.73386V26.1448Z"
          fill={col}
        />
        <path
          d="M10.8134 14.0977H13.7836C14.0081 14.0977 14.1908 13.9186 14.1908 13.6985V10.7865C14.1908 10.5664 14.0081 10.3873 13.7836 10.3873H10.8134C10.5889 10.3873 10.4062 10.5664 10.4062 10.7865V13.6985C10.4062 13.9186 10.5889 14.0977 10.8134 14.0977ZM11.1248 11.0918H13.4722V13.3932H11.1248V11.0918Z"
          fill={col}
        />
        <path
          d="M13.7836 20.1564H10.8134C10.5889 20.1564 10.4062 20.3355 10.4062 20.5556V23.4675C10.4062 23.6877 10.5889 23.8667 10.8134 23.8667H13.7836C14.0081 23.8667 14.1908 23.6877 14.1908 23.4675V20.5556C14.1908 20.3355 14.0081 20.1564 13.7836 20.1564ZM13.4722 23.1622H11.1248V20.8609H13.4722V23.1622Z"
          fill={col}
        />
        <path
          d="M14.3439 15.3753L14.0856 15.6286C13.9559 15.4156 13.7192 15.2722 13.4482 15.2722H11.1488C10.7393 15.2722 10.4062 15.5987 10.4062 16.0001V18.2545C10.4062 18.656 10.7393 18.9825 11.1488 18.9825H13.4482C13.8577 18.9825 14.1908 18.656 14.1908 18.2545V17.8788C14.1908 17.6843 14.0299 17.5266 13.8315 17.5266C13.6331 17.5266 13.4722 17.6843 13.4722 17.8788V18.2545C13.4722 18.2675 13.4615 18.278 13.4482 18.278H11.1488C11.1356 18.278 11.1248 18.2675 11.1248 18.2545V16.0001C11.1248 15.9872 11.1356 15.9767 11.1488 15.9767H13.4482C13.4615 15.9767 13.4722 15.9872 13.4722 16.0001V16.23L12.6818 17.0049L12.1693 16.5025C12.029 16.365 11.8015 16.365 11.6612 16.5025C11.5209 16.6401 11.5209 16.8631 11.6612 17.0007L12.4277 17.7521C12.4979 17.8209 12.5898 17.8553 12.6818 17.8553C12.7737 17.8553 12.8657 17.8209 12.9358 17.7521L14.0855 16.625L14.0856 16.6249L14.852 15.8735C14.9923 15.7359 14.9923 15.5129 14.852 15.3753C14.7118 15.2378 14.4842 15.2378 14.3439 15.3753Z"
          fill={col}
        />
        <path
          d="M15.3632 11.4677H16.5129C16.7114 11.4677 16.8722 11.31 16.8722 11.1154C16.8722 10.9209 16.7114 10.7632 16.5129 10.7632H15.3632C15.1648 10.7632 15.0039 10.9209 15.0039 11.1154C15.0039 11.31 15.1648 11.4677 15.3632 11.4677Z"
          fill={col}
        />
        <path
          d="M15.0039 12.6185C15.0039 12.8131 15.1648 12.9708 15.3632 12.9708H21.1119C21.3103 12.9708 21.4711 12.8131 21.4711 12.6185C21.4711 12.424 21.3103 12.2663 21.1119 12.2663H15.3632C15.1648 12.2663 15.0039 12.424 15.0039 12.6185Z"
          fill={col}
        />
        <path
          d="M15.3632 16.7279H19.1956C19.3941 16.7279 19.5549 16.5702 19.5549 16.3757C19.5549 16.1812 19.3941 16.0234 19.1956 16.0234H15.3632C15.1648 16.0234 15.0039 16.1812 15.0039 16.3757C15.0039 16.5702 15.1648 16.7279 15.3632 16.7279Z"
          fill={col}
        />
        <path
          d="M21.1119 17.5266H15.3632C15.1648 17.5266 15.0039 17.6843 15.0039 17.8788C15.0039 18.0733 15.1648 18.2311 15.3632 18.2311H21.1119C21.3103 18.2311 21.4711 18.0733 21.4711 17.8788C21.4711 17.6843 21.3103 17.5266 21.1119 17.5266Z"
          fill={col}
        />
        <path
          d="M15.3632 21.6128H16.8962C17.0946 21.6128 17.2555 21.4551 17.2555 21.2605C17.2555 21.066 17.0946 20.9083 16.8962 20.9083H15.3632C15.1648 20.9083 15.0039 21.066 15.0039 21.2605C15.0039 21.4551 15.1648 21.6128 15.3632 21.6128Z"
          fill={col}
        />
        <path
          d="M21.1119 22.411H15.3632C15.1648 22.411 15.0039 22.5687 15.0039 22.7633C15.0039 22.9578 15.1648 23.1155 15.3632 23.1155H21.1119C21.3103 23.1155 21.4711 22.9578 21.4711 22.7633C21.4711 22.5687 21.3103 22.411 21.1119 22.411Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconExcercise(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M10.9023 17.6301C10.512 17.24 9.87931 17.2396 9.48852 17.6292L8.56766 18.5471L13.4879 23.4642L14.407 22.548C14.7985 22.1577 14.7989 21.5241 14.4079 21.1334L10.9023 17.6301Z"
          fill="white"
        />
        <path
          d="M9.40549 27.2931C9.79614 27.6835 10.4295 27.6835 10.8202 27.2931L13.4879 24.6271C13.8093 24.306 13.8093 23.7853 13.4879 23.4642L8.56766 18.5471C8.22979 18.2095 7.68198 18.2095 7.34411 18.5471L4.70624 21.1832C4.31559 21.5736 4.31559 22.2066 4.70624 22.597L9.40549 27.2931Z"
          fill="white"
        />
        <path
          d="M8.56766 18.5471V18.5471C8.22979 18.2095 7.68198 18.2095 7.34411 18.5471L4.70624 21.1832C4.31559 21.5736 4.31559 22.2066 4.70624 22.597L9.40549 27.2931C9.79614 27.6835 10.4295 27.6835 10.8202 27.2931L13.4879 24.6271C13.8093 24.306 13.8093 23.7853 13.4879 23.4642V23.4642M8.56766 18.5471L9.48852 17.6292C9.87931 17.2396 10.512 17.24 10.9023 17.6301L14.4079 21.1334C14.7989 21.5241 14.7985 22.1577 14.407 22.548L13.4879 23.4642M8.56766 18.5471L13.4879 23.4642"
          stroke={col}
        />
        <path
          d="M23.1227 21.3766L21.7459 22.749L24.097 23.3517L25.6711 21.7681L24.8939 19.5818L24.0083 20.4792L23.5655 20.9279L23.3441 21.1523L23.1227 21.3766Z"
          fill="white"
        />
        <path
          d="M19.5633 20.5464L21.7459 22.749L23.1227 21.3766L23.3441 21.1523L18.8952 16.5165L12.7271 10.3524L11.5653 9.17065L11.3419 9.39364L9.94871 10.7551L11.1307 11.9477L19.5633 20.5464Z"
          fill="white"
        />
        <path
          d="M24.8939 19.5818L13.1294 7.60978L12.2357 8.50171L11.7888 8.94767L11.5653 9.17065L12.7271 10.3524L18.8952 16.5165L23.3441 21.1523L23.5655 20.9279L24.0083 20.4792L24.8939 19.5818Z"
          fill="white"
        />
        <path
          d="M24.8939 19.5818L13.1294 7.60978M24.8939 19.5818L25.6711 21.7681M24.8939 19.5818L24.0083 20.4792L23.5655 20.9279L23.3441 21.1523M21.7459 22.749L19.5633 20.5464L11.1307 11.9477L9.94871 10.7551M21.7459 22.749L23.1227 21.3766L23.3441 21.1523M21.7459 22.749L24.097 23.3517M8.76668 9.56251L11.9224 6.38143M8.76668 9.56251L9.94871 10.7551M8.76668 9.56251L7.97897 8.76774M11.9224 6.38143L13.1294 7.60978M11.9224 6.38143L11.1735 5.6193M9.94871 10.7551L11.3419 9.39364L11.5653 9.17065M13.1294 7.60978L12.2357 8.50171L11.7888 8.94767L11.5653 9.17065M25.6711 21.7681L24.097 23.3517M25.6711 21.7681L26.3237 23.6042V23.6042C26.3768 23.7535 26.2415 23.9014 26.088 23.8621V23.8621L24.097 23.3517M11.5653 9.17065L12.7271 10.3524L18.8952 16.5165L23.3441 21.1523M7.97897 8.76774C7.108 7.88898 7.11373 6.47134 7.99177 5.59964M7.97897 8.76774V8.76774C7.108 7.88898 7.11373 6.47134 7.99177 5.59964V5.59964M7.99177 5.59964C8.87433 4.72345 10.3018 4.73228 11.1735 5.6193M7.99177 5.59964V5.59964C8.87433 4.72345 10.3018 4.73228 11.1735 5.6193V5.6193"
          stroke={col}
        />
        <path
          d="M15.9571 8.4104C16.4576 7.91024 17.269 7.91024 17.7695 8.4104C18.27 8.91056 18.27 9.72147 17.7695 10.2216L16.3696 11.6206C15.8691 12.1207 15.0577 12.1207 14.5572 11.6206C14.0567 11.1204 14.0567 10.3095 14.5572 9.80934L15.9571 8.4104Z"
          fill="white"
          stroke={col}
        />
        <path
          d="M18.4727 9.80926C18.9732 9.30911 19.7846 9.30911 20.2851 9.80926C20.7856 10.3094 20.7856 11.1203 20.2851 11.6205L18.3253 13.579C17.8248 14.0792 17.0134 14.0792 16.5129 13.579C16.0124 13.0789 16.0124 12.2679 16.5129 11.7678L18.4727 9.80926Z"
          fill="white"
          stroke={col}
        />
        <path
          d="M20.4375 11.7678C20.938 11.2676 21.7495 11.2676 22.25 11.7678C22.7504 12.2679 22.7504 13.0788 22.25 13.579L20.2901 15.5375C19.7897 16.0377 18.9782 16.0377 18.4777 15.5375C17.9772 15.0374 17.9772 14.2264 18.4777 13.7263L20.4375 11.7678Z"
          fill="white"
          stroke={col}
        />
        <path
          d="M21.9799 14.146C22.403 13.7231 23.0891 13.7231 23.5123 14.146C23.9355 14.5689 23.9355 15.2545 23.5123 15.6774L21.8325 17.3562C21.4093 17.7791 20.7232 17.7791 20.3 17.3562C19.8769 16.9333 19.8769 16.2476 20.3 15.8247L21.9799 14.146Z"
          fill="white"
          stroke={col}
        />
        <path
          d="M18.6024 21.5084C17.4305 22.6796 15.5304 22.6796 14.3584 21.5084L11.0754 18.2275L10.084 17.2368C8.91203 16.0656 8.91203 14.1668 10.084 12.9956L11.1326 11.9477L11.8505 11.2302C12.6335 10.4477 13.9036 10.4497 14.6842 11.2345L18.6398 15.2117C18.8766 15.4498 19.0452 15.7102 19.0538 16.0458C19.0621 16.364 18.7845 16.6708 18.4776 16.7558C17.252 17.095 15.3524 15.0801 14.4606 14.1517C14.3535 14.0402 14.177 14.0389 14.0666 14.1472C13.9563 14.2554 13.9562 14.4316 14.0536 14.5516C14.2753 14.8245 14.4063 15.0942 14.4705 15.3514L19.5651 20.5464L18.6024 21.5084Z"
          fill="white"
        />
        <path
          d="M11.0754 18.2275L14.3584 21.5084C15.5304 22.6796 17.4305 22.6796 18.6024 21.5084L19.5651 20.5464L14.4705 15.3514M11.0754 18.2275L10.084 17.2368C8.91203 16.0656 8.91203 14.1668 10.084 12.9956L11.1326 11.9477L11.8505 11.2302C12.6335 10.4477 13.9036 10.4497 14.6842 11.2345L18.6398 15.2117C18.8766 15.4498 19.0452 15.7102 19.0538 16.0458V16.0458C19.0621 16.364 18.7845 16.6708 18.4776 16.7558C17.252 17.095 15.3524 15.0801 14.4606 14.1517C14.3535 14.0402 14.177 14.0389 14.0666 14.1472V14.1472C13.9563 14.2554 13.9562 14.4316 14.0536 14.5516C14.2753 14.8245 14.4063 15.0942 14.4705 15.3514M11.0754 18.2275C11.7727 18.9244 12.6743 18.3138 13.0379 17.9214M13.8416 17.1129C14.0634 16.8703 14.6706 16.1534 14.4705 15.3514"
          stroke={col}
        />
      </svg>
    </>
  );
}
export function IconTeach(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M12.1569 7.00002C12.1569 8.16072 11.2528 9.07145 10.1742 9.07145C9.09551 9.07145 8.19141 8.16072 8.19141 7.00002C8.19141 5.83932 9.09551 4.92859 10.1742 4.92859C11.2528 4.92859 12.1569 5.83932 12.1569 7.00002Z"
          fill="white"
          stroke={col}
        />
        <path
          d="M24.2759 28H13.1034M4 28H7.31035M7.31035 28H10.2069M7.31035 28V21.1429M7.31035 14.2857V19.8572V21.1429M13.1034 28V15.2524C13.1034 14.481 13.9694 14.0265 14.6043 14.4649V14.4649C15.2437 14.9064 16.0024 15.1428 16.7794 15.1428H19.4803C20.072 15.1428 20.5517 14.6632 20.5517 14.0714V14.0714C20.5517 13.4797 20.072 13 19.4803 13H18.6731C17.5091 13 16.4258 12.4158 15.4402 11.7966C14.8844 11.4474 14.1987 11.1341 13.4101 10.9725C12.6791 10.8227 11.94 11.0659 11.3062 11.4597L10.7347 11.8148C10.4115 12.0157 10.0023 12.0157 9.67908 11.8148L8.69089 11.2008C8.32947 10.9762 7.91243 10.8571 7.4869 10.8571V10.8571C6.22709 10.8571 5.20582 11.8784 5.20582 13.1382V16V19.0383C5.20582 20.2006 6.14805 21.1429 7.31035 21.1429V21.1429M13.1034 28H10.2069M10.2069 28V19.4286M16.8276 9.57143H20.5517M16.8276 6.57143H23.8621M15.5862 19.4286H27C27.5523 19.4286 28 18.9809 28 18.4286V5C28 4.44771 27.5523 4 27 4H14.7586"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M20.5156 13L23.826 9.14288"
          stroke={col}
          strokeLinecap="round"
        />
      </svg>
    </>
  );
}
export function IconExpand(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 28 28"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.609 11.2716C27.3772 11.2716 28 11.846 28 12.5572V15.2823C28 15.9924 27.376 16.5679 26.609 16.5679H1.39096C0.622609 16.5679 0 15.9935 0 15.2823V12.5572C0 11.8471 0.624 11.2716 1.39096 11.2716H26.609ZM26.609 21.7037C27.3772 21.7037 28 22.2781 28 22.9893V25.7144C28 26.4245 27.376 27 26.609 27H1.39096C0.622609 27 0 26.4256 0 25.7144V22.9893C0 22.2792 0.624 21.7037 1.39096 21.7037H26.609ZM26.609 1C27.3772 1 28 1.57441 28 2.28556V5.01074C28 5.72076 27.376 6.2963 26.609 6.2963H1.39096C0.622609 6.2963 0 5.72189 0 5.01074V2.28556C0 1.57553 0.624 1 1.39096 1H26.609Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconCollapse(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 28 28"
        fill={col}
      >
        <path
          d="M5 23L23 5M5 5L23 23"
          stroke={col}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconVignamLogo(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="36"
        viewBox="0 0 31 36"
        fill="none"
      >
        <path
          d="M12.4601 25.6078C13.3915 28.4485 11.9932 31.2333 10.0587 33.46C8.39099 32.4638 0.386171 26.4282 0.052635 20.4511C-0.48102 15.4116 3.18788 11.1924 4.52202 10.4307C3.32129 17.5797 10.0587 18.2829 12.4601 25.6078Z"
          fill="#02214F"
        />
        <path
          d="M19.9248 15.8217C20.1553 17.568 18.3905 21.623 15.322 23.9669C16.6562 16.8179 7.85081 16.2905 7.58398 8.73124C8.71801 3.45733 12.7204 0.468791 13.9212 0C11.1862 8.26244 18.8575 7.73505 19.9248 15.8217Z"
          fill="#02214F"
        />
        <path
          d="M28.5275 28.2727C25.8592 33.3708 16.8538 36.5937 12.251 34.7185C17.4541 29.3274 18.5215 29.4446 21.7901 24.9911C25.1922 20.0102 23.5245 17.1389 22.6573 12.8611C20.7895 11.9236 33.4961 18.7796 28.5275 28.2727Z"
          fill="#02214F"
        />
        <path
          d="M21.2451 15.8217C21.4756 17.568 19.7109 21.623 16.6423 23.9669C17.9765 16.8179 9.17113 16.2905 8.9043 8.73124C10.0383 3.45733 14.0407 0.468791 15.2415 0C12.5065 8.26244 20.1778 7.73505 21.2451 15.8217Z"
          fill={col}
        />
        <path
          d="M13.6574 25.6078C14.5887 28.4485 13.1904 31.2333 11.2559 33.46C9.58826 32.4638 1.58344 26.4282 1.2499 20.4511C0.716246 15.4116 4.38514 11.1924 5.71928 10.4307C4.51855 17.5797 11.256 18.2829 13.6574 25.6078Z"
          fill={col}
        />
        <path
          d="M29.7883 28.3041C27.12 33.4022 18.1145 36.6252 13.5117 34.75C18.7149 29.3589 19.7822 29.4761 23.0508 25.0226C26.4529 20.0417 24.7852 17.1704 23.918 12.8926C22.0502 11.9551 34.7568 18.8111 29.7883 28.3041Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconListClass(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <rect x="5.5" y="4.5" width="20" height="23" rx="0.5" stroke={col} />
        <circle cx="16.0706" cy="7.48173" r="0.851852" stroke={col} />
        <circle cx="16.0706" cy="14.2962" r="0.851852" stroke={col} />
        <circle cx="16.0706" cy="21.1111" r="0.851852" stroke={col} />
        <path
          d="M11.8139 9.61122C11.8139 10.7874 10.8605 11.7408 9.68432 11.7408C8.50816 11.7408 7.55469 10.7874 7.55469 9.61122C7.55469 8.43506 8.50816 7.48159 9.68432 7.48159M8.83247 8.75937L9.346 9.52968C9.52103 9.79221 9.89247 9.82899 10.1156 9.60588L12.6658 7.05566"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M11.8139 16.4262C11.8139 17.6023 10.8605 18.5558 9.68432 18.5558C8.50816 18.5558 7.55469 17.6023 7.55469 16.4262C7.55469 15.25 8.50816 14.2965 9.68432 14.2965M8.83247 15.5743L9.346 16.3446C9.52103 16.6071 9.89247 16.6439 10.1156 16.4208L12.6658 13.8706"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M11.8139 23.2406C11.8139 24.4168 10.8605 25.3702 9.68432 25.3702C8.50816 25.3702 7.55469 24.4168 7.55469 23.2406C7.55469 22.0645 8.50816 21.111 9.68432 21.111M8.83247 22.3888L9.346 23.1591C9.52103 23.4216 9.89247 23.4584 10.1156 23.2353L12.6658 20.6851"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M16.0709 9.18506C15.13 9.18506 14.3672 9.75714 14.3672 10.4628C14.3672 11.1685 14.9393 11.7406 15.645 11.7406H16.0709H16.4968C17.2025 11.7406 17.7746 11.1685 17.7746 10.4628C17.7746 9.75714 17.0118 9.18506 16.0709 9.18506Z"
          stroke={col}
        />
        <path
          d="M16.0709 16C15.13 16 14.3672 16.5721 14.3672 17.2778C14.3672 17.9835 14.9393 18.5556 15.645 18.5556H16.0709H16.4968C17.2025 18.5556 17.7746 17.9835 17.7746 17.2778C17.7746 16.5721 17.0118 16 16.0709 16Z"
          stroke={col}
        />
        <path
          d="M16.0709 22.8149C15.13 22.8149 14.3672 23.387 14.3672 24.0927C14.3672 24.7984 14.9393 25.3705 15.645 25.3705H16.0709H16.4968C17.2025 25.3705 17.7746 24.7984 17.7746 24.0927C17.7746 23.387 17.0118 22.8149 16.0709 22.8149Z"
          stroke={col}
        />
        <path d="M19 9H23" stroke={col} strokeLinecap="round" />
        <path d="M19 16H23" stroke={col} strokeLinecap="round" />
        <path d="M19 23H23" stroke={col} strokeLinecap="round" />
        <path d="M19 11H24" stroke={col} strokeLinecap="round" />
        <path d="M19 18H24" stroke={col} strokeLinecap="round" />
        <path d="M19 25H24" stroke={col} strokeLinecap="round" />
      </svg>
    </>
  );
}
export function IconTickMark(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill={col}
      >
        <path
          d="M47.352 14.6878C48.2607 15.5965 48.2607 17.0699 47.352 17.9786L23.8258 41.5048C22.2637 43.0669 19.7311 43.0669 18.169 41.5048L9.81007 33.1459C8.90101 32.2368 8.901 30.7629 9.81007 29.8539C10.7183 28.9456 12.1907 28.9447 13.1001 29.8519L20.2906 37.0248C20.6812 37.4144 21.3134 37.4142 21.7036 37.0243L44.062 14.687C44.9709 13.7791 46.4436 13.7794 47.352 14.6878Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function IconCreateMessage(props: { col?: string; col1?: string }) {
  const { col = "black", col1 = "#6596F6" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M20 2H4C2.897 2 2 2.897 2 4V16C2 17.103 2.897 18 4 18H7V21.767L13.277 18H20C21.103 18 22 17.103 22 16V4C22 2.897 21.103 2 20 2ZM20 16H12.723L9 18.233V16H4V4H20V16Z"
          fill={col}
        />
        <path d="M11 14H13V11H16V9H13V6H11V9H8V11H11V14Z" fill={col1} />
      </svg>
    </>
  );
}
export function IconViewAll(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
      >
        <path
          d="M13.4419 5.44194C13.686 5.19787 13.686 4.80214 13.4419 4.55806L9.46447 0.580583C9.22039 0.336506 8.82466 0.336506 8.58058 0.580583C8.33651 0.824661 8.33651 1.22039 8.58058 1.46447L12.1161 5L8.58058 8.53553C8.3365 8.77961 8.3365 9.17534 8.58058 9.41942C8.82466 9.6635 9.22039 9.6635 9.46447 9.41942L13.4419 5.44194ZM-5.46392e-08 5.625L13 5.625L13 4.375L5.46392e-08 4.375L-5.46392e-08 5.625Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconPlayButton(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M10.9917 5.20659L4.23797 1.0755C4.09633 0.989152 3.93433 0.941933 3.76848 0.938659C3.60263 0.935385 3.43889 0.976174 3.29395 1.05686C3.14902 1.13755 3.02809 1.25525 2.94351 1.39794C2.85893 1.54063 2.81372 1.70322 2.8125 1.86909V10.1313C2.81372 10.2972 2.85893 10.4597 2.94351 10.6024C3.02809 10.7451 3.14902 10.8628 3.29395 10.9435C3.43889 11.0242 3.60263 11.065 3.76848 11.0617C3.93433 11.0584 4.09633 11.0112 4.23797 10.9249L10.9917 6.79378C11.1279 6.71088 11.2405 6.59433 11.3186 6.45535C11.3967 6.31636 11.4377 6.15961 11.4377 6.00018C11.4377 5.84075 11.3967 5.68401 11.3186 5.54502C11.2405 5.40604 11.1279 5.28949 10.9917 5.20659ZM3.9375 9.79003V2.21034L10.1325 6.00018L3.9375 9.79003Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconBackArrow(props: { col?: string }) {
  const { col = "black" } = props || {};
  // const { size = "black" } = props || {};
  return (
    <>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 23 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM23 7H1V9H23V7Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconDoubts(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M11 13H5C3.34315 13 2 14.3431 2 16V25C2 26.6569 3.34315 28 5 28H9L10.5548 29.9435C10.7024 30.128 11 30.0236 11 29.7873V28H17.5C19.1569 28 20.5 26.6569 20.5 25V21M4.5 17.5H13.5M4.5 20.5H17M4.5 23.5H14.5"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M17 23.5C17 23.7761 16.7761 24 16.5 24C16.2239 24 16 23.7761 16 23.5C16 23.2239 16.2239 23 16.5 23C16.7761 23 17 23.2239 17 23.5Z"
          fill={col}
        />
        <path
          d="M26.7383 17.5467L27.0658 17.9245L26.7383 17.5467C26.5759 17.6875 26.4775 17.8939 26.4775 18.1162V20.7697L24.9724 19.2239C24.763 19.0088 24.4514 18.9438 24.1789 19.0406C23.342 19.3379 22.4405 19.5 21.5 19.5C17.0817 19.5 13.5 15.9183 13.5 11.5C13.5 7.08172 17.0817 3.5 21.5 3.5C25.9183 3.5 29.5 7.08172 29.5 11.5C29.5 13.9147 28.4308 16.0791 26.7383 17.5467Z"
          stroke={col}
        />
        <path
          d="M22.003 14.5C22.003 14.7761 21.7792 15 21.503 15C21.2269 15 21.003 14.7761 21.003 14.5C21.003 14.2239 21.2269 14 21.503 14C21.7792 14 22.003 14.2239 22.003 14.5Z"
          fill={col}
        />
        <path
          d="M22.1517 7C23.0645 7 23.7938 7.23596 24.3397 7.70787C24.8945 8.17977 25.1719 8.82443 25.1719 9.64185C25.1719 10.493 24.8855 11.1334 24.3128 11.5632C23.7401 11.993 22.9795 12.2079 22.0309 12.2079L22.0276 12.6976C22.0258 12.9792 21.7969 13.2065 21.5153 13.2065C21.2324 13.2065 21.003 12.9771 21.003 12.6942V11.2219H22.0242C22.0242 11.2219 22.9637 11.0044 23.2927 10.6959C23.6216 10.3874 23.7088 9.64185 23.7088 9.64185C23.7088 9.19523 23.5701 8.84551 23.2927 8.5927C23.0242 8.33989 22.6484 8.21348 22.1652 8.21348C21.6819 8.21348 21.3016 8.33568 21.0242 8.58006C20.9161 8.67531 20.829 8.7853 20.7631 8.91C20.5776 9.26057 20.2866 9.60393 19.89 9.60393C19.4934 9.60393 19.1591 9.27672 19.2607 8.89334C19.3211 8.66539 19.4123 8.45141 19.5343 8.2514C19.7759 7.85534 20.1204 7.54775 20.5678 7.32865C21.0242 7.10955 21.5522 7 22.1517 7Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconHomework(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M16 10L14 8H5C4.72386 8 4.5 8.22386 4.5 8.5V25.5M16 10V27.5M16 10L18 8H27C27.2761 8 27.5 8.22386 27.5 8.5V25.5M16 27.5H5C4.72386 27.5 4.5 27.2761 4.5 27V25.5M16 27.5H27C27.2761 27.5 27.5 27.2761 27.5 27V25.5M16 27.5L14.5 25.5H4.5M16 27.5L17.5 25.5H27.5M18 13.5L19.5 15L20.8701 11.803C20.9489 11.6192 21.1297 11.5 21.3297 11.5H25.5M21 17.5H25.5M18 19.5H25.5M18 21.5H25.5M18 23.5H23.5M9.5 19.5H14M14 21.5H6.5M6.5 23.5H12M10.5 10.5H8.5M29.5 17V24M2.5 24V28.5C2.5 29.0523 2.94772 29.5 3.5 29.5H6.5M15 6L18 3"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M25.9976 15.4999C25.9976 15.776 25.7738 15.9999 25.4976 15.9999C25.2215 15.9999 24.9976 15.776 24.9976 15.4999C24.9976 15.2237 25.2215 14.9999 25.4976 14.9999C25.7738 14.9999 25.9976 15.2237 25.9976 15.4999Z"
          fill={col}
        />
        <path
          d="M24.5 15.4999C24.5 15.776 24.2761 15.9999 24 15.9999C23.7239 15.9999 23.5 15.776 23.5 15.4999C23.5 15.2237 23.7239 14.9999 24 14.9999C24.2761 14.9999 24.5 15.2237 24.5 15.4999Z"
          fill={col}
        />
        <path
          d="M20 17.4999C20 17.776 19.7761 17.9999 19.5 17.9999C19.2239 17.9999 19 17.776 19 17.4999C19 17.2237 19.2239 16.9999 19.5 16.9999C19.7761 16.9999 20 17.2237 20 17.4999Z"
          fill={col}
        />
        <path
          d="M7.5 10.5C7.5 10.7761 7.27614 11 7 11C6.72386 11 6.5 10.7761 6.5 10.5C6.5 10.2239 6.72386 10 7 10C7.27614 10 7.5 10.2239 7.5 10.5Z"
          fill={col}
        />
        <path
          d="M8.5 19.5C8.5 19.7761 8.27614 20 8 20C7.72386 20 7.5 19.7761 7.5 19.5C7.5 19.2239 7.72386 19 8 19C8.27614 19 8.5 19.2239 8.5 19.5Z"
          fill={col}
        />
        <path
          d="M19.5 2C19.5 2.27614 19.2761 2.5 19 2.5C18.7239 2.5 18.5 2.27614 18.5 2C18.5 1.72386 18.7239 1.5 19 1.5C19.2761 1.5 19.5 1.72386 19.5 2Z"
          fill={col}
        />
        <path
          d="M3 22.5C3 22.7761 2.77614 23 2.5 23C2.22386 23 2 22.7761 2 22.5C2 22.2239 2.22386 22 2.5 22C2.77614 22 3 22.2239 3 22.5Z"
          fill={col}
        />
        <path
          d="M25.9976 15.4999C25.9976 15.776 25.7738 15.9999 25.4976 15.9999C25.2215 15.9999 24.9976 15.776 24.9976 15.4999C24.9976 15.2237 25.2215 14.9999 25.4976 14.9999C25.7738 14.9999 25.9976 15.2237 25.9976 15.4999Z"
          stroke="#D9D9D9"
        />
        <path
          d="M24.5 15.4999C24.5 15.776 24.2761 15.9999 24 15.9999C23.7239 15.9999 23.5 15.776 23.5 15.4999C23.5 15.2237 23.7239 14.9999 24 14.9999C24.2761 14.9999 24.5 15.2237 24.5 15.4999Z"
          stroke="#D9D9D9"
        />
        <path
          d="M20 17.4999C20 17.776 19.7761 17.9999 19.5 17.9999C19.2239 17.9999 19 17.776 19 17.4999C19 17.2237 19.2239 16.9999 19.5 16.9999C19.7761 16.9999 20 17.2237 20 17.4999Z"
          stroke="#D9D9D9"
        />
        <path
          d="M7.5 10.5C7.5 10.7761 7.27614 11 7 11C6.72386 11 6.5 10.7761 6.5 10.5C6.5 10.2239 6.72386 10 7 10C7.27614 10 7.5 10.2239 7.5 10.5Z"
          stroke="#D9D9D9"
        />
        <path
          d="M8.5 19.5C8.5 19.7761 8.27614 20 8 20C7.72386 20 7.5 19.7761 7.5 19.5C7.5 19.2239 7.72386 19 8 19C8.27614 19 8.5 19.2239 8.5 19.5Z"
          stroke="#D9D9D9"
        />
        <path
          d="M19.5 2C19.5 2.27614 19.2761 2.5 19 2.5C18.7239 2.5 18.5 2.27614 18.5 2C18.5 1.72386 18.7239 1.5 19 1.5C19.2761 1.5 19.5 1.72386 19.5 2Z"
          stroke="#D9D9D9"
        />
        <path
          d="M3 22.5C3 22.7761 2.77614 23 2.5 23C2.22386 23 2 22.7761 2 22.5C2 22.2239 2.22386 22 2.5 22C2.77614 22 3 22.2239 3 22.5Z"
          stroke="#D9D9D9"
        />
        <path
          d="M10.5 13.5L12.5 15.5L21.7259 6.27407L19.709 4.29097L10.5 13.5Z"
          fill="white"
        />
        <path
          d="M10.5 13.5L12.5 15.5M10.5 13.5L9.65811 16.0257C9.59297 16.2211 9.7789 16.407 9.97434 16.3419L12.5 15.5M10.5 13.5L19.709 4.29097M12.5 15.5L21.7259 6.27407M21.7259 6.27407L19.709 4.29097M21.7259 6.27407L23.1206 4.87937M19.709 4.29097L21.0868 2.91318M23.1206 4.87937L24.6464 3.35355C24.8417 3.15829 24.8417 2.84171 24.6464 2.64645L23.3536 1.35355C23.1583 1.15829 22.8417 1.15829 22.6464 1.35355L21.0868 2.91318M23.1206 4.87937L21.0868 2.91318"
          stroke={col}
          strokeLinecap="round"
        />
      </svg>
    </>
  );
}
export function IconResult(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M11 13.5V9C11 8.72386 11.2245 8.49737 11.4992 8.52461C12.5709 8.63085 13.543 9.07542 14.3073 9.75M11 13.5H6.5C6.22386 13.5 5.99737 13.7245 6.02462 13.9993C6.27516 16.5263 8.40709 18.5 11 18.5C13.7614 18.5 16 16.2614 16 13.5C16 12.0066 15.3453 10.6662 14.3073 9.75M11 13.5L14.3073 9.75"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M8 7V6C8 5.44772 8.44772 5 9 5H23M23 5L27 9M23 5V8C23 8.55228 23.4477 9 24 9H27M27 9V27C27 27.5523 26.5523 28 26 28H9C8.44771 28 8 27.5523 8 27V23M19 11.5H25M19 13.5H25M19 15.5H22"
          stroke={col}
          strokeLinecap="round"
        />
        <path
          d="M24.5 15.5C24.5 15.7761 24.2761 16 24 16C23.7239 16 23.5 15.7761 23.5 15.5C23.5 15.2239 23.7239 15 24 15C24.2761 15 24.5 15.2239 24.5 15.5Z"
          fill={col}
        />
        <path
          d="M8.5 21.5C8.5 21.7761 8.27614 22 8 22C7.72386 22 7.5 21.7761 7.5 21.5C7.5 21.2239 7.72386 21 8 21C8.27614 21 8.5 21.2239 8.5 21.5Z"
          fill={col}
        />
        <path
          d="M11.5 25L15.5 21L20.5 25L24.5 20"
          stroke={col}
          strokeLinecap="round"
        />
        <circle
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="matrix(1 0 0 -1 10 26.5)"
          fill={col}
        />
        <path
          d="M12 25C12 25.2761 11.7761 25.5 11.5 25.5C11.2239 25.5 11 25.2761 11 25C11 24.7239 11.2239 24.5 11.5 24.5C11.7761 24.5 12 24.7239 12 25Z"
          fill="white"
        />
        <circle
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="matrix(1 0 0 -1 23 21.5)"
          fill={col}
        />
        <path
          d="M25 20C25 20.2761 24.7761 20.5 24.5 20.5C24.2239 20.5 24 20.2761 24 20C24 19.7239 24.2239 19.5 24.5 19.5C24.7761 19.5 25 19.7239 25 20Z"
          fill="white"
        />
        <circle
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="matrix(1 0 0 -1 19 26.5)"
          fill={col}
        />
        <path
          d="M21 25C21 25.2761 20.7761 25.5 20.5 25.5C20.2239 25.5 20 25.2761 20 25C20 24.7239 20.2239 24.5 20.5 24.5C20.7761 24.5 21 24.7239 21 25Z"
          fill="white"
        />
        <circle
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="matrix(1 0 0 -1 14 22.5)"
          fill={col}
        />
        <path
          d="M16 21C16 21.2761 15.7761 21.5 15.5 21.5C15.2239 21.5 15 21.2761 15 21C15 20.7239 15.2239 20.5 15.5 20.5C15.7761 20.5 16 20.7239 16 21Z"
          fill="white"
        />
        <path
          d="M9.5 12H4.52239C4.75988 9.36176 6.86176 7.25988 9.5 7.02239V12Z"
          stroke={col}
        />
      </svg>
    </>
  );
}
export function IconHome(props: {
  col?: string;
  size?: string;
  filled?: boolean;
}) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill={props.filled ? col : "none"}
      >
        <path
          d="M13.3307 18.1667H12.8307V18.6667V26.1667H7.16406V16V15.5H6.66406H3.96704L15.9974 4.67268L28.0278 15.5H25.3307H24.8307V16V26.1667H19.1641V18.6667V18.1667H18.6641H13.3307Z"
          stroke={col}
        />
      </svg>
    </>
  );
}

export function IconEdit(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          d="M9.36979 1.6665H7.66609C3.40683 1.6665 1.70312 3.33317 1.70312 7.49984V12.4998C1.70312 16.6665 3.40683 18.3332 7.66609 18.3332H12.7772C17.0365 18.3332 18.7402 16.6665 18.7402 12.4998V10.8332"
          stroke={col}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6669 2.51688L6.95426 9.08354C6.69871 9.33354 6.44315 9.82521 6.39204 10.1835L6.02574 12.6919C5.88945 13.6002 6.54537 14.2335 7.47389 14.1085L10.038 13.7502C10.3957 13.7002 10.8983 13.4502 11.1624 13.2002L17.875 6.63354C19.0335 5.50021 19.5787 4.18354 17.875 2.51688C16.1713 0.850211 14.8254 1.38354 13.6669 2.51688Z"
          stroke={col}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7031 3.4585C13.2739 5.45016 14.8668 7.0085 16.9113 7.57516"
          stroke={col}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconPenCursor(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 36 36"
        fill="none"
      >
        <path
          d="M16.9212 29.0883L30.2335 15.7759C27.9938 14.8408 25.9597 13.4746 24.2469 11.7549C22.5264 10.0417 21.1595 8.007 20.2241 5.76649L6.91174 19.0788C5.87318 20.1174 5.353 20.6376 4.90662 21.2099C4.37943 21.8854 3.92738 22.6163 3.55846 23.3897C3.24708 24.0448 3.01488 24.7432 2.5505 26.1364L0.0989884 33.4855C-0.0138429 33.822 -0.0305831 34.1833 0.050649 34.5288C0.131881 34.8742 0.307865 35.1902 0.558821 35.4412C0.809776 35.6921 1.12575 35.8681 1.47124 35.9494C1.81672 36.0306 2.17801 36.0138 2.5145 35.901L9.86364 33.4495C11.2586 32.9851 11.9552 32.7529 12.6103 32.4415C13.3843 32.0726 14.1151 31.6208 14.7901 31.0934C15.3624 30.647 15.8826 30.1268 16.9212 29.0883ZM33.927 12.0825C35.2543 10.7551 36 8.95488 36 7.07774C36 5.20061 35.2543 3.40036 33.927 2.07302C32.5996 0.745689 30.7994 1.39857e-08 28.9223 0C27.0451 -1.39857e-08 25.2449 0.745689 23.9175 2.07302L22.321 3.66957L22.3894 3.86936C23.1762 6.12057 24.4637 8.16383 26.1549 9.84514C27.8864 11.5869 30.0012 12.8998 32.3304 13.679L33.927 12.0825Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconRightArrow(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 18" fill="none">
        <path
          d="M1 16.84L7.52 10.32C8.29 9.55 8.29 8.29 7.52 7.52L1 1"
          stroke={col}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconLeftArrow(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 18" fill="none">
        <path
          d="M8.09765 0.999844L1.57765 7.51984C0.807655 8.28984 0.807655 9.54984 1.57766 10.3198L8.09766 16.8398"
          stroke={col}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconErasor(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46" fill="none">
        <path
          d="M15.4967 37.4244L5.41421 27.3419C4.63317 26.5609 4.63317 25.2946 5.41421 24.5135L10.898 19.0297M15.4967 37.4244L22.3947 30.5264M15.4967 37.4244L32.1819 37.4244M10.898 19.0297L22.5134 7.41433C23.2944 6.63329 24.5608 6.63329 25.3418 7.41433L34.0101 16.0826C34.7911 16.8637 34.7911 18.13 34.0101 18.911L22.3947 30.5264M10.898 19.0297L22.3947 30.5264"
          stroke={col}
          strokeWidth="3"
        />
      </svg>
    </>
  );
}
export function IconWhiteBoard(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
        <path
          d="M35.288 7.445C36.1879 6.56227 37.3978 6.0672 38.6584 6.06592C39.9189 6.06464 41.1298 6.55724 42.0315 7.43814C42.9332 8.31903 43.4539 9.51812 43.4821 10.7784C43.5102 12.0386 43.0435 13.2598 42.182 14.18L34.172 22.572C33.6661 23.1021 33.016 23.4723 32.302 23.637L26.532 24.968C26.333 25.014 26.1258 25.0105 25.9285 24.958C25.7312 24.9054 25.5498 24.8052 25.4001 24.6663C25.2504 24.5274 25.1371 24.3539 25.0699 24.1611C25.0028 23.9682 24.9839 23.7618 25.015 23.56L25.89 17.87C26.0112 17.0814 26.3808 16.3521 26.945 15.788L35.288 7.445ZM40.625 9.566C40.4345 9.28058 40.1831 9.04097 39.8889 8.86442C39.5947 8.68787 39.265 8.57878 38.9235 8.54502C38.582 8.51126 38.2373 8.55366 37.9142 8.66916C37.5911 8.78467 37.2977 8.97041 37.055 9.213L28.713 17.555C28.5248 17.743 28.4015 17.9861 28.361 18.249L27.766 22.118L31.74 21.201C31.9779 21.146 32.1945 21.0226 32.363 20.846L40.373 12.454C40.7367 12.0728 40.9598 11.5791 41.0056 11.0542C41.0514 10.5293 40.9172 10.0045 40.625 9.566ZM28.697 10.5H10.25C9.25544 10.5 8.30161 10.8951 7.59835 11.5983C6.89509 12.3016 6.5 13.2554 6.5 14.25V19.182C7.51 18.435 8.606 17.668 9.708 17.018C11.05 16.226 12.504 15.543 13.894 15.331C15.339 15.111 16.84 15.393 17.949 16.687C18.472 17.297 18.776 17.972 18.871 18.692C18.964 19.396 18.847 20.068 18.646 20.674C18.286 21.76 17.573 22.842 16.974 23.752L16.854 23.933C16.172 24.972 15.658 25.799 15.462 26.536C15.372 26.876 15.367 27.139 15.419 27.357C15.468 27.567 15.589 27.821 15.884 28.117C16.287 28.519 16.642 28.662 16.944 28.701C17.264 28.743 17.643 28.683 18.094 28.489C19.037 28.084 20.002 27.23 20.866 26.366C21.1005 26.1315 21.4184 25.9998 21.75 25.9998C22.0816 25.9998 22.3995 26.1315 22.634 26.366C22.8685 26.6005 23.0002 26.9184 23.0002 27.25C23.0002 27.5816 22.8685 27.8995 22.634 28.134C21.765 29.004 20.506 30.174 19.081 30.786C18.349 31.1 17.509 31.296 16.619 31.18C15.71 31.061 14.863 30.631 14.116 29.884C13.535 29.302 13.153 28.648 12.985 27.927C12.818 27.215 12.879 26.524 13.046 25.894C13.366 24.694 14.133 23.521 14.765 22.56L14.8 22.507C15.476 21.479 16.02 20.65 16.273 19.887C16.393 19.524 16.422 19.244 16.393 19.019C16.365 18.809 16.279 18.579 16.051 18.314C15.66 17.857 15.13 17.671 14.271 17.802C13.356 17.942 12.231 18.432 10.979 19.17C9.746 19.898 8.487 20.809 7.312 21.697C7.039 21.903 6.767 22.111 6.5 22.316V33.75C6.5 34.7446 6.89509 35.6984 7.59835 36.4016C8.30161 37.1049 9.25544 37.5 10.25 37.5H37.75C38.7446 37.5 39.6984 37.1049 40.4016 36.4016C41.1049 35.6984 41.5 34.7446 41.5 33.75V18.515L44 15.895V33.75C44 35.4076 43.3415 36.9973 42.1694 38.1694C40.9973 39.3415 39.4076 40 37.75 40H10.25C8.5924 40 7.00268 39.3415 5.83058 38.1694C4.65848 36.9973 4 35.4076 4 33.75V14.25C4 12.5924 4.65848 11.0027 5.83058 9.83058C7.00268 8.65848 8.5924 8 10.25 8H31.197L28.697 10.5Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconPen(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46" fill={col}>
        <path
          d="M22.1641 38.6426V40.9997H23.8307V38.6426"
          stroke="#194A75"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <path
          d="M8 8V17.4286H11.3333M38 8V17.4286H34.6667M11.3333 17.4286L20.5 33.9286H21.3333M11.3333 17.4286H34.6667M34.6667 17.4286L25.5 33.9286H24.6667M21.3333 33.9286V38.6429M21.3333 33.9286H24.6667M21.3333 38.6429H24.6667M21.3333 38.6429H22.1667H23.8333H24.6667M24.6667 38.6429V33.9286"
          stroke={col}
          strokeWidth="3"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconHighlighter(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46" fill="none">
        <path
          d="M10 7V18.55H11.625M36 7V18.55H34.375M11.625 18.55V24.325H16.5M11.625 18.55H34.375M34.375 18.55V24.325H29.5M16.5 24.325V40L29.5 32.575V24.325M16.5 24.325H29.5"
          stroke={col}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconShareCustom(props: { col?: string }) {
  const { col = "white" } = props || {};
  return (
    <>
      <svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.6667 15.5502C15.8222 15.5502 15.0667 15.8815 14.4889 16.4006L6.56667 11.8173C6.62222 11.5633 6.66667 11.3092 6.66667 11.0442C6.66667 10.7791 6.62222 10.5251 6.56667 10.2711L14.4 5.73193C15 6.28414 15.7889 6.62651 16.6667 6.62651C18.5111 6.62651 20 5.14659 20 3.31325C20 1.47992 18.5111 0 16.6667 0C14.8222 0 13.3333 1.47992 13.3333 3.31325C13.3333 3.57831 13.3778 3.83233 13.4333 4.08635L5.6 8.6255C5 8.07329 4.21111 7.73092 3.33333 7.73092C1.48889 7.73092 0 9.21084 0 11.0442C0 12.8775 1.48889 14.3574 3.33333 14.3574C4.21111 14.3574 5 14.0151 5.6 13.4629L13.5111 18.0572C13.4556 18.2892 13.4222 18.5321 13.4222 18.7751C13.4222 20.5532 14.8778 22 16.6667 22C18.4556 22 19.9111 20.5532 19.9111 18.7751C19.9111 16.997 18.4556 15.5502 16.6667 15.5502Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconCheck(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      // width="23"
      // height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="5"
        width="14"
        height="14"
        rx="1"
        stroke="#C7C7C7"
        strokeWidth="2"
      />
      <path
        d="M1 5.5C4.26373 6.95055 5.99323 10.5654 6.78461 13.2151C6.89132 13.5724 7.33333 13.7111 7.61512 13.4669L22 1"
        stroke="#24F225"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
export function IconText(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.663 0.32H30.795V8.633H29.469L27.99 3.278C27.888 2.87 27.769 2.581 27.633 2.411C27.531 2.207 27.31 2.088 26.97 2.054C26.63 1.986 26.052 1.952 25.236 1.952H19.473V30.869C19.473 32.059 19.524 32.756 19.626 32.96C19.728 33.164 20.051 33.3 20.595 33.368L23.4 33.674V35H11.109V33.674L13.914 33.368C14.458 33.3 14.781 33.164 14.883 32.96C14.985 32.756 15.036 32.059 15.036 30.869V1.952H9.222C8.44 1.952 7.862 1.986 7.488 2.054C7.148 2.088 6.91 2.207 6.774 2.411C6.672 2.581 6.57 2.87 6.468 3.278L4.989 8.633H3.663V0.32Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconUpload(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.375 35C3.17188 35 2.14157 34.5712 1.28407 33.7137C0.426566 32.8562 -0.00145462 31.8267 3.71392e-06 30.625V24.0625H4.375V30.625H30.625V24.0625H35V30.625C35 31.8281 34.5713 32.8584 33.7138 33.7159C32.8563 34.5734 31.8267 35.0015 30.625 35H4.375ZM15.3125 26.25V8.42187L9.625 14.1094L6.5625 10.9375L17.5 0L28.4375 10.9375L25.375 14.1094L19.6875 8.42187V26.25H15.3125Z"
          fill={col}
        />
      </svg>
    </>
  );
}

export function IconWorksheets(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 22V3C2 1.89543 2.89543 1 4 1H17"
          stroke={col}
          strokeLinejoin="round"
        />
        <path
          d="M7 27.5H23C24.1046 27.5 25 26.6046 25 25.5V12.3284C25 11.798 24.7893 11.2893 24.4142 10.9142L18.0858 4.58579C17.7107 4.21071 17.202 4 16.6716 4H7C5.89543 4 5 4.89543 5 6V25.5C5 26.6046 5.89543 27.5 7 27.5Z"
          stroke={col}
          strokeLinejoin="round"
        />
        <path
          d="M17.5 4V9.5C17.5 10.6046 18.3954 11.5 19.5 11.5H25"
          stroke={col}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconPYQS(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.31865 4.79787H15.0846M9.65908 8.59574H15.0846M9.65908 12.3936H17.7974M9.65908 16.1915H15.0846M9.65908 19.9894H17.7974M9.65908 23.7872H20.5101M24.2648 8.55251L17.2981 1.58579C16.923 1.21071 16.4143 1 15.8838 1H5.14844C4.04387 1 3.14844 1.89543 3.14844 3V24.5C3.14844 25.6046 4.04387 26.5 5.14844 26.5H22.8506C23.9551 26.5 24.8506 25.6046 24.8506 24.5V9.96672C24.8506 9.43629 24.6399 8.92758 24.2648 8.55251Z"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49053 11.3086H5.32031V13.4788H7.49053V11.3086Z"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49053 22.7021H5.32031V24.8724H7.49053V22.7021Z"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49053 18.9043H5.32031V21.0745H7.49053V18.9043Z"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49053 15.1064H5.32031V17.2767H7.49053V15.1064Z"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49053 7.51074H5.32031V9.68095H7.49053V7.51074Z"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.7109 1V7.1383C16.7109 8.24287 17.6064 9.1383 18.7109 9.1383H24.8492"
          stroke={col}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconTest(props: { col?: string; size?: string }) {
  const { col = "black" } = props || {};
  const { size = "32" } = props || {};

  return (
    <>
      <svg
        viewBox="0 0 28 28"
        fill="none"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.0924 2.19178H16.4875V2.16438C16.4875 1.69605 16.0989 1.31507 15.6212 1.31507H13.3576V1.28767C13.3576 0.577644 12.7685 0 12.0442 0H10.2558C9.53154 0 8.94236 0.577644 8.94236 1.28767V1.31507H6.67882C6.20113 1.31507 5.81253 1.69605 5.81253 2.16438V2.19178H2.20764C0.990366 2.19178 0 3.16274 0 4.35616V25.8356C0 27.029 0.990366 28 2.20764 28H20.0924C21.3096 28 22.3 27.029 22.3 25.8356V4.35616C22.3 3.16274 21.3096 2.19178 20.0924 2.19178ZM16.0682 4.76712H19.6452C19.6607 4.76712 19.6732 4.7794 19.6732 4.79452V25.3973C19.6732 25.4124 19.6607 25.4247 19.6452 25.4247H2.65476C2.63934 25.4247 2.62682 25.4124 2.62682 25.3973V4.79452C2.62682 4.7794 2.63934 4.76712 2.65476 4.76712H6.23176C6.23673 4.76712 6.24154 4.76658 6.24646 4.76641C6.64903 5.29836 7.29417 5.64384 8.02018 5.64384H14.2798C15.0058 5.64384 15.651 5.29836 16.0535 4.76641C16.0585 4.76658 16.0633 4.76712 16.0682 4.76712ZM9.7807 1.28767C9.7807 1.03085 9.99381 0.821918 10.2558 0.821918H12.0442C12.3062 0.821918 12.5193 1.03085 12.5193 1.28767V1.31507H9.7807V1.28767ZM6.65088 2.16438C6.65088 2.14926 6.6634 2.13699 6.67882 2.13699H15.6212C15.6366 2.13699 15.6491 2.14926 15.6491 2.16438V2.59956C15.6491 2.60066 15.649 2.6017 15.649 2.60274C15.649 2.60378 15.6491 2.60488 15.6491 2.60592V3.47945C15.6491 4.21967 15.0348 4.82192 14.2798 4.82192H8.02018C7.26516 4.82192 6.65088 4.21967 6.65088 3.47945V2.16438ZM21.4617 25.8356C21.4617 26.5758 20.8474 27.1781 20.0924 27.1781H2.20764C1.45263 27.1781 0.838346 26.5758 0.838346 25.8356V4.35616C0.838346 3.61595 1.45263 3.0137 2.20764 3.0137H5.81253V3.47945C5.81253 3.63934 5.83086 3.79507 5.86456 3.94521H2.65476C2.17707 3.94521 1.78847 4.32619 1.78847 4.79452V25.3973C1.78847 25.8656 2.17707 26.2466 2.65476 26.2466H19.6452C20.1229 26.2466 20.5115 25.8656 20.5115 25.3973V4.79452C20.5115 4.32619 20.1229 3.94521 19.6452 3.94521H16.4354C16.4692 3.79507 16.4875 3.63934 16.4875 3.47945V3.0137H20.0924C20.8474 3.0137 21.4617 3.61595 21.4617 4.35616V25.8356Z"
          fill={col}
        />
        <path
          d="M4.94381 11.7807H8.40898C8.67093 11.7807 8.88404 11.5717 8.88404 11.3149V7.91766C8.88404 7.66084 8.67093 7.4519 8.40898 7.4519H4.94381C4.68186 7.4519 4.46875 7.66084 4.46875 7.91766V11.3149C4.46875 11.5717 4.68186 11.7807 4.94381 11.7807ZM5.3071 8.27382H8.04569V10.9588H5.3071V8.27382Z"
          fill={col}
        />
        <path
          d="M8.40898 18.8491H4.94381C4.68186 18.8491 4.46875 19.0581 4.46875 19.3149V22.7121C4.46875 22.969 4.68186 23.1779 4.94381 23.1779H8.40898C8.67093 23.1779 8.88404 22.969 8.88404 22.7121V19.3149C8.88404 19.0581 8.67093 18.8491 8.40898 18.8491ZM8.04569 22.356H5.3071V19.671H8.04569V22.356Z"
          fill={col}
        />
        <path
          d="M9.06272 13.2713L8.76136 13.5667C8.61007 13.3182 8.3338 13.1509 8.01775 13.1509H5.33504C4.85735 13.1509 4.46875 13.5319 4.46875 14.0002V16.6303C4.46875 17.0987 4.85735 17.4796 5.33504 17.4796H8.01775C8.49544 17.4796 8.88404 17.0987 8.88404 16.6303V16.192C8.88404 15.965 8.69636 15.781 8.46486 15.781C8.23337 15.781 8.04569 15.965 8.04569 16.192V16.6303C8.04569 16.6455 8.03317 16.6577 8.01775 16.6577H5.33504C5.31962 16.6577 5.3071 16.6455 5.3071 16.6303V14.0002C5.3071 13.9851 5.31962 13.9728 5.33504 13.9728H8.01775C8.03317 13.9728 8.04569 13.9851 8.04569 14.0002V14.2684L7.12351 15.1725L6.52566 14.5863C6.36196 14.4258 6.09654 14.4258 5.93289 14.5863C5.76919 14.7468 5.76919 15.007 5.93289 15.1675L6.82713 16.0442C6.90895 16.1245 7.01626 16.1646 7.12351 16.1646C7.23076 16.1646 7.33807 16.1245 7.41989 16.0442L8.76119 14.7292L8.7613 14.7291L9.65548 13.8524C9.81918 13.6919 9.81918 13.4318 9.65548 13.2713C9.49184 13.1108 9.22636 13.1108 9.06272 13.2713Z"
          fill={col}
        />
        <path
          d="M10.2551 8.7123H11.5965C11.828 8.7123 12.0156 8.5283 12.0156 8.30134C12.0156 8.07438 11.828 7.89038 11.5965 7.89038H10.2551C10.0236 7.89038 9.83594 8.07438 9.83594 8.30134C9.83594 8.5283 10.0236 8.7123 10.2551 8.7123Z"
          fill={col}
        />
        <path
          d="M9.83594 10.055C9.83594 10.282 10.0236 10.466 10.2551 10.466H16.9619C17.1934 10.466 17.381 10.282 17.381 10.055C17.381 9.82804 17.1934 9.64404 16.9619 9.64404H10.2551C10.0236 9.64404 9.83594 9.82804 9.83594 10.055Z"
          fill={col}
        />
        <path
          d="M10.2551 14.8493H14.7263C14.9578 14.8493 15.1455 14.6653 15.1455 14.4383C15.1455 14.2113 14.9578 14.0273 14.7263 14.0273H10.2551C10.0236 14.0273 9.83594 14.2113 9.83594 14.4383C9.83594 14.6653 10.0236 14.8493 10.2551 14.8493Z"
          fill={col}
        />
        <path
          d="M16.9619 15.781H10.2551C10.0236 15.781 9.83594 15.965 9.83594 16.192C9.83594 16.4189 10.0236 16.6029 10.2551 16.6029H16.9619C17.1934 16.6029 17.381 16.4189 17.381 16.192C17.381 15.965 17.1934 15.781 16.9619 15.781Z"
          fill={col}
        />
        <path
          d="M10.2551 20.5482H12.0436C12.2751 20.5482 12.4628 20.3642 12.4628 20.1373C12.4628 19.9103 12.2751 19.7263 12.0436 19.7263H10.2551C10.0236 19.7263 9.83594 19.9103 9.83594 20.1373C9.83594 20.3642 10.0236 20.5482 10.2551 20.5482Z"
          fill={col}
        />
        <path
          d="M16.9619 21.4795H10.2551C10.0236 21.4795 9.83594 21.6635 9.83594 21.8905C9.83594 22.1174 10.0236 22.3014 10.2551 22.3014H16.9619C17.1934 22.3014 17.381 22.1174 17.381 21.8905C17.381 21.6635 17.1934 21.4795 16.9619 21.4795Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconQuestionBank(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.243 24.9961V24.9907M21.243 23.3868C21.243 20.9731 23.4959 21.5095 23.4959 19.6321C23.4959 18.4471 22.4872 17.4865 21.243 17.4865C20.2342 17.4865 19.3803 18.1179 19.0933 18.9884M28.0016 21.2413C28.0016 24.974 24.9757 27.9999 21.243 27.9999C17.5103 27.9999 14.4844 24.974 14.4844 21.2413C14.4844 17.5086 17.5103 14.4827 21.243 14.4827C24.9757 14.4827 28.0016 17.5086 28.0016 21.2413Z"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3995 2.1162H15.9189V2.08975C15.9189 1.63757 15.5437 1.26972 15.0825 1.26972H12.897V1.24327C12.897 0.557725 12.3282 0 11.6289 0H9.90212C9.20287 0 8.634 0.557725 8.634 1.24327V1.26972H6.44852C5.9873 1.26972 5.6121 1.63757 5.6121 2.08975V2.1162H2.13152C0.956215 2.1162 0 3.05368 0 4.20595V24.9447C0 26.097 0.956215 27.0345 2.13152 27.0345H15.1095L15.0825 26.2409H2.13152C1.40254 26.2409 0.809437 25.6594 0.809437 24.9447V4.20595C0.809437 3.49126 1.40254 2.90978 2.13152 2.90978H5.6121V3.35947C5.6121 3.51385 5.6298 3.6642 5.66234 3.80916H2.56322C2.102 3.80916 1.7268 4.17701 1.7268 4.62919V24.5215C1.7268 24.9737 2.102 25.3415 2.56322 25.3415H13.7874V24.5215H2.53624V4.62919C2.53624 4.61459 2.54832 4.60274 2.56322 4.60274H6.01687C6.02168 4.60274 6.02632 4.60221 6.03106 4.60205C6.41976 5.11565 7.04264 5.44922 7.74362 5.44922H13.7874C14.4884 5.44922 15.1113 5.11565 15.5 4.60205C15.5047 4.60221 15.5094 4.60274 15.5141 4.60274H18.9678C18.9827 4.60274 18.9948 4.61459 18.9948 4.62919V13.5172H19.8042V4.62919C19.8042 4.17701 19.429 3.80916 18.9678 3.80916H15.8687C15.9013 3.6642 15.9189 3.51385 15.9189 3.35947V2.90978H19.3995C20.1285 2.90978 20.7216 3.49126 20.7216 4.20595V13.5172H21.531V4.20595C21.531 3.05368 20.5748 2.1162 19.3995 2.1162ZM9.90212 0.793576C9.6492 0.793576 9.44344 0.995303 9.44344 1.24327V1.26972H12.0876V1.24327C12.0876 0.995303 11.8818 0.793576 11.6289 0.793576H9.90212ZM6.44852 2.0633C6.43362 2.0633 6.42154 2.07515 6.42154 2.08975V3.35947C6.42154 4.07417 7.01464 4.65564 7.74362 4.65564H13.7874C14.5164 4.65564 15.1095 4.07417 15.1095 3.35947V2.51606L15.1093 2.51299L15.1095 2.50992V2.08975C15.1095 2.07515 15.0974 2.0633 15.0825 2.0633H6.44852Z"
          fill={col}
        />
        <path
          d="M6.82013 12.8137L6.52916 13.099L5.83817 13.7765L4.94779 14.6494L4.37056 14.0835C4.2125 13.9285 3.95623 13.9285 3.79823 14.0835C3.64017 14.2384 3.64017 14.4896 3.79823 14.6446L4.66163 15.4911C4.74063 15.5686 4.84424 15.6073 4.94779 15.6073C5.05135 15.6073 5.15495 15.5686 5.23395 15.4911L6.529 14.2214L7.39245 13.3749C7.55051 13.2199 7.55051 12.9687 7.39245 12.8137C7.23445 12.6588 6.97813 12.6588 6.82013 12.8137Z"
          fill={col}
        />
        <path
          d="M6.82013 6.87478L6.52916 7.16004L5.83817 7.83749L4.94779 8.71042L4.37056 8.1445C4.2125 7.98954 3.95623 7.98954 3.79823 8.1445C3.64017 8.29946 3.64017 8.55065 3.79823 8.70561L4.66163 9.55209C4.74063 9.6296 4.84424 9.66832 4.94779 9.66832C5.05135 9.66832 5.15495 9.6296 5.23395 9.55209L6.529 8.28242L7.39245 7.43589C7.55051 7.28093 7.55051 7.02974 7.39245 6.87478C7.23445 6.71982 6.97813 6.71982 6.82013 6.87478Z"
          fill={col}
        />
        <path
          d="M6.82013 18.461L6.52916 18.7462L5.83817 19.4237L4.94779 20.2966L4.37056 19.7307C4.2125 19.5757 3.95623 19.5757 3.79823 19.7307C3.64017 19.8856 3.64017 20.1368 3.79823 20.2918L4.66163 21.1383C4.74063 21.2158 4.84424 21.2545 4.94779 21.2545C5.05135 21.2545 5.15495 21.2158 5.23395 21.1383L6.529 19.8686L7.39245 19.0221C7.55051 18.8671 7.55051 18.6159 7.39245 18.461C7.23445 18.306 6.97813 18.306 6.82013 18.461Z"
          fill={col}
        />
        <path
          d="M7.97112 8.41198H9.26622C9.48974 8.41198 9.67094 8.23433 9.67094 8.0152C9.67094 7.79606 9.48974 7.61841 9.26622 7.61841H7.97112C7.74761 7.61841 7.56641 7.79606 7.56641 8.0152C7.56641 8.23433 7.74761 8.41198 7.97112 8.41198Z"
          fill={col}
        />
        <path
          d="M7.56641 9.70831C7.56641 9.92744 7.74761 10.1051 7.97112 10.1051H14.4466C14.6701 10.1051 14.8513 9.92744 14.8513 9.70831C14.8513 9.48918 14.6701 9.31152 14.4466 9.31152H7.97112C7.74761 9.31152 7.56641 9.48918 7.56641 9.70831Z"
          fill={col}
        />
        <path
          d="M7.97112 14.3373H12.2881C12.5116 14.3373 12.6928 14.1596 12.6928 13.9405C12.6928 13.7214 12.5116 13.5437 12.2881 13.5437H7.97112C7.74761 13.5437 7.56641 13.7214 7.56641 13.9405C7.56641 14.1596 7.74761 14.3373 7.97112 14.3373Z"
          fill={col}
        />
        <path
          d="M14.4466 15.2368H7.97112C7.74761 15.2368 7.56641 15.4145 7.56641 15.6336C7.56641 15.8527 7.74761 16.0304 7.97112 16.0304H14.4466C14.6701 16.0304 14.8513 15.8527 14.8513 15.6336C14.8513 15.4145 14.6701 15.2368 14.4466 15.2368Z"
          fill={col}
        />
        <path
          d="M7.97112 19.8397H9.69792C9.92144 19.8397 10.1026 19.6621 10.1026 19.4429C10.1026 19.2238 9.92144 19.0461 9.69792 19.0461H7.97112C7.74761 19.0461 7.56641 19.2238 7.56641 19.4429C7.56641 19.6621 7.74761 19.8397 7.97112 19.8397Z"
          fill={col}
        />
        <path
          d="M14.4466 20.7388H7.97112C7.74761 20.7388 7.56641 20.9164 7.56641 21.1356C7.56641 21.3547 7.74761 21.5323 7.97112 21.5323H14.4466C14.6701 21.5323 14.8513 21.3547 14.8513 21.1356C14.8513 20.9164 14.6701 20.7388 14.4466 20.7388Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconAllSimulationsBlue() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M28.871 21.9929C28.9555 21.8625 29.0001 21.714 29 21.5627V8.4373C28.9998 8.28625 28.9551 8.13799 28.8706 8.00788C28.7861 7.87777 28.6648 7.77054 28.5193 7.69728L15.4527 1.10633C15.3142 1.03659 15.1584 1 15 1M28.871 21.9929C28.7865 22.1233 28.6651 22.2308 28.5193 22.3041L15.4527 28.8937C15.3142 28.9634 15.1584 29 15 29C14.8416 29 14.6858 28.9634 14.5473 28.8937L1.48067 22.3041C1.33494 22.2308 1.2135 22.1233 1.12898 21.9929M28.871 21.9929L15 15.1225M1.12898 21.9929C1.04445 21.8625 0.999919 21.714 1 21.5627V8.4373C1.0002 8.28625 1.04486 8.13799 1.12937 8.00788C1.21389 7.87777 1.33517 7.77054 1.48067 7.69728L8.014 4.4018L14.5473 1.10633C14.6858 1.03659 14.8416 1 15 1M1.12898 21.9929L15 15.1225M15 1V15.1225"
          stroke="#3174F3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.088 20.6577C18.2129 20.6577 20.7462 18.3309 20.7462 15.4607C20.7462 12.5905 18.2129 10.2637 15.088 10.2637C11.963 10.2637 9.42969 12.5905 9.42969 15.4607C9.42969 18.3309 11.963 20.6577 15.088 20.6577Z"
          fill="#3174F3"
        />
        <path
          d="M15.0793 22.0843C19.0624 22.0843 22.2913 19.1186 22.2913 15.4601C22.2913 11.8017 19.0624 8.83594 15.0793 8.83594C11.0961 8.83594 7.86719 11.8017 7.86719 15.4601C7.86719 19.1186 11.0961 22.0843 15.0793 22.0843Z"
          stroke="#3174F3"
          strokeMiterlimit="10"
        />
        <path
          d="M15.0865 23.9212C20.1738 23.9212 24.2979 20.1332 24.2979 15.4606C24.2979 10.7879 20.1738 7 15.0865 7C9.99911 7 5.875 10.7879 5.875 15.4606C5.875 20.1332 9.99911 23.9212 15.0865 23.9212Z"
          stroke="#3174F3"
          strokeMiterlimit="10"
          strokeDasharray="5 2.31"
        />
        <g opacity="0.3">
          <path
            d="M18.4776 11.2998C18.6147 12.9027 18.2376 14.9254 16.144 16.5309C14.2389 18.0001 12.0452 18.2677 10.2344 18.1207C10.6625 18.7802 11.2444 19.3442 11.9383 19.7724C12.6321 20.2005 13.4207 20.482 14.2472 20.5967C15.0737 20.7113 15.9177 20.6563 16.7182 20.4355C17.5188 20.2147 18.2562 19.8336 18.8772 19.3197C19.4982 18.8059 19.9875 18.1719 20.3098 17.4635C20.6322 16.7552 20.7795 15.99 20.7413 15.223C20.7031 14.4561 20.4803 13.7064 20.0888 13.0281C19.6974 12.3497 19.1471 11.7594 18.4776 11.2998Z"
            fill="white"
          />
        </g>
        <path
          d="M20.341 13.54C23.2316 13.9467 25.1624 14.6786 25.1624 15.5155C25.1624 16.7931 20.6495 17.8294 15.0826 17.8294C9.51576 17.8294 5 16.78 5 15.5155C5 14.6786 6.93084 13.9414 9.82138 13.54"
          stroke="#3174F3"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeDasharray="5 2.31"
        />
        <path
          d="M14.1016 16.0479L15.9096 17.8502L14.1016 19.4872"
          stroke="#3174F3"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
      </svg>
    </>
  );
}
export function IconAllSimulationsGrey() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M28.871 21.9929C28.9555 21.8625 29.0001 21.714 29 21.5627V8.4373C28.9998 8.28625 28.9551 8.13799 28.8706 8.00788C28.7861 7.87777 28.6648 7.77054 28.5193 7.69728L15.4527 1.10633C15.3142 1.03659 15.1584 1 15 1M28.871 21.9929C28.7865 22.1233 28.6651 22.2308 28.5193 22.3041L15.4527 28.8937C15.3142 28.9634 15.1584 29 15 29C14.8416 29 14.6858 28.9634 14.5473 28.8937L1.48067 22.3041C1.33494 22.2308 1.2135 22.1233 1.12898 21.9929M28.871 21.9929L15 15.1225M1.12898 21.9929C1.04445 21.8625 0.999919 21.714 1 21.5627V8.4373C1.0002 8.28625 1.04486 8.13799 1.12937 8.00788C1.21389 7.87777 1.33517 7.77054 1.48067 7.69728L8.014 4.4018L14.5473 1.10633C14.6858 1.03659 14.8416 1 15 1M1.12898 21.9929L15 15.1225M15 1V15.1225"
          stroke="#282929"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.088 20.6577C18.2129 20.6577 20.7462 18.3309 20.7462 15.4607C20.7462 12.5905 18.2129 10.2637 15.088 10.2637C11.963 10.2637 9.42969 12.5905 9.42969 15.4607C9.42969 18.3309 11.963 20.6577 15.088 20.6577Z"
          fill="#282929"
        />
        <path
          d="M15.0793 22.0843C19.0624 22.0843 22.2913 19.1186 22.2913 15.4601C22.2913 11.8017 19.0624 8.83594 15.0793 8.83594C11.0961 8.83594 7.86719 11.8017 7.86719 15.4601C7.86719 19.1186 11.0961 22.0843 15.0793 22.0843Z"
          stroke="#282929"
          strokeMiterlimit="10"
        />
        <path
          d="M15.0865 23.9212C20.1738 23.9212 24.2979 20.1332 24.2979 15.4606C24.2979 10.7879 20.1738 7 15.0865 7C9.99911 7 5.875 10.7879 5.875 15.4606C5.875 20.1332 9.99911 23.9212 15.0865 23.9212Z"
          stroke="#282929"
          strokeMiterlimit="10"
          strokeDasharray="5 2.31"
        />
        <g opacity="0.3">
          <path
            d="M18.4776 11.2998C18.6147 12.9027 18.2376 14.9254 16.144 16.5309C14.2389 18.0001 12.0452 18.2677 10.2344 18.1207C10.6625 18.7802 11.2444 19.3442 11.9383 19.7724C12.6321 20.2005 13.4207 20.482 14.2472 20.5967C15.0737 20.7113 15.9177 20.6563 16.7182 20.4355C17.5188 20.2147 18.2562 19.8336 18.8772 19.3197C19.4982 18.8059 19.9875 18.1719 20.3098 17.4635C20.6322 16.7552 20.7795 15.99 20.7413 15.223C20.7031 14.4561 20.4803 13.7064 20.0888 13.0281C19.6974 12.3497 19.1471 11.7594 18.4776 11.2998Z"
            fill="white"
          />
        </g>
        <path
          d="M20.341 13.54C23.2316 13.9467 25.1624 14.6786 25.1624 15.5155C25.1624 16.7931 20.6495 17.8294 15.0826 17.8294C9.51576 17.8294 5 16.78 5 15.5155C5 14.6786 6.93084 13.9414 9.82138 13.54"
          stroke="#7E8184"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          strokeDasharray="5 2.31"
        />
        <path
          d="M14.1016 16.0479L15.9096 17.8502L14.1016 19.4872"
          stroke="#7E8184"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
      </svg>
    </>
  );
}
export function IconTopicHeading(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 29 29"
        fill="none"
      >
        <path
          d="M21.5578 9.05225V2C21.5578 1.44772 21.11 1 20.5578 1H2C1.44772 1 1 1.44772 1 2V27.0466C1 27.5989 1.44772 28.0466 2 28.0466H12.165M4.07185 9.64144H11.3379M4.07185 14.0463H11.3379M4.07185 18.6476H11.3379"
          stroke={col}
        />
        <path
          d="M25.9035 14.3266C25.9035 16.5833 23.9699 18.456 21.5299 18.456C19.0898 18.456 17.1562 16.5833 17.1562 14.3266C17.1562 12.07 19.0898 10.1973 21.5299 10.1973C23.9699 10.1973 25.9035 12.07 25.9035 14.3266Z"
          stroke={col}
        />
        <path
          d="M22.6172 12.0547C24.7439 12.5036 24.5272 14.5985 24.1531 15.5898"
          stroke={col}
          strokeWidth="0.5"
          strokeDasharray="1 1"
        />
        <path
          d="M14.6094 26.573C14.6094 23.7578 16.8915 21.4756 19.7067 21.4756H23.3987C26.2139 21.4756 28.496 23.7578 28.496 26.573C28.496 27.6371 27.6334 28.4998 26.5692 28.4998H16.5362C15.472 28.4998 14.6094 27.6371 14.6094 26.573Z"
          stroke={col}
        />
      </svg>
    </>
  );
}
export function IconTopics(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="18"
        viewBox="0 0 16 20"
        fill="none"
      >
        <rect
          x="1"
          y="1"
          width="14"
          height="18"
          rx="3"
          stroke={col}
          strokeWidth="1.5"
        />
        <path
          d="M4 5.5H12"
          stroke={col}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M4 13H10"
          stroke={col}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M4 9H12"
          stroke={col}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
}
export function IconSyllabus(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="27" height="27" rx="3.5" stroke={col} />
        <path
          d="M10.5 5.25H17.5M5.25 8.75H10.5M5.25 12.25H11.375M5.25 15.75H15.75M5.25 19.25H13.125M5.25 22.75H12.25"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconSummary(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.1111 1V7.22222C18.1111 7.63478 18.275 8.03044 18.5667 8.32217C18.8584 8.61389 19.2541 8.77778 19.6667 8.77778H25.8889M18.1111 1H7.22222C6.3971 1 5.60578 1.32778 5.02233 1.91122C4.43889 2.49467 4.11111 3.28599 4.11111 4.11111V11.8889M18.1111 1L25.8889 8.77778M25.8889 8.77778V11.8889M25.8889 24.3333V25.8889C25.8889 26.714 25.5611 27.5053 24.9777 28.0888C24.3942 28.6722 23.6029 29 22.7778 29H7.22222C6.3971 29 5.60578 28.6722 5.02233 28.0888C4.43889 27.5053 4.11111 26.714 4.11111 25.8889V24.3333M1 18.1111H5.66667M12.6667 18.1111H17.3333M24.3333 18.1111H29"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconNotes(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 28 28"
        fill="none"
      >
        <path
          d="M19.0909 8.90909H26.0909L19.0909 1.90909V8.90909ZM7.63636 0H20.3636L28 7.63636V20.3636C28 21.0387 27.7318 21.6862 27.2545 22.1635C26.7771 22.6409 26.1296 22.9091 25.4545 22.9091H7.63636C6.96127 22.9091 6.31382 22.6409 5.83646 22.1635C5.35909 21.6862 5.09091 21.0387 5.09091 20.3636V2.54545C5.09091 1.87036 5.35909 1.22291 5.83646 0.745546C6.31382 0.268181 6.96127 0 7.63636 0ZM2.54545 5.09091V25.4545H25.4545V28H2.54545C1.87036 28 1.22291 27.7318 0.745546 27.2545C0.268181 26.7771 0 26.1296 0 25.4545V5.09091H2.54545Z"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconDelete(props: { col?: string }) {
  const { col = "black" } = props || {};

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 28 28"
      >
        <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z" />
      </svg>
    </>
  );
}
export function IconMindMap(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 29 28"
        fill="none"
      >
        <path
          d="M17.6035 14.4374C17.6035 15.2943 17.2817 16.069 16.7631 16.6249C16.2581 17.1661 15.5664 17.4999 14.8035 17.4999C14.0405 17.4999 13.3488 17.1661 12.8438 16.6249C12.3252 16.069 12.0034 15.2943 12.0034 14.4374C12.0034 13.5805 12.3252 12.8058 12.8438 12.2499C13.3488 11.7087 14.0405 11.3749 14.8035 11.3749C15.5664 11.3749 16.2581 11.7087 16.7631 12.2499C17.2817 12.8058 17.6035 13.5805 17.6035 14.4374Z"
          fill={col}
        />
        <path
          d="M17.6035 14.4374H25.2038M17.6035 14.4374C17.6035 13.5805 17.2817 12.8058 16.7631 12.2499M17.6035 14.4374C17.6035 15.2943 17.2817 16.069 16.7631 16.6249M14.8035 17.4999V25.3748M14.8035 17.4999C14.0405 17.4999 13.3488 17.1661 12.8438 16.6249M14.8035 17.4999C15.5664 17.4999 16.2581 17.1661 16.7631 16.6249M12.0034 14.4374H3.20312M12.0034 14.4374C12.0034 15.2943 12.3252 16.069 12.8438 16.6249M12.0034 14.4374C12.0034 13.5805 12.3252 12.8058 12.8438 12.2499M14.8035 11.3749V2.625M14.8035 11.3749C15.5664 11.3749 16.2581 11.7087 16.7631 12.2499M14.8035 11.3749C14.0405 11.3749 13.3488 11.7087 12.8438 12.2499M16.7631 12.2499L25.2038 2.625M12.8438 16.6249L3.20312 25.3748M16.7631 16.6249L25.2038 25.3748M12.8438 12.2499L3.20312 2.625"
          stroke={col}
          strokeWidth="1.25"
        />
        <ellipse
          cx="3.19694"
          cy="2.62498"
          rx="2.40007"
          ry="2.62498"
          fill={col}
        />
        <ellipse
          cx="24.8063"
          cy="25.375"
          rx="2.40007"
          ry="2.62498"
          fill={col}
        />
        <ellipse cx="25.6032" cy="14" rx="2.40007" ry="2.62498" fill={col} />
        <ellipse
          cx="15.1969"
          cy="25.375"
          rx="2.40007"
          ry="2.62498"
          fill={col}
        />
        <ellipse
          cx="2.40007"
          cy="25.375"
          rx="2.40007"
          ry="2.62498"
          fill={col}
        />
        <ellipse cx="3.19694" cy="14" rx="2.40007" ry="2.62498" fill={col} />
        <ellipse
          cx="25.6032"
          cy="2.62498"
          rx="2.40007"
          ry="2.62498"
          fill={col}
        />
        <ellipse
          cx="14.4001"
          cy="2.62498"
          rx="2.40007"
          ry="2.62498"
          fill={col}
        />
      </svg>
    </>
  );
}
export function IconLessonPlan(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M9.61467 27.3529H4.73333C3.74319 27.3529 2.7936 27.0059 2.09347 26.3881C1.39333 25.7703 1 24.9325 1 24.0588V4.29412C1 3.42046 1.39333 2.58259 2.09347 1.96482C2.7936 1.34706 3.74319 1 4.73333 1H19.6667C20.6568 1 21.6064 1.34706 22.3065 1.96482C23.0067 2.58259 23.4 3.42046 23.4 4.29412V17.4706M17.8 25.7059L21.5333 29L29 22.4118M8.46667 7.58824H15.9333M8.46667 14.1765H12.2"
          stroke={col}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function IconIntroduction(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 28 28"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="27" height="27" rx="3.5" stroke={col} />
      <path
        d="M5.25 5.25H12.25M5.25 8.75H22.75M5.25 11.4333H22.75M5.25 14.1167H14.875"
        stroke={col}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconTeachNavbarSearch(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M21 21L15 15M3 10C3 10.9193 3.18106 11.8295 3.53284 12.6788C3.88463 13.5281 4.40024 14.2997 5.05025 14.9497C5.70026 15.5998 6.47194 16.1154 7.32122 16.4672C8.1705 16.8189 9.08075 17 10 17C10.9193 17 11.8295 16.8189 12.6788 16.4672C13.5281 16.1154 14.2997 15.5998 14.9497 14.9497C15.5998 14.2997 16.1154 13.5281 16.4672 12.6788C16.8189 11.8295 17 10.9193 17 10C17 9.08075 16.8189 8.1705 16.4672 7.32122C16.1154 6.47194 15.5998 5.70026 14.9497 5.05025C14.2997 4.40024 13.5281 3.88463 12.6788 3.53284C11.8295 3.18106 10.9193 3 10 3C9.08075 3 8.1705 3.18106 7.32122 3.53284C6.47194 3.88463 5.70026 4.40024 5.05025 5.05025C4.40024 5.70026 3.88463 6.47194 3.53284 7.32122C3.18106 8.1705 3 9.08075 3 10Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export function IconTeachNavbarDownload(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M12 17L5.75 10.75L7.5 8.9375L10.75 12.1875V2H13.25V12.1875L16.5 8.9375L18.25 10.75L12 17ZM4.5 22C3.8125 22 3.22417 21.7554 2.735 21.2662C2.24583 20.7771 2.00083 20.1883 2 19.5V15.75H4.5V19.5H19.5V15.75H22V19.5C22 20.1875 21.7554 20.7762 21.2663 21.2662C20.7771 21.7562 20.1883 22.0008 19.5 22H4.5Z"
          fill="black"
        />
      </g>
    </svg>
  );
}
export function IconTeachNavbarShare(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z"
          fill="black"
        />
      </g>
    </svg>
  );
}
export function IconTeachAddContent(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7C14 7.27887 13.8892 7.54631 13.692 7.7435C13.4948 7.94069 13.2274 8.05147 12.9485 8.05147L8.05147 8.05147L8.05147 12.9485C8.05147 13.2274 7.94069 13.4948 7.7435 13.692C7.54631 13.8892 7.27887 14 7 14C6.72113 14 6.45369 13.8892 6.2565 13.692C6.05931 13.4948 5.94853 13.2274 5.94853 12.9485L5.94853 8.05147L1.05147 8.05147C0.772604 8.05147 0.505157 7.94069 0.307968 7.7435C0.110778 7.54631 -3.66094e-07 7.27887 -3.41715e-07 7C-3.17336e-07 6.72113 0.110779 6.45369 0.307968 6.2565C0.505157 6.05931 0.772604 5.94853 1.05147 5.94853L5.94853 5.94853L5.94853 1.05147C5.94853 0.772604 6.05931 0.505158 6.2565 0.307968C6.45369 0.110779 6.72113 3.17335e-07 7 3.41715e-07C7.27887 3.66094e-07 7.54631 0.110779 7.7435 0.307969C7.94069 0.505158 8.05147 0.772604 8.05147 1.05147L8.05147 5.94853L12.9485 5.94853C13.2274 5.94853 13.4948 6.05931 13.692 6.2565C13.8892 6.45369 14 6.72113 14 7Z"
        fill="black"
      />
    </svg>
  );
}

export function IconTeachPC(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="72" height="72" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_7272_16235" transform="scale(0.0078125)" />
        </pattern>
        <image
          id="image0_7272_16235"
          width="128"
          height="128"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}

export function IconDeleteContent(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 18C2.45 18 1.97933 17.8043 1.588 17.413C1.19667 17.0217 1.00067 16.5507 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.021 14.413 17.413C14.0217 17.805 13.5507 18.0007 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
        fill="#808080"
      />
    </svg>
  );
}
export function IconShowVideo(props: { col?: string }) {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <circle
        opacity="0.3"
        cx="22.6965"
        cy="22.2316"
        r="13.0129"
        fill="#905FBE"
      />
      <rect
        x="11.7383"
        y="11.2734"
        width="21.9164"
        height="21.9164"
        fill="url(#pattern0)"
      />
      <circle
        opacity="0.3"
        cx="22.6964"
        cy="22.2316"
        r="17.1222"
        stroke="#905FBE"
        strokeWidth="2"
      />
      <circle
        opacity="0.3"
        cx="22.6964"
        cy="22.2315"
        r="21.2315"
        stroke="#905FBE"
        strokeWidth="2"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_7340_33221" transform="scale(0.0078125)" />
        </pattern>
        <image
          id="image0_7340_33221"
          width="128"
          height="128"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}
export function IconEditContent(props: { col?: string }) {
  const { col = "black" } = props || {};
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 4.20996H9.83333C5.66667 4.20996 4 5.87663 4 10.0433V15.0433C4 19.21 5.66667 20.8766 9.83333 20.8766H14.8333C19 20.8766 20.6667 19.21 20.6667 15.0433V13.3766"
        stroke="#808080"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6996 5.05936L9.13291 11.626C8.88291 11.876 8.63291 12.3677 8.58291 12.726L8.22457 15.2344C8.09124 16.1427 8.73291 16.776 9.64124 16.651L12.1496 16.2927C12.4996 16.2427 12.9912 15.9927 13.2496 15.7427L19.8162 9.17602C20.9496 8.04269 21.4829 6.72602 19.8162 5.05936C18.1496 3.39269 16.8329 3.92602 15.6996 5.05936Z"
        stroke="#808080"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7578 6.00098C15.3161 7.99264 16.8745 9.55098 18.8745 10.1176"
        stroke="#808080"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function IconToggleWhiteboard(props: { showWhiteBoard: boolean }) {
  return (
    <svg
      width="69"
      height="81"
      viewBox="0 0 69 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_8_1070)">
        <rect
          x="22.3125"
          y="18.6411"
          width="158.502"
          height="36.3588"
          rx="4"
          fill={props?.showWhiteBoard ? "gray" : "#4B65F6"}
        />
        <path
          d="M52.5858 27.9836C53.097 27.4821 53.7844 27.2009 54.5005 27.2002C55.2166 27.1994 55.9046 27.4793 56.4168 27.9797C56.9291 28.4802 57.2249 29.1614 57.2409 29.8773C57.2568 30.5933 56.9917 31.287 56.5023 31.8098L51.9518 36.5774C51.6644 36.8785 51.295 37.0889 50.8894 37.1824L47.6114 37.9386C47.4984 37.9647 47.3807 37.9627 47.2686 37.9328C47.1565 37.903 47.0534 37.8461 46.9684 37.7672C46.8834 37.6882 46.819 37.5897 46.7808 37.4801C46.7427 37.3706 46.732 37.2533 46.7496 37.1387L47.2467 33.9061C47.3156 33.4582 47.5255 33.0438 47.8461 32.7233L52.5858 27.9836ZM55.6177 29.1886C55.5095 29.0264 55.3667 28.8903 55.1996 28.79C55.0324 28.6897 54.8451 28.6277 54.6511 28.6086C54.4571 28.5894 54.2613 28.6135 54.0777 28.6791C53.8942 28.7447 53.7275 28.8502 53.5896 28.988L48.8505 33.7272C48.7436 33.834 48.6735 33.9721 48.6505 34.1215L48.3125 36.3195L50.5701 35.7985C50.7053 35.7673 50.8283 35.6972 50.924 35.5968L55.4746 30.8293C55.6812 30.6127 55.808 30.3322 55.834 30.034C55.86 29.7358 55.7837 29.4377 55.6177 29.1886ZM48.8414 29.7192H38.3615C37.7965 29.7192 37.2546 29.9436 36.8551 30.3432C36.4556 30.7427 36.2311 31.2846 36.2311 31.8496V34.6515C36.8049 34.2271 37.4275 33.7914 38.0536 33.4221C38.816 32.9722 39.642 32.5842 40.4317 32.4637C41.2526 32.3387 42.1053 32.4989 42.7354 33.2341C43.0325 33.5806 43.2052 33.9641 43.2592 34.3731C43.312 34.7731 43.2455 35.1548 43.1313 35.4991C42.9268 36.1161 42.5218 36.7308 42.1815 37.2477L42.1133 37.3506C41.7258 37.9408 41.4338 38.4107 41.3225 38.8293C41.2714 39.0225 41.2685 39.1719 41.2981 39.2958C41.3259 39.4151 41.3946 39.5594 41.5622 39.7275C41.7912 39.9559 41.9929 40.0371 42.1644 40.0593C42.3462 40.0832 42.5615 40.0491 42.8177 39.9389C43.3535 39.7088 43.9017 39.2236 44.3925 38.7328C44.5257 38.5996 44.7064 38.5247 44.8947 38.5247C45.0831 38.5247 45.2638 38.5996 45.3969 38.7328C45.5301 38.866 45.605 39.0466 45.605 39.235C45.605 39.4233 45.5301 39.604 45.3969 39.7372C44.9033 40.2314 44.188 40.8961 43.3785 41.2438C42.9626 41.4222 42.4854 41.5335 41.9798 41.4676C41.4634 41.4 40.9822 41.1557 40.5578 40.7314C40.2277 40.4007 40.0107 40.0292 39.9153 39.6196C39.8204 39.2151 39.8551 38.8225 39.9499 38.4646C40.1317 37.7829 40.5675 37.1165 40.9265 36.5706L40.9464 36.5404C41.3304 35.9564 41.6395 35.4855 41.7832 35.052C41.8514 34.8458 41.8679 34.6867 41.8514 34.5589C41.8355 34.4396 41.7866 34.3089 41.6571 34.1584C41.435 33.8988 41.1339 33.7931 40.6459 33.8675C40.1261 33.947 39.4869 34.2254 38.7757 34.6447C38.0752 35.0583 37.3599 35.5758 36.6924 36.0803C36.5373 36.1973 36.3828 36.3155 36.2311 36.4319V42.9277C36.2311 43.4927 36.4556 44.0346 36.8551 44.4341C37.2546 44.8336 37.7965 45.0581 38.3615 45.0581H53.9844C54.5495 45.0581 55.0913 44.8336 55.4909 44.4341C55.8904 44.0346 56.1148 43.4927 56.1148 42.9277V34.2726L57.5351 32.7841V42.9277C57.5351 43.8694 57.161 44.7725 56.4951 45.4384C55.8293 46.1042 54.9261 46.4783 53.9844 46.4783H38.3615C37.4198 46.4783 36.5167 46.1042 35.8508 45.4384C35.1849 44.7725 34.8109 43.8694 34.8109 42.9277V31.8496C34.8109 30.9079 35.1849 30.0048 35.8508 29.3389C36.5167 28.673 37.4198 28.2989 38.3615 28.2989H50.2616L48.8414 29.7192Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_8_1070"
          x="0.3125"
          y="0.641113"
          width="202.502"
          height="80.3588"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="11" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8_1070"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8_1070"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function IconEmptyContent() {
  return (
    <svg
      width="111"
      height="110"
      viewBox="0 0 111 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="55.5" cy="55" r="55" fill="#F7F7FF" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.8121 32.333H72.1931C73.9107 32.333 75.5579 33.0153 76.7724 34.2298C77.987 35.4444 78.6693 37.0916 78.6693 38.8092V71.1901C78.6693 72.9077 77.987 74.555 76.7724 75.7695C75.5579 76.984 73.9107 77.6663 72.1931 77.6663H39.8121C38.0945 77.6663 36.4473 76.984 35.2328 75.7695C34.0182 74.555 33.3359 72.9077 33.3359 71.1901V38.8092C33.3359 37.0916 34.0182 35.4444 35.2328 34.2298C36.4473 33.0153 38.0945 32.333 39.8121 32.333Z"
        stroke="black"
        strokeWidth="3.2381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M39.8121 38.8092H72.1931C73.9107 38.8092 75.5579 39.4915 76.7724 40.706C77.987 41.9206 78.6693 43.5678 78.6693 45.2854V38.8092C78.6693 35.5711 75.7712 32.333 72.1931 32.333H39.8121C36.234 32.333 33.3359 35.5711 33.3359 38.8092V45.2854C33.3359 43.5678 34.0182 41.9206 35.2328 40.706C36.4473 39.4915 38.0945 38.8092 39.8121 38.8092Z"
        fill="black"
        stroke="black"
        strokeWidth="3.2381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.2773 54.9996H49.5154M46.2773 48.5234H59.22M46.2773 61.4758H65.6962M46.2773 67.952H59.22"
        stroke="black"
        strokeWidth="3.2381"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const IconAddSimulationCross = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.17969 14.6318L14.4444 5.36714"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M14.4453 14.6328L5.18061 5.36811"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const IconThreeDots = () => {
  return (
    <svg
      width="3"
      height="14"
      viewBox="0 0 3 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 0.25C0.675 0.25 0 0.925 0 1.75C0 2.575 0.675 3.25 1.5 3.25C2.325 3.25 3 2.575 3 1.75C3 0.925 2.325 0.25 1.5 0.25ZM1.5 10.75C0.675 10.75 0 11.425 0 12.25C0 13.075 0.675 13.75 1.5 13.75C2.325 13.75 3 13.075 3 12.25C3 11.425 2.325 10.75 1.5 10.75ZM1.5 5.5C0.675 5.5 0 6.175 0 7C0 7.825 0.675 8.5 1.5 8.5C2.325 8.5 3 7.825 3 7C3 6.175 2.325 5.5 1.5 5.5Z"
        fill="#212121"
      />
    </svg>
  );
};
